export default {
  "siteTitle": {
    "ja": "Towa Song Database",
    "en": "Towa Song Database",
    "kr": "토와 송 데이터베이스"
  },
  "updatedAt": "2026-11-02T15:16:28.892005065Z",
  "singers": [
    {
      "id": "tokoyamitowa",
      "ja": "常闇トワ",
      "en": "Tokoyami Towa",
      "kr": "토코야미 토와",
      "channelUrl": "https://www.youtube.com/channel/UC1uv2Oq6kNxgATlCiez59hw",
      "color": "#cabaff"
    },
    {
      "id": "hoshimachisuisei",
      "ja": "星街すいせい",
      "en": "Hoshimachi Suisei",
      "kr": "호시마치 스이세이",
      "channelUrl": "https://www.youtube.com/channel/UC5CwaMl1eIgY8h02uZw7u8A",
      "color": "#50e5f9"
    },
    {
      "id": "minatoaqua",
      "ja": "湊あくあ",
      "en": "Minato Aqua",
      "kr": "미나토 아쿠아",
      "channelUrl": "https://www.youtube.com/channel/UC1opHUrw8rvnsadT-iGp7Cg",
      "color": "#ffa6ea"
    },
    {
      "id": "azki",
      "ja": "AZKi",
      "en": "AZKi",
      "kr": "AZKi",
      "channelUrl": "https://www.youtube.com/@AZKi",
      "color": "#f789ba"
    },
    {
      "id": "sakuramiko",
      "ja": "さくらみこ",
      "en": "Sakura Miko",
      "kr": "사쿠라 미코",
      "channelUrl": "https://www.youtube.com/@SakuraMiko",
      "color": "#FF8FDF"
    },
    {
      "id": "akirose",
      "ja": "アキ・ローゼンタール",
      "en": "Aki Rosenthal",
      "kr": "아키 로젠탈",
      "channelUrl": "https://www.youtube.com/@AkiRosenthal",
      "color": "#f571ba"
    },
    {
      "id": "omarupolka",
      "ja": "尾丸ポルカ",
      "en": "Omaru Polka",
      "kr": "오마루 폴카",
      "channelUrl": "https://www.youtube.com/@OmaruPolka",
      "color": "#fa868c"
    },
    {
      "id": "kazamairoha",
      "ja": "風真いろは",
      "en": "Kazama Iroha",
      "kr": "카자마 이로하",
      "channelUrl": "https://www.youtube.com/@kazamairoha",
      "color": "#93dcd8"
    },
    {
      "id": "nekomataokayu",
      "ja": "猫又おかゆ",
      "en": "Nekomata Okayu",
      "kr": "네코마타 오카유",
      "channelUrl": "https://www.youtube.com/@nekomataokayu",
      "color": "#b99bff"
    },
    {
      "id": "momosuzunene",
      "ja": "桃鈴ねね",
      "en": "Momosuzu Nene",
      "kr": "모모스즈 네네",
      "channelUrl": "https://www.youtube.com/@MomosuzuNene",
      "color": "#ffbe6e"
    },
    {
      "id": "robocosan",
      "ja": "ロボ子さん",
      "en": "Roboco-san",
      "kr": "로보코 씨",
      "channelUrl": "https://www.youtube.com/@robocosan",
      "color": "#f5a2e0"
    },
    {
      "id": "yozoramel",
      "ja": "夜空メル",
      "en": "Yozora Mel",
      "kr": "요조라 멜",
      "channelUrl": "https://www.youtube.com/@yozoramel",
      "color": "#eedf8a"
    },
    {
      "id": "takanelui",
      "ja": "鷹嶺ルイ",
      "en": "Takane Lui",
      "kr": "타카네 루이",
      "channelUrl": "https://www.youtube.com/@TakaneLui",
      "color": "#e68dbc"
    },
    {
      "id": "sakamatachloe",
      "ja": "沙花叉クロヱ",
      "en": "Sakamata Chloe",
      "kr": "사카마타 클로에",
      "channelUrl": "https://www.youtube.com/@sakamatachloe",
      "color": "#ee8583"
    },
    {
      "id": "hakosbaelz",
      "ja": "Hakos Baelz",
      "en": "Hakos Baelz",
      "kr": "Hakos Baelz",
      "channelUrl": "https://www.youtube.com/@hakosbaelz",
      "color": "#fd9c96"
    },
    {
      "id": "kureijiollie",
      "ja": "Kureiji Ollie",
      "en": "Kureiji Ollie",
      "kr": "Kureiji Ollie",
      "channelUrl": "https://www.youtube.com/@KureijiOllie",
      "color": "#fa8cb2"
    },
    {
      "id": "pavoliareine",
      "ja": "Pavolia Reine",
      "en": "Pavolia Reine",
      "kr": "Pavolia Reine",
      "channelUrl": "https://www.youtube.com/@PavoliaReine",
      "color": "#77a7f0"
    },
    {
      "id": "anyamelfissa",
      "ja": "Anya Melfissa",
      "en": "Anya Melfissa",
      "kr": "Anya Melfissa",
      "channelUrl": "https://www.youtube.com/@AnyaMelfissa",
      "color": "#fae19b"
    },
    {
      "id": "shiranuiflare",
      "ja": "不知火フレア",
      "en": "Shiranui Flare",
      "kr": "시라누이 후레아",
      "channelUrl": "https://www.youtube.com/@ShiranuiFlare",
      "color": "#f0ac9d"
    },
    {
      "id": "cpt",
      "ja": "Cpt",
      "en": "Cpt",
      "kr": "Cpt",
      "channelUrl": "https://www.youtube.com/@CR_Cpt",
      "color": "#fcb7ab"
    },
    {
      "id": "ookamimio",
      "ja": "大神ミオ",
      "en": "Ookami Mio",
      "kr": "오오카미 미오",
      "channelUrl": "https://www.youtube.com/@OokamiMio",
      "color": "#f0a7ae"
    },
    {
      "id": "moricalliope",
      "ja": "Mori Calliope",
      "en": "Mori Calliope",
      "kr": "Mori Calliope",
      "channelUrl": "https://www.youtube.com/@MoriCalliope",
      "color": "#f9a7b0"
    },
    {
      "id": "shishirobotan",
      "ja": "獅白ぼたん",
      "en": "Shishiro Botan",
      "kr": "시시로 보탄",
      "channelUrl": "https://www.youtube.com/@ShishiroBotan",
      "color": "#a3e5cf"
    },
    {
      "id": "nekotatsuna",
      "ja": "猫汰つな",
      "en": "Nekota Tsuna",
      "kr": "네코타 츠나",
      "channelUrl": "https://www.youtube.com/@tsuna_nekota",
      "color": "#f9c8b0"
    },
    {
      "id": "amanekanata",
      "ja": "天音かなた",
      "en": "Amane Kanata",
      "kr": "아마네 카나타",
      "channelUrl": "https://www.youtube.com/@AmaneKanata",
      "color": "#99d8ff"
    },
    {
      "id": "tokinosora",
      "ja": "ときのそら",
      "en": "Tokino Sora",
      "kr": "토키노 소라",
      "channelUrl": "https://www.youtube.com/@TokinoSora",
      "color": "#82a0f5"
    },
    {
      "id": "natsuiromatsuri",
      "ja": "夏色まつり",
      "en": "Natsuiro Matsuri",
      "kr": "나츠이로 마츠리",
      "channelUrl": "https://www.youtube.com/@NatsuiroMatsuri",
      "color": "#ffa227"
    },
    {
      "id": "hakuikoyori",
      "ja": "博衣こより",
      "en": "Hakui Koyori",
      "kr": "하쿠이 코요리",
      "channelUrl": "https://www.youtube.com/@HakuiKoyori",
      "color": "#ffacd3"
    },
    {
      "id": "oozorasubaru",
      "ja": "大空スバル",
      "en": "Oozora Subaru",
      "kr": "오오조라 스바루",
      "channelUrl": "https://www.youtube.com/@OozoraSubaru",
      "color": "#e0ff2c"
    },
    {
      "id": "yuzukichoco",
      "ja": "癒月ちょこ",
      "en": "Yuzuki Choco",
      "kr": "유즈키 초코",
      "channelUrl": "https://www.youtube.com/@YuzukiChoco",
      "color": "#ff6e9b"
    },
    {
      "id": "shirakamifubuki",
      "ja": "白上フブキ",
      "en": "Shirakami Fubuki",
      "kr": "시라카미 후부키",
      "channelUrl": "https://www.youtube.com/@shirakamifubuki",
      "color": "#76dfff"
    },
    {
      "id": "inugamikorone",
      "ja": "犬神ころね",
      "en": "Inugami Korone",
      "kr": "이누가미 코로네",
      "channelUrl": "https://www.youtube.com/@InugamiKorone",
      "color": "#ffcc29"
    },
    {
      "id": "usadapekora",
      "ja": "兎田ぺこら",
      "en": "Usada Pekora",
      "kr": "우사다 페코라",
      "channelUrl": "https://www.youtube.com/@UsadaPekora",
      "color": "#88d2ff"
    },
    {
      "id": "shiroganenoel",
      "ja": "白銀ノエル",
      "en": "Shirogane Noel",
      "kr": "시로가네 노엘",
      "channelUrl": "https://www.youtube.com/@ShiroganeNoel",
      "color": "#ACBDC5"
    },
    {
      "id": "housyoumarine",
      "ja": "宝鐘マリン",
      "en": "Houshou Marine",
      "kr": "호쇼 마린",
      "channelUrl": "https://www.youtube.com/@HoushouMarine",
      "color": "#c47266"
    },
    {
      "id": "tsunomakiwatame",
      "ja": "角巻わため",
      "en": "Tsunomaki Watame",
      "kr": "츠노마키 와타메",
      "channelUrl": "https://www.youtube.com/@TsunomakiWatame",
      "color": "#fff29e"
    },
    {
      "id": "himemoriluna",
      "ja": "姫森ルーナ",
      "en": "Himemori Luna",
      "kr": "히메모리 루나",
      "channelUrl": "https://www.youtube.com/@HimemoriLuna",
      "color": "#fe84c2"
    },
    {
      "id": "yukihanalamy",
      "ja": "雪花ラミィ",
      "en": "Yukihana Lamy",
      "kr": "유키하나 라미",
      "channelUrl": "https://www.youtube.com/@YukihanaLamy",
      "color": "#6bcdf8"
    },
    {
      "id": "otonosekanade",
      "ja": "音乃瀬奏",
      "en": "Otonose Kanade",
      "kr": "오토노세 카나데",
      "channelUrl": "https://www.youtube.com/@OtonoseKanade",
      "color": "#ffe7b5"
    },
    {
      "id": "minaserio",
      "ja": "水無世燐央",
      "en": "Minase Rio",
      "kr": "미나세 리오",
      "channelUrl": "https://www.youtube.com/@MinaseRio",
      "color": "#A4A8D4"
    },
    {
      "id": "himehina",
      "ja": "HIMEHINA",
      "en": "HIMEHINA",
      "kr": "HIMEHINA",
      "channelUrl": "https://www.youtube.com/@HIMEHINA",
      "color": "#FFB1B1"
    }
  ],
  "songs": [
    {
      "youtubeId": "ylpBsZ0jHZc",
      "originalName": {
        "ja": "【ホロドリ】『Shallow Shadow』常闇トワ (Official Music Video)",
        "en": "【holodori】\"Shallow Shadow\" Tokoyami Towa (Official Music Video)",
        "kr": ""
      },
      "displayName": {
        "ja": "Shallow Shadow",
        "en": "",
        "kr": ""
      },
      "artist": "",
      "viewCount": 231871,
      "likeCount": 9818,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": [
        "本多友紀（EverNest）"
      ],
      "composition": [
        "本多友紀（EverNest）"
      ],
      "arrangement": [
        "傳田有矢（EverNest）"
      ],
      "isAvailableMV": true,
      "release": [
        ""
      ],
      "releaseAt": "2026/10/18",
      "order": 1,
      "type": "original",
      "descriptionHtml": {
        "ja": "『Shallow Shadow』Official Music Videoを公開！🏰🎶\u003cbr\u003e\u003cbr\u003e――――――――――――\u003cbr\u003e『Shallow Shadow』\u003cbr\u003e\u003cbr\u003e歌唱：常闇トワ\u003cbr\u003e作詞：本多友紀（EverNest）\u003cbr\u003e作曲：本多友紀（EverNest）\u003cbr\u003e編曲：傳田有矢（EverNest）\u003cbr\u003e――――――――――――\u003cbr\u003e\u003cbr\u003eーーー\u003cbr\u003eMovie：ろりー（x.com/yosinO_mo）\u003cbr\u003eIllustration：釧路くき（x.com/kuki8117）\u003cbr\u003eLyric \u0026 Logo design：JEFF99（x.com/nesspaula99）\u003cbr\u003eーーー\u003cbr\u003e\u003cbr\u003e▼ゲームダウンロードはこちら\u003cbr\u003e\u003ca href=\"https://hololive-dreams.com/\" target=\"_blank\"\u003ehttps://hololive-dreams.com/\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e―――――――――――\u003cbr\u003e公式X\u003cbr\u003e\u003ca href=\"https://x.com/hololive_dreams\" target=\"_blank\"\u003ehttps://x.com/hololive_dreams\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e英語版公式X\u003cbr\u003e\u003ca href=\"https://x.com/holo_dreams_en\" target=\"_blank\"\u003ehttps://x.com/holo_dreams_en\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e公式サイト\u003cbr\u003e\u003ca href=\"https://hololive-dreams.com/\" target=\"_blank\"\u003ehttps://hololive-dreams.com/\u003c/a\u003e\u003cbr\u003e―――――――――――\u003cbr\u003e\u003cbr\u003e#hololive #ホロドリ #常闇トワ\u003cbr\u003e\u003cbr\u003e※ホロライブプロダクションから未成年の視聴者の方々へのお願い\u003cbr\u003e下記リンクをご確認の上、お楽しみください。\u003cbr\u003e\u003ca href=\"https://hololivepro.com/request-to-minors/\" target=\"_blank\"\u003ehttps://hololivepro.com/request-to-minors/\u003c/a\u003e",
        "en": "Official Music Video for \"Shallow Shadow\" is now available! 🏰🎶\u003cbr\u003e\u003cbr\u003e――――――――――――\u003cbr\u003e\"Shallow Shadow\"\u003cbr\u003eVocals: Tokoyami Towa\u003cbr\u003eLyrics: Yuki Honda（EverNest）\u003cbr\u003eComposition: Yuki Honda（EverNest）\u003cbr\u003eArrangement: Yuya Denda（EverNest）\u003cbr\u003e――――――――――――\u003cbr\u003e\u003cbr\u003eーーー\u003cbr\u003eMovie：ろりー（x.com/yosinO_mo）\u003cbr\u003eIllustration：釧路くき（x.com/kuki8117）\u003cbr\u003eLyric \u0026 Logo design：JEFF99（x.com/nesspaula99）\u003cbr\u003eーーー\u003cbr\u003e\u003cbr\u003e▼Download the game\u003cbr\u003e\u003ca href=\"https://hololive-dreams.com/en\" target=\"_blank\"\u003ehttps://hololive-dreams.com/en\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e――――――――――――\u003cbr\u003eOfficial Japanese X Account\u003cbr\u003e\u003ca href=\"https://x.com/hololive_dreams\" target=\"_blank\"\u003ehttps://x.com/hololive_dreams\u003c/a\u003e\u003cbr\u003e\u003cbr\u003eOfficial English X Account\u003cbr\u003e\u003ca href=\"https://x.com/holo_dreams_en\" target=\"_blank\"\u003ehttps://x.com/holo_dreams_en\u003c/a\u003e\u003cbr\u003e\u003cbr\u003eOfficial Website\u003cbr\u003e\u003ca href=\"https://hololive-dreams.com/en\" target=\"_blank\"\u003ehttps://hololive-dreams.com/en\u003c/a\u003e\u003cbr\u003e――――――――――――\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e#hololive #holodori #常闇トワ\u003cbr\u003e\u003cbr\u003e\u003ca href=\"https://en.hololive.tv/request-to-minors\" target=\"_blank\"\u003ehttps://en.hololive.tv/request-to-minors\u003c/a\u003e \u003cbr\u003eRequest from hololive Production to underage viewers:\u003cbr\u003ePlease be sure to check the link before viewing our content.",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/ylpBsZ0jHZc/maxresdefault.jpg",
      "publishedAt": "2026-10-18T11:00:11Z"
    },
    {
      "youtubeId": "X8ZP3g9_MZ0",
      "originalName": {
        "ja": "HIMEHINA×Mori Calliope×Tokoyami Towa『ファイアダンス』Cover",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "ファイアダンス",
        "en": "",
        "kr": ""
      },
      "artist": "Vivid BAD SQUAD",
      "viewCount": 784790,
      "likeCount": 26144,
      "singers": [
        "himehina",
        "moricalliope",
        "tokoyamitowa"
      ],
      "lyrics": null,
      "composition": null,
      "arrangement": null,
      "isAvailableMV": true,
      "release": null,
      "releaseAt": "",
      "order": 0,
      "type": "cover",
      "descriptionHtml": {
        "ja": "㊗武道館ライブ来年7/13開催決定！最速先行10/18まで受付中！\u003cbr\u003e\u003ca href=\"https://spc.himehina.jp/LiveatBudokan27\" target=\"_blank\"\u003ehttps://spc.himehina.jp/LiveatBudokan27\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e🎥ワールドツアーグランドフィナーレ見逃し配信中！10/22(木)まで\u003cbr\u003e\u003ca href=\"https://www.hulu.jp/store/himehina-world-tour-2026-lifetime-is-bubblin-grand-finale-2days\" target=\"_blank\"\u003ehttps://www.hulu.jp/store/himehina-world-tour-2026-lifetime-is-bubblin-grand-finale-2days\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e\u003cbr\u003eOriginal：\u003ca href=\"https://youtu.be/Zqs0lEADyFo\" target=\"_blank\"\u003ehttps://youtu.be/Zqs0lEADyFo\u003c/a\u003e\u003cbr\u003eLyrics\u0026Music：DECO*27\u003cbr\u003eArrange：Giga\u003cbr\u003e\u003cbr\u003eVocal：\u003cbr\u003e            🍡HIME TANAKA \u003ca href=\"https://twitter.com/HimeTanaka_HH\" target=\"_blank\"\u003ehttps://twitter.com/HimeTanaka_HH\u003c/a\u003e\u003cbr\u003e            🦈HINA SUZUKI \u003ca href=\"https://twitter.com/HinaSuzuki_HH\" target=\"_blank\"\u003ehttps://twitter.com/HinaSuzuki_HH\u003c/a\u003e\u003cbr\u003e            👾TOWA TOKOYAMI \u003ca href=\"https://twitter.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://twitter.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e            💀MORI CALLIOPE \u003ca href=\"https://twitter.com/moricalliope\" target=\"_blank\"\u003ehttps://twitter.com/moricalliope\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e◤◢◤NEWS◢◤◢\u003cbr\u003eHIMEHINA最新情報はこちら：\u003ca href=\"https://larainc.link/HIMEHINA\" target=\"_blank\"\u003ehttps://larainc.link/HIMEHINA\u003c/a\u003e\u003cbr\u003e＿＿＿＿＿＿＿＿＿＿＿＿＿＿＿＿＿＿＿＿＿＿＿＿\u003cbr\u003e🧛‍♀️HIMEHINA EP『VAMPY』\u003cbr\u003e￣￣￣￣￣￣￣￣￣￣￣￣￣￣￣￣￣￣￣￣￣￣￣￣\u003cbr\u003e11月27日 ヒメヒナ初のEP『VAMPY』が発売👑🦇\u003cbr\u003e予約 / \u003ca href=\"https://spc.himehina.jp/vampy\" target=\"_blank\"\u003ehttps://spc.himehina.jp/vampy\u003c/a\u003e\u003cbr\u003e＿＿＿＿＿＿＿＿＿＿＿＿＿＿＿＿＿＿＿＿＿＿＿＿\u003cbr\u003e💿3rd Cover ALBUM 『ヒメヒナウタミタ参』\u003cbr\u003e￣￣￣￣￣￣￣￣￣￣￣￣￣￣￣￣￣￣￣￣￣￣￣￣\u003cbr\u003eカバーアルバム第三弾が12月23日発売！\u003cbr\u003e予約 / \u003ca href=\"https://spc.himehina.jp/utamita3/\" target=\"_blank\"\u003ehttps://spc.himehina.jp/utamita3/\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e◤◢◤PLAYLIST◢◤◢\u003cbr\u003e\u003ca href=\"https://www.youtube.com/playlist?list=PL1tX8zAv8bPk85chzXCyh6CgEyqFAdxwV\" target=\"_blank\"\u003ehttps://www.youtube.com/playlist?list=PL1tX8zAv8bPk85chzXCyh6CgEyqFAdxwV\u003c/a\u003e\u003cbr\u003e\u003ca href=\"https://www.youtube.com/playlist?list=PL1tX8zAv8bPlL68x0sS_DRP0jmRFq5ybW\" target=\"_blank\"\u003ehttps://www.youtube.com/playlist?list=PL1tX8zAv8bPlL68x0sS_DRP0jmRFq5ybW\u003c/a\u003e\u003cbr\u003e\u003ca href=\"https://www.youtube.com/playlist?list=PL1tX8zAv8bPlHlTIICF11GfzKqorbA2OT\" target=\"_blank\"\u003ehttps://www.youtube.com/playlist?list=PL1tX8zAv8bPlHlTIICF11GfzKqorbA2OT\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e◤◢◤PRODUCTION◢◤◢\u003cbr\u003eMovie ─────────\u003cbr\u003eDirection：Studio LaRa\u003cbr\u003eMovie：Waduki (Log-!N) \u003ca href=\"https://twitter.com/Waduki_ki\" target=\"_blank\"\u003ehttps://twitter.com/Waduki_ki\u003c/a\u003e\u003cbr\u003eIllust.：kicori \u003ca href=\"https://twitter.com/kicorikkka\" target=\"_blank\"\u003ehttps://twitter.com/kicorikkka\u003c/a\u003e\u003cbr\u003e\u003cbr\u003eSound ─────────\u003cbr\u003eSound Director：Tetsuya Ohyama\u003cbr\u003eMix：Mitsuhiro Iinami\u003cbr\u003eVocal REC：Yuuka Suzuki\u003cbr\u003e\u003cbr\u003eProduced by Studio LaRa \u003ca href=\"https://twitter.com/LaRa_km10\" target=\"_blank\"\u003ehttps://twitter.com/LaRa_km10\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e◤◢◤LINK◢◤◢\u003cbr\u003eALL LINKs：\u003ca href=\"https://lit.link/HIMEHINA\" target=\"_blank\"\u003ehttps://lit.link/HIMEHINA\u003c/a\u003e\u003cbr\u003eWeb \u0026 Fanclub：\u003ca href=\"https://himehina.jp/\" target=\"_blank\"\u003ehttps://himehina.jp/\u003c/a\u003e\u003cbr\u003eTikTok：\u003ca href=\"https://tiktok.com/@himehina.80\" target=\"_blank\"\u003ehttps://tiktok.com/@himehina.80\u003c/a\u003e\u003cbr\u003eInstagram：\u003ca href=\"https://instagram.com/himehina_official/\" target=\"_blank\"\u003ehttps://instagram.com/himehina_official/\u003c/a\u003e\u003cbr\u003eSpotify：\u003ca href=\"https://open.spotify.com/intl-ja/artist/5OBmR4AY53SS26qHZ4uwnq\" target=\"_blank\"\u003ehttps://open.spotify.com/intl-ja/artist/5OBmR4AY53SS26qHZ4uwnq\u003c/a\u003e\u003cbr\u003eDiscord：\u003ca href=\"https://discord.gg/XJbKHW2g9t\" target=\"_blank\"\u003ehttps://discord.gg/XJbKHW2g9t\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e#HIMEHINA #ヒメヒナ #MoriCalliope #常闇トワ #VTuber #ファイアダンス",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/X8ZP3g9_MZ0/maxresdefault.jpg",
      "publishedAt": "2026-10-16T12:00:09Z"
    },
    {
      "youtubeId": "yOI1qMpfuRw",
      "originalName": {
        "ja": "Rewrite the Answer / 常闇トワ (official)",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "Rewrite the Answer",
        "en": "",
        "kr": ""
      },
      "artist": "",
      "viewCount": 432632,
      "likeCount": 19510,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": [
        "山中拓也"
      ],
      "composition": [
        "山中拓也"
      ],
      "arrangement": [
        "山中拓也"
      ],
      "isAvailableMV": true,
      "release": [
        "Rewrite the Answer"
      ],
      "releaseAt": "2026/10/09",
      "order": 1,
      "type": "original",
      "descriptionHtml": {
        "ja": "重なる想いは混ざりあって\u003cbr\u003e奇跡の道を歩いていくんだ\u003cbr\u003e\u003cbr\u003e-------\u003cbr\u003e\u003cbr\u003e▼楽曲配信リンク\u003cbr\u003e常闇トワ『Rewrite the Answer』\u003cbr\u003e\u003ca href=\"https://cover.lnk.to/OCa2Jk\" target=\"_blank\"\u003ehttps://cover.lnk.to/OCa2Jk\u003c/a\u003e\u003cbr\u003e\u003cbr\u003eTVアニメ『追放された転生重騎士はゲーム知識で無双する』オープニングテーマ\u003cbr\u003e\u003ca href=\"https://sh-anime.shochiku.co.jp/jukishi-anime/\" target=\"_blank\"\u003ehttps://sh-anime.shochiku.co.jp/jukishi-anime/\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e-------\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e常闇トワ\u003cbr\u003e\u003ca href=\"https://x.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://x.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003eLyrics：山中拓也(THE ORAL CIGARETTES)\u003cbr\u003eMusic：山中拓也(THE ORAL CIGARETTES), 辻村有記\u003cbr\u003eArrangement：山中拓也(THE ORAL CIGARETTES), 辻村有記\u003cbr\u003eMix Engineer：MEG(MEGMETAL)\u003cbr\u003eRec Engineer：丸岡詩織\u003cbr\u003e\u003cbr\u003eDirector：中垣内悠(Folium)\u003cbr\u003eIllustrator：ツカハラミノリ\u003cbr\u003eMotionDesigner：鎌田栄大(Folium)\u003cbr\u003eGraphic Designer：卜部\u003cbr\u003e\u003cbr\u003e■special thanks\u003cbr\u003e常闇眷属\u003cbr\u003e\u003cbr\u003e-------\u003cbr\u003e\u003cbr\u003e塞いだ心を解放して\u003cbr\u003e路なき道を歩いてきたんだ\u003cbr\u003e乾いた想いは飲み込んで\u003cbr\u003e夢震わす世界の証明\u003cbr\u003e\u003cbr\u003eありとあらゆる不条理のAnswer\u003cbr\u003e絡めたwonder 傍観者じゃない\u003cbr\u003e酸いも甘いも噛み分け砕いて\u003cbr\u003e喰らう後悔も\u003cbr\u003e\u003cbr\u003eI need you\u003cbr\u003e簡単に 目を覚ましそうな\u003cbr\u003e刺激的夢に身を任せて\u003cbr\u003eいっそ遊び尽くして\u003cbr\u003eI need you\u003cbr\u003e単純に そして明快に\u003cbr\u003e裏切りという烙印はいつしか\u003cbr\u003eきっと切り拓いていく\u003cbr\u003e始まりのArmor\u003cbr\u003e\u003cbr\u003e重なる想いは混ざりあって\u003cbr\u003e奇跡の道を歩いていくんだ\u003cbr\u003e孤独は疾うに吐き出して\u003cbr\u003e君と鳴らす未来の共鳴\u003cbr\u003e\u003cbr\u003e神と所謂完全なMonster\u003cbr\u003eリアルなAnswer 勝算ありじゃない？\u003cbr\u003e2つの答えを×合いイコールで\u003cbr\u003e謳う存在も\u003cbr\u003e\u003cbr\u003eI feel you\u003cbr\u003e永遠の傷や後悔も\u003cbr\u003e共に交わした誓い芽生え共に交わした誓い芽生え\u003cbr\u003eそっと光り出すのさ\u003cbr\u003eI feel you\u003cbr\u003e偏見もその不完全も\u003cbr\u003esyncした答えその刃に込めて\u003cbr\u003eもっと強くなるのさ\u003cbr\u003e絡めあうArmor\u003cbr\u003e\u003cbr\u003eRewrite the Answer\u003cbr\u003e\u003cbr\u003eI need you\u003cbr\u003e簡単に 目を覚ましそうな\u003cbr\u003e刺激的夢に身を任せて\u003cbr\u003eいっそ遊び尽くして\u003cbr\u003e嘲笑う声も\u003cbr\u003e壊れた夜も\u003cbr\u003e無限の道に繋いでいく\u003cbr\u003eいつかもっともっと映し出して\u003cbr\u003eRewrite the Answer\u003cbr\u003e\u003cbr\u003eRewrite the Answer\u003cbr\u003e\u003cbr\u003e--------------------------------\u003cbr\u003e※ホロライブプロダクションから未成年の視聴者の方々へのお願い\u003cbr\u003e[カバー 未成年者の方々へ]で検索してお読みいただくか、下記リンクをご確認の上、お楽しみください。\u003cbr\u003e\u003ca href=\"https://hololivepro.com/request-to-minors/\" target=\"_blank\"\u003ehttps://hololivepro.com/request-to-minors/\u003c/a\u003e\u003cbr\u003e--------------------------------\u003cbr\u003e\u003cbr\u003e#転生重騎士 #anime",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/yOI1qMpfuRw/maxresdefault.jpg",
      "publishedAt": "2026-10-08T11:00:07Z"
    },
    {
      "youtubeId": "lmBkWOkBCBA",
      "originalName": {
        "ja": "SM4SH IT UP",
        "en": "SM4SH IT UP",
        "kr": ""
      },
      "displayName": {
        "ja": "SM4SH IT UP",
        "en": "",
        "kr": ""
      },
      "artist": "",
      "viewCount": 229856,
      "likeCount": 4753,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": [
        "Ryo Isono"
      ],
      "composition": [
        "Ryo Isono"
      ],
      "arrangement": [
        "Ryo Isono"
      ],
      "isAvailableMV": false,
      "release": [
        "SM4SH IT UP"
      ],
      "releaseAt": "2026/08/09",
      "order": 1,
      "type": "original",
      "descriptionHtml": {
        "ja": "Provided to YouTube by hololive RECORDS\u003cbr\u003e\u003cbr\u003eSM4SH IT UP · Tokoyami Towa · Ryo Isono · Ryo Isono · Ryo Isono\u003cbr\u003e\u003cbr\u003eSM4SH IT UP\u003cbr\u003e\u003cbr\u003eReleased on: 2026-08-09\u003cbr\u003e\u003cbr\u003eAuto-generated by YouTube.",
        "en": "Provided to YouTube by hololive RECORDS\u003cbr\u003e\u003cbr\u003eSM4SH IT UP · Tokoyami Towa · Ryo Isono · Ryo Isono · Ryo Isono\u003cbr\u003e\u003cbr\u003eSM4SH IT UP\u003cbr\u003e\u003cbr\u003eReleased on: 2026-08-09\u003cbr\u003e\u003cbr\u003eAuto-generated by YouTube.",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/lmBkWOkBCBA/maxresdefault.jpg",
      "publishedAt": "2026-08-08T15:05:11Z"
    },
    {
      "youtubeId": "oUd1hLK7p2I",
      "originalName": {
        "ja": "#ウチらしか勝たん / 常闇トワ×桃鈴ねね (official)",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "#ウチらしか勝たん",
        "en": "",
        "kr": ""
      },
      "artist": "ねねねトワワ（常闇トワ×桃鈴ねね）",
      "viewCount": 506458,
      "likeCount": 23224,
      "singers": [
        "tokoyamitowa",
        "momosuzunene"
      ],
      "lyrics": [
        "knoak"
      ],
      "composition": [
        "knoak"
      ],
      "arrangement": [
        "knoak"
      ],
      "isAvailableMV": true,
      "release": [
        "#ウチらしか勝たん"
      ],
      "releaseAt": "2026/07/10",
      "order": 1,
      "type": "original",
      "descriptionHtml": {
        "ja": "-------\u003cbr\u003e\u003cbr\u003e▼楽曲配信リンク\u003cbr\u003e#ねねねトワワ『 #ウチらしか勝たん 』\u003cbr\u003e\u003ca href=\"https://cover.lnk.to/q7WIF0\" target=\"_blank\"\u003ehttps://cover.lnk.to/q7WIF0\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e-------\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e常闇トワ\u003cbr\u003e\u003ca href=\"https://x.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://x.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003ca href=\"https://www.youtube.com/@TokoyamiTowa\" target=\"_blank\"\u003e@TokoyamiTowa\u003c/a\u003e \u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e桃鈴ねね\u003cbr\u003e\u003ca href=\"https://x.com/momosuzunene\" target=\"_blank\"\u003ehttps://x.com/momosuzunene\u003c/a\u003e\u003cbr\u003e\u003ca href=\"https://www.youtube.com/@MomosuzuNene\" target=\"_blank\"\u003e@MomosuzuNene\u003c/a\u003e \u003cbr\u003e\u003cbr\u003e\u003cbr\u003e-------\u003cbr\u003e\u003cbr\u003e作詞/作曲/編曲：knoak 様\u003cbr\u003eRecording Engineer：丸岡詩織 様\u003cbr\u003eMix Engineer：佐々木優 様\u003cbr\u003e\u003cbr\u003e-------\u003cbr\u003e\u003cbr\u003e■Illust\u003cbr\u003eおにねこ 様\u003cbr\u003e\u003ca href=\"https://x.com/onineko26\" target=\"_blank\"\u003ehttps://x.com/onineko26\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Movie\u003cbr\u003eお菊 様\u003cbr\u003e\u003ca href=\"https://x.com/__Lizel\" target=\"_blank\"\u003ehttps://x.com/__Lizel\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Logo\u003cbr\u003eBinn 様\u003cbr\u003e\u003ca href=\"https://x.com/binn_n0\" target=\"_blank\"\u003ehttps://x.com/binn_n0\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■字幕\u003cbr\u003eBigsky Sunshine様 \u003cbr\u003eLamine 様\u003cbr\u003e\u003ca href=\"https://x.com/La_mi_ne\" target=\"_blank\"\u003ehttps://x.com/La_mi_ne\u003c/a\u003e \u003cbr\u003eTama様 \u003cbr\u003eT-chan様\u003cbr\u003e\u003cbr\u003e■special thanks\u003cbr\u003e常闇眷属\u003cbr\u003eねっ子\u003cbr\u003e\u003cbr\u003e--------------------------------\u003cbr\u003e※ホロライブプロダクションから未成年の視聴者の方々へのお願い\u003cbr\u003e[カバー 未成年者の方々へ]で検索してお読みいただくか、下記リンクをご確認の上、お楽しみください。\u003cbr\u003e\u003ca href=\"https://hololivepro.com/request-to-minors/\" target=\"_blank\"\u003ehttps://hololivepro.com/request-to-minors/\u003c/a\u003e\u003cbr\u003e--------------------------------",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/oUd1hLK7p2I/maxresdefault.jpg",
      "publishedAt": "2026-07-09T11:00:06Z"
    },
    {
      "youtubeId": "c5qJc8ArTUo",
      "originalName": {
        "ja": "CH4NGE / ORIO ｰ 常闇トワ×天音かなた ｰ(cover)",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "CH4NGE",
        "en": "",
        "kr": ""
      },
      "artist": "Giga",
      "viewCount": 1147595,
      "likeCount": 51277,
      "singers": [
        "tokoyamitowa",
        "amanekanata"
      ],
      "lyrics": null,
      "composition": null,
      "arrangement": null,
      "isAvailableMV": true,
      "release": null,
      "releaseAt": "",
      "order": 0,
      "type": "cover",
      "descriptionHtml": {
        "ja": "ありがとう\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e■素敵な本家様\u003cbr\u003e『CH4NGE ft.可不』/Giga様\u003cbr\u003e\u003ca href=\"https://www.youtube.com/watch?v=LbO4pg_LHUI\" target=\"_blank\"\u003ehttps://www.youtube.com/watch?v=LbO4pg_LHUI\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■MIX\u003cbr\u003eよしけん　様\u003cbr\u003e\u003ca href=\"https://x.com/yoshi_kennn\" target=\"_blank\"\u003ehttps://x.com/yoshi_kennn\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Illust\u003cbr\u003e花澤明　様\u003cbr\u003e\u003ca href=\"https://x.com/hnzwakira\" target=\"_blank\"\u003ehttps://x.com/hnzwakira\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Movie\u003cbr\u003eKOHIRU　様\u003cbr\u003e\u003ca href=\"https://x.com/k0ii81\" target=\"_blank\"\u003ehttps://x.com/k0ii81\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e常闇トワ　   \u003ca href=\"https://www.youtube.com/@TokoyamiTowa\" target=\"_blank\"\u003e@TokoyamiTowa\u003c/a\u003e \u003cbr\u003e\u003ca href=\"https://x.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://x.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e天音かなた　\u003ca href=\"https://www.youtube.com/@AmaneKanata\" target=\"_blank\"\u003e@AmaneKanata\u003c/a\u003e \u003cbr\u003e\u003ca href=\"https://x.com/amanekanatach\" target=\"_blank\"\u003ehttps://x.com/amanekanatach\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e#常闇トワ #歌ってみた #cover #CH4NGE #天音かなた\u003cbr\u003e\u003cbr\u003e--------------------------------\u003cbr\u003e※ホロライブプロダクションから未成年の視聴者の方々へのお願い\u003cbr\u003e[カバー 未成年者の方々へ]で検索してお読みいただくか、下記リンクをご確認の上、お楽しみください。\u003cbr\u003e\u003ca href=\"https://hololivepro.com/request-to-minors/\" target=\"_blank\"\u003ehttps://hololivepro.com/request-to-minors/\u003c/a\u003e\u003cbr\u003e--------------------------------",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/c5qJc8ArTUo/maxresdefault.jpg",
      "publishedAt": "2026-05-17T11:00:06Z"
    },
    {
      "youtubeId": "kPqmld3_lSs",
      "originalName": {
        "ja": "BEEP BEEP / Hoshimatic Project (official)",
        "en": "BEEP BEEP / Hoshimatic Project (official)",
        "kr": "BEEP BEEP / Hoshimatic Project (official)"
      },
      "displayName": {
        "ja": "BEEP BEEP",
        "en": "",
        "kr": ""
      },
      "artist": "Hoshimatic Project",
      "viewCount": 2252135,
      "likeCount": -1,
      "singers": [
        "hoshimachisuisei",
        "tokinosora",
        "natsuiromatsuri",
        "akirose",
        "momosuzunene",
        "hakuikoyori",
        "oozorasubaru",
        "tokoyamitowa",
        "kazamairoha"
      ],
      "lyrics": [
        "Anna Kusakawa"
      ],
      "composition": [
        "Anna Kusakawa",
        "KISSY"
      ],
      "arrangement": [
        "KISSY"
      ],
      "isAvailableMV": true,
      "release": [
        "BEEP BEEP"
      ],
      "releaseAt": "2026/04/18",
      "order": 1,
      "type": "original",
      "descriptionHtml": {
        "ja": "⇩2026.4.18 0:00『BEEP BEEP』リリース🎧\u003cbr\u003e\u003ca href=\"https://cover.lnk.to/qmePp8\" target=\"_blank\"\u003ehttps://cover.lnk.to/qmePp8\u003c/a\u003e             \u003cbr\u003e\u003cbr\u003e🔽CD受付開始！\u003cbr\u003e\u003ca href=\"https://shop.hololivepro.com/products/hoshimaticproject_beepbeep\" target=\"_blank\"\u003ehttps://shop.hololivepro.com/products/hoshimaticproject_beepbeep\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e\u003cbr\u003eVocal：Hoshimatic Project\u003cbr\u003eHoshimachi Suisei\u003cbr\u003eTokino Sora\u003cbr\u003eNatsuiro Matsuri\u003cbr\u003eAki Rosenthal\u003cbr\u003eOozora Subaru\u003cbr\u003eTokoyami Towa\u003cbr\u003eMomosuzu Nene\u003cbr\u003eHakui Koyori\u003cbr\u003eKazama Iroha\u003cbr\u003e\u003cbr\u003eLyrics by： Anna Kusakawa\u003cbr\u003eComposed by： Anna Kusakawa, KISSY\u003cbr\u003eArranged by： KISSY\u003cbr\u003eMixed by：NNZN\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e-----------------\u003cbr\u003e📹MV staff\u003cbr\u003e\u003cbr\u003eProducer：Takashi Kawamura(GEEK PICTURES)\u003cbr\u003eDirector：ina(entity)\u003cbr\u003eAnimator：\u003cbr\u003eHiroaki Osawa(entity)\u003cbr\u003eAkira Takayanagi(Flying Ship Studio, Inc.)\u003cbr\u003eKazumasa Takahashi(Flying Ship Studio, Inc.)\u003cbr\u003e\u003cbr\u003eProduction Assistant：Chizu Suzuki(Flying Ship Studio, Inc.)\u003cbr\u003eAssistant Producer：Rie Aratani(entity)\u003cbr\u003eProducer：Takako Kanda(entity)\u003cbr\u003e        \u003cbr\u003eLead Modeler：Masashi Miyaoka\u003cbr\u003eModeler：Yozo Uchiyama\u003cbr\u003eRigger：Shohei Chino\u003cbr\u003eSticker Design：Chihirock\u003cbr\u003e        \u003cbr\u003eChief Motion Caputure Designer：Takahide Shinohara(TOEI ZUKUN LABORATORY)\u003cbr\u003eLead Motion Caputure Designer：\u003cbr\u003eKouta Isomura(TOEI ZUKUN LABORATORY)\u003cbr\u003eRina Sawada(TOEI ZUKUN LABORATORY)\u003cbr\u003eMotion Caputure Designer：\u003cbr\u003eDaiki Yonezawa(TOEI ZUKUN LABORATORY)\u003cbr\u003eShiori Tagawa(TOEI ZUKUN LABORATORY)\u003cbr\u003eEmi Matsumoto(TOEI ZUKUN LABORATORY)\u003cbr\u003eMiku Kuragane(TOEI ZUKUN LABORATORY)\u003cbr\u003eKana Numasato(TOEI ZUKUN LABORATORY)\u003cbr\u003eRyo Hasebe(TOEI ZUKUN LABORATORY)\u003cbr\u003e\u003cbr\u003eProject Manager：Miyu Omoto(TOEI ZUKUN LABORATORY)\u003cbr\u003eProducer：Sawami Takahashi(TOEI ZUKUN LABORATORY)\u003cbr\u003e      \u003cbr\u003eSound Effects：Shuji Suzuki(SuZooki)\u003cbr\u003eProduction Coordinator：Takayoshi Iwata(ARK inc.)\u003cbr\u003eEditor：Tomojiro Fujiki(ARK inc.)\u003cbr\u003e\u003cbr\u003e\u003cbr\u003eTranslations: fts, Lamine\u003cbr\u003eCaptions: T-chan\u003cbr\u003e-----------------\u003cbr\u003e💃Choreography\u003cbr\u003e\u003cbr\u003eChoreography：Miyuki Nishijima\u003cbr\u003eGeneral Supervision：        \u003cbr\u003eSupervision：MaiMai：FIREWORKS Co., Ltd.\u003cbr\u003eAssistant：FIREWORKS DANCERS\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e🎨Illustration\u003cbr\u003eCostume design：さえきやひろ\u003cbr\u003e\u003cbr\u003eJacket Illustration：犬乃ぴすけ\u003cbr\u003e\u003cbr\u003eFinal drawings：\u003cbr\u003e株式会社サーチフィールド\u003cbr\u003e\u003cbr\u003e壱十九\u003cbr\u003eかしなーた\u003cbr\u003eshita\u003cbr\u003e福本もこ\u003cbr\u003eわなつ\u003cbr\u003etaron\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e※ホロライブプロダクションから未成年の視聴者の方々へのお願い\u003cbr\u003e[カバー 未成年者の方々へ]で検索してお読みいただくか、下記リンクをご確認の上、お楽しみください。\u003cbr\u003e\u003ca href=\"https://hololivepro.com/request-to-minors/\" target=\"_blank\"\u003ehttps://hololivepro.com/request-to-minors/\u003c/a\u003e",
        "en": "⇩2026.4.18 0:00『BEEP BEEP』リリース🎧\u003cbr\u003e\u003ca href=\"https://cover.lnk.to/qmePp8\" target=\"_blank\"\u003ehttps://cover.lnk.to/qmePp8\u003c/a\u003e             \u003cbr\u003e\u003cbr\u003e🔽CD受付開始！\u003cbr\u003e\u003ca href=\"https://shop.hololivepro.com/products/hoshimaticproject_beepbeep\" target=\"_blank\"\u003ehttps://shop.hololivepro.com/products/hoshimaticproject_beepbeep\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e\u003cbr\u003eVocal：Hoshimatic Project\u003cbr\u003eHoshimachi Suisei\u003cbr\u003eTokino Sora\u003cbr\u003eNatsuiro Matsuri\u003cbr\u003eAki Rosenthal\u003cbr\u003eOozora Subaru\u003cbr\u003eTokoyami Towa\u003cbr\u003eMomosuzu Nene\u003cbr\u003eHakui Koyori\u003cbr\u003eKazama Iroha\u003cbr\u003e\u003cbr\u003eLyrics by： Anna Kusakawa\u003cbr\u003eComposed by： Anna Kusakawa, KISSY\u003cbr\u003eArranged by： KISSY\u003cbr\u003eMixed by：NNZN\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e-----------------\u003cbr\u003e📹MV staff\u003cbr\u003e\u003cbr\u003eProducer：Takashi Kawamura(GEEK PICTURES)\u003cbr\u003eDirector：ina(entity)\u003cbr\u003eAnimator：\u003cbr\u003eHiroaki Osawa(entity)\u003cbr\u003eAkira Takayanagi(Flying Ship Studio, Inc.)\u003cbr\u003eKazumasa Takahashi(Flying Ship Studio, Inc.)\u003cbr\u003e\u003cbr\u003eProduction Assistant：Chizu Suzuki(Flying Ship Studio, Inc.)\u003cbr\u003eAssistant Producer：Rie Aratani(entity)\u003cbr\u003eProducer：Takako Kanda(entity)\u003cbr\u003e        \u003cbr\u003eLead Modeler：Masashi Miyaoka\u003cbr\u003eModeler：Yozo Uchiyama\u003cbr\u003eRigger：Shohei Chino\u003cbr\u003eSticker Design：Chihirock\u003cbr\u003e        \u003cbr\u003eChief Motion Caputure Designer：Takahide Shinohara(TOEI ZUKUN LABORATORY)\u003cbr\u003eLead Motion Caputure Designer：\u003cbr\u003eKouta Isomura(TOEI ZUKUN LABORATORY)\u003cbr\u003eRina Sawada(TOEI ZUKUN LABORATORY)\u003cbr\u003eMotion Caputure Designer：\u003cbr\u003eDaiki Yonezawa(TOEI ZUKUN LABORATORY)\u003cbr\u003eShiori Tagawa(TOEI ZUKUN LABORATORY)\u003cbr\u003eEmi Matsumoto(TOEI ZUKUN LABORATORY)\u003cbr\u003eMiku Kuragane(TOEI ZUKUN LABORATORY)\u003cbr\u003eKana Numasato(TOEI ZUKUN LABORATORY)\u003cbr\u003eRyo Hasebe(TOEI ZUKUN LABORATORY)\u003cbr\u003e\u003cbr\u003eProject Manager：Miyu Omoto(TOEI ZUKUN LABORATORY)\u003cbr\u003eProducer：Sawami Takahashi(TOEI ZUKUN LABORATORY)\u003cbr\u003e      \u003cbr\u003eSound Effects：Shuji Suzuki(SuZooki)\u003cbr\u003eProduction Coordinator：Takayoshi Iwata(ARK inc.)\u003cbr\u003eEditor：Tomojiro Fujiki(ARK inc.)\u003cbr\u003e-----------------\u003cbr\u003e💃Choreography\u003cbr\u003e\u003cbr\u003eChoreography：Miyuki Nishijima\u003cbr\u003eGeneral Supervision：        \u003cbr\u003eSupervision：MaiMai：FIREWORKS Co., Ltd.\u003cbr\u003eAssistant：FIREWORKS DANCERS\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e🎨Illustration\u003cbr\u003eCostume design：さえきやひろ\u003cbr\u003e\u003cbr\u003eJacket Illustration：犬乃ぴすけ\u003cbr\u003e\u003cbr\u003eFinal drawings：\u003cbr\u003e株式会社サーチフィールド\u003cbr\u003e\u003cbr\u003e壱十九\u003cbr\u003eかしなーた\u003cbr\u003eshita\u003cbr\u003e福本もこ\u003cbr\u003eわなつ\u003cbr\u003etaron\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e※ホロライブプロダクションから未成年の視聴者の方々へのお願い\u003cbr\u003e[カバー 未成年者の方々へ]で検索してお読みいただくか、下記リンクをご確認の上、お楽しみください。\u003cbr\u003e\u003ca href=\"https://hololivepro.com/request-to-minors/\" target=\"_blank\"\u003ehttps://hololivepro.com/request-to-minors/\u003c/a\u003e",
        "kr": "⇩2026.4.18 0:00『BEEP BEEP』リリース🎧\u003cbr\u003e\u003ca href=\"https://cover.lnk.to/qmePp8\" target=\"_blank\"\u003ehttps://cover.lnk.to/qmePp8\u003c/a\u003e             \u003cbr\u003e\u003cbr\u003e🔽CD受付開始！\u003cbr\u003e\u003ca href=\"https://shop.hololivepro.com/products/hoshimaticproject_beepbeep\" target=\"_blank\"\u003ehttps://shop.hololivepro.com/products/hoshimaticproject_beepbeep\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e\u003cbr\u003eVocal：Hoshimatic Project\u003cbr\u003eHoshimachi Suisei\u003cbr\u003eTokino Sora\u003cbr\u003eNatsuiro Matsuri\u003cbr\u003eAki Rosenthal\u003cbr\u003eOozora Subaru\u003cbr\u003eTokoyami Towa\u003cbr\u003eMomosuzu Nene\u003cbr\u003eHakui Koyori\u003cbr\u003eKazama Iroha\u003cbr\u003e\u003cbr\u003eLyrics by： Anna Kusakawa\u003cbr\u003eComposed by： Anna Kusakawa, KISSY\u003cbr\u003eArranged by： KISSY\u003cbr\u003eMixed by：NNZN\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e-----------------\u003cbr\u003e📹MV staff\u003cbr\u003e\u003cbr\u003eProducer：Takashi Kawamura(GEEK PICTURES)\u003cbr\u003eDirector：ina(entity)\u003cbr\u003eAnimator：\u003cbr\u003eHiroaki Osawa(entity)\u003cbr\u003eAkira Takayanagi(Flying Ship Studio, Inc.)\u003cbr\u003eKazumasa Takahashi(Flying Ship Studio, Inc.)\u003cbr\u003e\u003cbr\u003eProduction Assistant：Chizu Suzuki(Flying Ship Studio, Inc.)\u003cbr\u003eAssistant Producer：Rie Aratani(entity)\u003cbr\u003eProducer：Takako Kanda(entity)\u003cbr\u003e        \u003cbr\u003eLead Modeler：Masashi Miyaoka\u003cbr\u003eModeler：Yozo Uchiyama\u003cbr\u003eRigger：Shohei Chino\u003cbr\u003eSticker Design：Chihirock\u003cbr\u003e        \u003cbr\u003eChief Motion Caputure Designer：Takahide Shinohara(TOEI ZUKUN LABORATORY)\u003cbr\u003eLead Motion Caputure Designer：\u003cbr\u003eKouta Isomura(TOEI ZUKUN LABORATORY)\u003cbr\u003eRina Sawada(TOEI ZUKUN LABORATORY)\u003cbr\u003eMotion Caputure Designer：\u003cbr\u003eDaiki Yonezawa(TOEI ZUKUN LABORATORY)\u003cbr\u003eShiori Tagawa(TOEI ZUKUN LABORATORY)\u003cbr\u003eEmi Matsumoto(TOEI ZUKUN LABORATORY)\u003cbr\u003eMiku Kuragane(TOEI ZUKUN LABORATORY)\u003cbr\u003eKana Numasato(TOEI ZUKUN LABORATORY)\u003cbr\u003eRyo Hasebe(TOEI ZUKUN LABORATORY)\u003cbr\u003e\u003cbr\u003eProject Manager：Miyu Omoto(TOEI ZUKUN LABORATORY)\u003cbr\u003eProducer：Sawami Takahashi(TOEI ZUKUN LABORATORY)\u003cbr\u003e      \u003cbr\u003eSound Effects：Shuji Suzuki(SuZooki)\u003cbr\u003eProduction Coordinator：Takayoshi Iwata(ARK inc.)\u003cbr\u003eEditor：Tomojiro Fujiki(ARK inc.)\u003cbr\u003e-----------------\u003cbr\u003e💃Choreography\u003cbr\u003e\u003cbr\u003eChoreography：Miyuki Nishijima\u003cbr\u003eGeneral Supervision：        \u003cbr\u003eSupervision：MaiMai：FIREWORKS Co., Ltd.\u003cbr\u003eAssistant：FIREWORKS DANCERS\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e🎨Illustration\u003cbr\u003eCostume design：さえきやひろ\u003cbr\u003e\u003cbr\u003eJacket Illustration：犬乃ぴすけ\u003cbr\u003e\u003cbr\u003eFinal drawings：\u003cbr\u003e株式会社サーチフィールド\u003cbr\u003e\u003cbr\u003e壱十九\u003cbr\u003eかしなーた\u003cbr\u003eshita\u003cbr\u003e福本もこ\u003cbr\u003eわなつ\u003cbr\u003etaron\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e※ホロライブプロダクションから未成年の視聴者の方々へのお願い\u003cbr\u003e[カバー 未成年者の方々へ]で検索してお読みいただくか、下記リンクをご確認の上、お楽しみください。\u003cbr\u003e\u003ca href=\"https://hololivepro.com/request-to-minors/\" target=\"_blank\"\u003ehttps://hololivepro.com/request-to-minors/\u003c/a\u003e"
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/kPqmld3_lSs/maxresdefault.jpg",
      "publishedAt": "2026-04-17T12:00:06Z"
    },
    {
      "youtubeId": "Ig7_D9uPH10",
      "originalName": {
        "ja": "Present Day (Live ver. Tokoyami Towa 2nd Live “SHINier”@有明アリーナ)",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "Present Day (Live ver. Tokoyami Towa 2nd Live “SHINier”@有明アリーナ)",
        "en": "",
        "kr": ""
      },
      "artist": "常闇トワ",
      "viewCount": 30344,
      "likeCount": 1275,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": [
        "古閑翔平"
      ],
      "composition": [
        "古閑翔平"
      ],
      "arrangement": [
        "YOURNESS"
      ],
      "isAvailableMV": false,
      "release": [
        "シルベ"
      ],
      "releaseAt": "2026/03/25",
      "order": 2,
      "type": "original",
      "descriptionHtml": {
        "ja": "Provided to YouTube by hololive RECORDS\u003cbr\u003e\u003cbr\u003ePresent Day (Live ver. Tokoyami Towa 2nd Live “SHINier”@有明アリーナ) · Tokoyami Towa · Shohei Koga(YOURNESS) · Shohei Koga(YOURNESS) · Shohei Koga(YOURNESS)\u003cbr\u003e\u003cbr\u003eShirube\u003cbr\u003e\u003cbr\u003eReleased on: 2026-03-25\u003cbr\u003e\u003cbr\u003eAuto-generated by YouTube.",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/Ig7_D9uPH10/maxresdefault.jpg",
      "publishedAt": "2026-03-24T15:00:27Z"
    },
    {
      "youtubeId": "eUmwR0x55JU",
      "originalName": {
        "ja": "シルベ / 常闇トワ (official)",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "シルベ",
        "en": "",
        "kr": ""
      },
      "artist": "常闇トワ",
      "viewCount": 1439180,
      "likeCount": 45484,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": [
        "古閑翔平(YOURNESS)"
      ],
      "composition": [
        "古閑翔平(YOURNESS)"
      ],
      "arrangement": [
        "古閑翔平(YOURNESS)"
      ],
      "isAvailableMV": true,
      "release": [
        "シルベ"
      ],
      "releaseAt": "2026/01/04",
      "order": 1,
      "type": "original",
      "descriptionHtml": {
        "ja": "選んできた 道のりを、今を\u003cbr\u003eいずれ後悔してしまう時が来ても\u003cbr\u003e私はまだ止まらない\u003cbr\u003e\u003cbr\u003e-------\u003cbr\u003e\u003cbr\u003e▼楽曲配信リンク\u003cbr\u003e常闇トワ『シルベ』\u003cbr\u003e\u003ca href=\"https://cover.lnk.to/kWY400\" target=\"_blank\"\u003ehttps://cover.lnk.to/kWY400\u003c/a\u003e\u003cbr\u003e\u003cbr\u003eTVアニメ『勇者パーティを追い出された器用貧乏』オープニングテーマ\u003cbr\u003e\u003ca href=\"https://kiyou-bimbou.com/\" target=\"_blank\"\u003ehttps://kiyou-bimbou.com/\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e『 シルベ 』シングルCD\u003cbr\u003e　各店舗購入リンク\u003cbr\u003e　\u003ca href=\"https://cover.lnk.to/Shirube\" target=\"_blank\"\u003ehttps://cover.lnk.to/Shirube\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e　ホロライブEC限定/通常盤まとめ\u003cbr\u003e　\u003ca href=\"https://shop.hololivepro.com/search?q=single_shirube\" target=\"_blank\"\u003ehttps://shop.hololivepro.com/search?q=single_shirube\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e　　▷ホロライブEC\u003cbr\u003e　💿️限定盤\u003cbr\u003e　JP：\u003ca href=\"https://shop.hololivepro.com/products/tokoyamitowa_shirube_limited\" target=\"_blank\"\u003ehttps://shop.hololivepro.com/products/tokoyamitowa_shirube_limited\u003c/a\u003e\u003cbr\u003e　EN：\u003ca href=\"https://shop.hololivepro.com/en/products/tokoyamitowa_shirube_limited\" target=\"_blank\"\u003ehttps://shop.hololivepro.com/en/products/tokoyamitowa_shirube_limited\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e　📀通常盤\u003cbr\u003e　JP：\u003ca href=\"https://shop.hololivepro.com/products/tokoyamitowa_shirube_regular\" target=\"_blank\"\u003ehttps://shop.hololivepro.com/products/tokoyamitowa_shirube_regular\u003c/a\u003e\u003cbr\u003e　EN：\u003ca href=\"https://shop.hololivepro.com/en/products/tokoyamitowa_shirube_regular\" target=\"_blank\"\u003ehttps://shop.hololivepro.com/en/products/tokoyamitowa_shirube_regular\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e-------\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e常闇トワ\u003cbr\u003e\u003ca href=\"https://x.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://x.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e作詞：古閑翔平(YOURNESS)\u003cbr\u003e作曲：古閑翔平(YOURNESS)\u003cbr\u003e編曲：古閑翔平(YOURNESS)\u003cbr\u003eguitar \u0026 backing vocals：黒川侑司(YOURNESS)\u003cbr\u003eguitar \u0026 programming：古閑翔平(YOURNESS)\u003cbr\u003ebass：田中雄大(YOURNESS)\u003cbr\u003edrums：小野貴寛(YOURNESS)\u003cbr\u003epiano arrangement：  宗正恭平\u003cbr\u003estrings arrangement：荒井沙会子（yusa）\u003cbr\u003eRecording Engineer：村上宣之\u003cbr\u003eMIX Engineer：MEG (MEGMETAL)\u003cbr\u003e\u003cbr\u003e監督・コンテ・演出：二村寧々\u003cbr\u003e\u003cbr\u003eキャラクターデザイン・作画監督：安武航\u003cbr\u003eサブキャラクターデザイン・作画監督：山澤純玲\u003cbr\u003e武器デザイン：髙田晃\u003cbr\u003eメカデザイン：山本もも\u003cbr\u003e動画検査：藤縄玲\u003cbr\u003e色彩設計・色指定・検査：吉田小百合\u003cbr\u003e美術監督：吉原俊一郎\u003cbr\u003e美術設定：蜂谷祥平\u003cbr\u003e撮影監督・3Dディレクター：河原秀樹\u003cbr\u003e編集：三嶋章紀\u003cbr\u003e\u003cbr\u003e作画監督：安部裕香\u003cbr\u003e\u003cbr\u003e原画：安武航, 小林美範, 栗原裕明, 羽根田弓子, 岡田あてな, 楠橋さつき, 中村里佳子, 飯田海, 三栄雪, 江禹辰 (rhinokino), 村上彩香, 西村祐希, 横山未来, 藤田理玖, 保村成, 斎藤敦史, magoyama, 安部裕香, テナテル, 太田衣美, 大釜沙也佳（ガイナックス京都）, 池原菜緒（ガイナックス京都）, 垣内沙耶香（ガイナックス京都）\u003cbr\u003e\u003cbr\u003e第二原画：藤縄玲, 阿部琴美, 覺張侑紀, 中村叶子, 櫻井多瑛, シーシャンシュン, ムサ・ワーリッド（rhinokino）, 植村みのり（rhinokino）, Shelia Loewito（rhinokino）, 吉田乃亜（rhinokino）\u003cbr\u003e\u003cbr\u003e動画：GRAPH77 FA\u003cbr\u003e仕上げ：GRAPH77 FA\u003cbr\u003e\u003cbr\u003e背景：H.TUAN（美峰）, BAO THANG（美峰）, TRONG HIEU（美峰）, DUY AN（美峰）, PHUONG THUY（美峰）, NGOC HUYEN（美峰）, HONG TAM（美峰）, THANH TU（美峰）\u003cbr\u003e2D背景用3Ｄモデリング：三戸康史\u003cbr\u003e美術制作：大崎寛也（美峰）\u003cbr\u003e美術設定：むすひ\u003cbr\u003e\u003cbr\u003e3DCG：小林昇太郎（SYNCHROTRON）\u003cbr\u003e撮影：榊原卓（SYNCHROTRON）, 八木昌彦（CLIP + BISON）, 小松学（CLIP + BISON）, 大石智一（CLIP + BISON）\u003cbr\u003e撮影制作管理：山根雅之, イングキャンディス, 馬場貴子\u003cbr\u003e\u003cbr\u003eタイトルロゴデザイン：氏原ソウ\u003cbr\u003e\u003cbr\u003eオンライン編集：木村瞳（qooop）\u003cbr\u003e\u003cbr\u003eエグゼクティブプロデューサー：松村一人\u003cbr\u003eアニメーションプロデューサー：木田和哉\u003cbr\u003eアソシエイトプロデューサー・制作進行：川路ゆきの\u003cbr\u003e\u003cbr\u003e制作：STUDIO GRAPH77\u003cbr\u003e\u003cbr\u003e■special thanks\u003cbr\u003e常闇眷属\u003cbr\u003e\u003cbr\u003e--------------------------------\u003cbr\u003e※ホロライブプロダクションから未成年の視聴者の方々へのお願い\u003cbr\u003e[カバー 未成年者の方々へ]で検索してお読みいただくか、下記リンクをご確認の上、お楽しみください。\u003cbr\u003e\u003ca href=\"https://hololivepro.com/request-to-minors/\" target=\"_blank\"\u003ehttps://hololivepro.com/request-to-minors/\u003c/a\u003e\u003cbr\u003e--------------------------------\u003cbr\u003e\u003cbr\u003e#器用貧乏 #kiyoubimbou #anime",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/eUmwR0x55JU/maxresdefault.jpg",
      "publishedAt": "2026-01-03T12:00:06Z"
    },
    {
      "youtubeId": "darS1jexgTw",
      "originalName": {
        "ja": "TRUTH",
        "en": "TRUTH",
        "kr": ""
      },
      "displayName": {
        "ja": "TRUTH",
        "en": "",
        "kr": ""
      },
      "artist": "常闇トワ",
      "viewCount": 306867,
      "likeCount": 3202,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": [
        "YAMAAD"
      ],
      "composition": [
        "YAMAAD"
      ],
      "arrangement": [
        "YAMAAD"
      ],
      "isAvailableMV": false,
      "release": [
        "SHIN"
      ],
      "releaseAt": "2025/10/08",
      "order": 7,
      "type": "original",
      "descriptionHtml": {
        "ja": "Provided to YouTube by hololive RECORDS\u003cbr\u003e\u003cbr\u003eTRUTH · Tokoyami Towa · YAMAAD · YAMAAD · YAMAAD\u003cbr\u003e\u003cbr\u003eSHIN\u003cbr\u003e\u003cbr\u003eReleased on: 2025-10-08\u003cbr\u003e\u003cbr\u003eAuto-generated by YouTube.",
        "en": "Provided to YouTube by hololive RECORDS\u003cbr\u003e\u003cbr\u003eTRUTH · Tokoyami Towa · YAMAAD · YAMAAD · YAMAAD\u003cbr\u003e\u003cbr\u003eSHIN\u003cbr\u003e\u003cbr\u003eReleased on: 2025-10-08\u003cbr\u003e\u003cbr\u003eAuto-generated by YouTube.",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/darS1jexgTw/maxresdefault.jpg",
      "publishedAt": "2025-10-07T15:01:07Z"
    },
    {
      "youtubeId": "3pUNgLPyjPM",
      "originalName": {
        "ja": "不可視 / 常闇トワ (official)",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "不可視",
        "en": "",
        "kr": ""
      },
      "artist": "常闇トワ",
      "viewCount": 946839,
      "likeCount": 32073,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": [
        "ユリイ・カノン"
      ],
      "composition": [
        "ユリイ・カノン"
      ],
      "arrangement": [
        "廣澤優也"
      ],
      "isAvailableMV": true,
      "release": [
        "SHIN"
      ],
      "releaseAt": "2025/10/08",
      "order": 5,
      "type": "original",
      "descriptionHtml": {
        "ja": "【 進 】\u003cbr\u003e私も怖いけど　君がいれば、 \u003cbr\u003e\u003cbr\u003e-------\u003cbr\u003e\u003cbr\u003e▼楽曲配信リンク\u003cbr\u003e常闇トワ『SHIN』\u003cbr\u003e\u003ca href=\"https://cover.lnk.to/SHIN\" target=\"_blank\"\u003ehttps://cover.lnk.to/SHIN\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e👾Tokoyami Towa 2nd Live \"SHINier\"👾\u003cbr\u003e2025年10月29日 (水) ～アーカイブ配信中❕️\u003cbr\u003e\u003ca href=\"https://shinier.hololivepro.com/\" target=\"_blank\"\u003ehttps://shinier.hololivepro.com/\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e🎫配信チケットページ\u003cbr\u003e・JP ：\u003ca href=\"https://shinier.hololivepro.com/ticket\" target=\"_blank\"\u003ehttps://shinier.hololivepro.com/ticket\u003c/a\u003e\u003cbr\u003e・EN：\u003ca href=\"https://shinier.hololivepro.com/ticket-en\" target=\"_blank\"\u003ehttps://shinier.hololivepro.com/ticket-en\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e-------\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e常闇トワ\u003cbr\u003e\u003ca href=\"https://x.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://x.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e\u003cbr\u003eLyrics：YURRY CANON\u003cbr\u003eComposition：YURRY CANON\u003cbr\u003eArrangement：Yuya Hirosawa\u003cbr\u003e\u003cbr\u003e\u003cbr\u003eDirector：mino(NANON CREATIVE)\u003cbr\u003e\u003cbr\u003eDirector of Photography：Kazuya Nakamura\u003cbr\u003e\u003cbr\u003eCharacter Design：goru\u003cbr\u003e\u003cbr\u003eVFX Director：mino (NANON CREATIVE)\u003cbr\u003eProduction Manager：payaco (NANON CREATIVE)\u003cbr\u003eVFX Production：NANON CREATIVE\u003cbr\u003e\u003cbr\u003eAnimation Director：goru\u003cbr\u003eAnimator：Uekibachi Kingyo , Ozido , Gaako , Kyuwan Choi , kk , COU , goru , Tsukimaro , Miyako Ameko , Meri , YOOKI , Luxe\u003cbr\u003e\u003cbr\u003eAnimation Producer：Yukina Hayashi (SAMA)\u003cbr\u003eAnimation Production：SAMA\u003cbr\u003e\u003cbr\u003eProduction Manager：Yamato Hara\u003cbr\u003eCreative Producer：Keita Sugai (Cyran)\u003cbr\u003eProduction：Cyran \u003cbr\u003e\u003cbr\u003e字幕：\u003cbr\u003eBigsky Sunshine, \u003cbr\u003eLamine\u003cbr\u003e( \u003ca href=\"https://x.com/La_mi_ne\" target=\"_blank\"\u003ehttps://x.com/La_mi_ne\u003c/a\u003e )\u003cbr\u003eT-chan \u003cbr\u003e\u003cbr\u003e■special thanks\u003cbr\u003e常闇眷属\u003cbr\u003e--------------------------------\u003cbr\u003e※ホロライブプロダクションから未成年の視聴者の方々へのお願い\u003cbr\u003e[カバー 未成年者の方々へ]で検索してお読みいただくか、下記リンクをご確認の上、お楽しみください。\u003cbr\u003e\u003ca href=\"https://hololivepro.com/request-to-minors/\" target=\"_blank\"\u003ehttps://hololivepro.com/request-to-minors/\u003c/a\u003e\u003cbr\u003e--------------------------------",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/3pUNgLPyjPM/maxresdefault.jpg",
      "publishedAt": "2025-11-02T10:00:06Z"
    },
    {
      "youtubeId": "q9cnZ9Uz_fw",
      "originalName": {
        "ja": "処方箋",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "処方箋",
        "en": "",
        "kr": ""
      },
      "artist": "常闇トワ",
      "viewCount": 401793,
      "likeCount": 3399,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": [
        "和ぬか"
      ],
      "composition": [
        "和ぬか"
      ],
      "arrangement": [
        "100回嘔吐・和ぬか"
      ],
      "isAvailableMV": false,
      "release": [
        "SHIN"
      ],
      "releaseAt": "2025/10/08",
      "order": 2,
      "type": "original",
      "descriptionHtml": {
        "ja": "Provided to YouTube by hololive RECORDS\u003cbr\u003e\u003cbr\u003e処方箋 · Tokoyami Towa · Wanuka · Wanuka · 100kai out · Wanuka\u003cbr\u003e\u003cbr\u003eSHIN\u003cbr\u003e\u003cbr\u003eReleased on: 2025-10-08\u003cbr\u003e\u003cbr\u003eAuto-generated by YouTube.",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/q9cnZ9Uz_fw/maxresdefault.jpg",
      "publishedAt": "2025-10-07T15:01:36Z"
    },
    {
      "youtubeId": "c2hP0qWGgaA",
      "originalName": {
        "ja": "凛",
        "en": "凛",
        "kr": ""
      },
      "displayName": {
        "ja": "凛",
        "en": "",
        "kr": ""
      },
      "artist": "常闇トワ",
      "viewCount": 436132,
      "likeCount": 4300,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": [
        "鈴木エレカ"
      ],
      "composition": [
        "鈴木エレカ・めんま"
      ],
      "arrangement": [
        "めんま"
      ],
      "isAvailableMV": false,
      "release": [
        "SHIN"
      ],
      "releaseAt": "2025/10/08",
      "order": 3,
      "type": "original",
      "descriptionHtml": {
        "ja": "Provided to YouTube by hololive RECORDS\u003cbr\u003e\u003cbr\u003e凛 · Tokoyami Towa · Ereca Suzuki · Ereca Suzuki · Menma · Menma\u003cbr\u003e\u003cbr\u003eSHIN\u003cbr\u003e\u003cbr\u003eReleased on: 2025-10-08\u003cbr\u003e\u003cbr\u003eAuto-generated by YouTube.",
        "en": "Provided to YouTube by hololive RECORDS\u003cbr\u003e\u003cbr\u003e凛 · Tokoyami Towa · Ereca Suzuki · Ereca Suzuki · Menma · Menma\u003cbr\u003e\u003cbr\u003eSHIN\u003cbr\u003e\u003cbr\u003eReleased on: 2025-10-08\u003cbr\u003e\u003cbr\u003eAuto-generated by YouTube.",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/c2hP0qWGgaA/maxresdefault.jpg",
      "publishedAt": "2025-10-07T15:01:07Z"
    },
    {
      "youtubeId": "2zTR_E0MMXg",
      "originalName": {
        "ja": "心の在処はすぐ傍に",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "心の在処はすぐ傍に",
        "en": "",
        "kr": ""
      },
      "artist": "常闇トワ",
      "viewCount": 587465,
      "likeCount": 6051,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": [
        "瀬名航"
      ],
      "composition": [
        "瀬名航"
      ],
      "arrangement": [
        "瀬名航"
      ],
      "isAvailableMV": false,
      "release": [
        "SHIN"
      ],
      "releaseAt": "2025/10/08",
      "order": 1,
      "type": "original",
      "descriptionHtml": {
        "ja": "Provided to YouTube by hololive RECORDS\u003cbr\u003e\u003cbr\u003e心の在処はすぐ傍に · Tokoyami Towa · Wataru Sena · Wataru Sena · Wataru Sena\u003cbr\u003e\u003cbr\u003eSHIN\u003cbr\u003e\u003cbr\u003eReleased on: 2025-10-08\u003cbr\u003e\u003cbr\u003eAuto-generated by YouTube.",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/2zTR_E0MMXg/maxresdefault.jpg",
      "publishedAt": "2025-10-07T15:00:11Z"
    },
    {
      "youtubeId": "l5I-Gg9AkSE",
      "originalName": {
        "ja": "命の洗濯",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "命の洗濯",
        "en": "",
        "kr": ""
      },
      "artist": "常闇トワ",
      "viewCount": 426759,
      "likeCount": 4814,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": [
        "ヒグチアイ"
      ],
      "composition": [
        "ヒグチアイ"
      ],
      "arrangement": [
        "兼松衆"
      ],
      "isAvailableMV": false,
      "release": [
        "SHIN"
      ],
      "releaseAt": "2025/10/08",
      "order": 9,
      "type": "original",
      "descriptionHtml": {
        "ja": "Provided to YouTube by hololive RECORDS\u003cbr\u003e\u003cbr\u003e命の洗濯 · Tokoyami Towa · Ai Higuchi · Ai Higuchi · Shu Kanematsu\u003cbr\u003e\u003cbr\u003eSHIN\u003cbr\u003e\u003cbr\u003eReleased on: 2025-10-08\u003cbr\u003e\u003cbr\u003eAuto-generated by YouTube.",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/l5I-Gg9AkSE/maxresdefault.jpg",
      "publishedAt": "2025-10-07T15:01:29Z"
    },
    {
      "youtubeId": "5kSJOT5hOVo",
      "originalName": {
        "ja": "New Order / 常闇トワ (official)",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "New Order",
        "en": "",
        "kr": ""
      },
      "artist": "常闇トワ",
      "viewCount": 869750,
      "likeCount": 38400,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": [
        "R・O・N"
      ],
      "composition": [
        "R・O・N"
      ],
      "arrangement": [
        "R・O・N"
      ],
      "isAvailableMV": true,
      "release": [
        "SHIN"
      ],
      "releaseAt": "2025/10/08",
      "order": 10,
      "type": "original",
      "descriptionHtml": {
        "ja": "【 新 】\u003cbr\u003eいつだって遅くはないんだ\u003cbr\u003e\u003cbr\u003e-------\u003cbr\u003e\u003cbr\u003e▼楽曲配信リンク\u003cbr\u003e常闇トワ『SHIN』\u003cbr\u003e\u003ca href=\"https://cover.lnk.to/SHIN\" target=\"_blank\"\u003ehttps://cover.lnk.to/SHIN\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e👾Tokoyami Towa 2nd Live \"SHINier\"👾\u003cbr\u003e2025年10月29日 (水) に有明アリーナにて開催！\u003cbr\u003e\u003ca href=\"https://shinier.hololivepro.com/\" target=\"_blank\"\u003ehttps://shinier.hololivepro.com/\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e🎫配信チケットページ\u003cbr\u003e・JP ：\u003ca href=\"https://shinier.hololivepro.com/ticket\" target=\"_blank\"\u003ehttps://shinier.hololivepro.com/ticket\u003c/a\u003e\u003cbr\u003e・EN：\u003ca href=\"https://shinier.hololivepro.com/ticket-en\" target=\"_blank\"\u003ehttps://shinier.hololivepro.com/ticket-en\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e-------\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e常闇トワ\u003cbr\u003e\u003ca href=\"https://x.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://x.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■作詞・作曲・編曲\u003cbr\u003eR・O・N 様\u003cbr\u003e\u003ca href=\"https://x.com/RON_SDF\" target=\"_blank\"\u003ehttps://x.com/RON_SDF\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Chorus\u003cbr\u003e白上フブキ @ShirakamiFubuki \u003cbr\u003e大神ミオ \u003ca href=\"https://www.youtube.com/@OokamiMio\" target=\"_blank\"\u003e@OokamiMio\u003c/a\u003e \u003cbr\u003e角巻わため \u003ca href=\"https://www.youtube.com/@TsunomakiWatame\" target=\"_blank\"\u003e@TsunomakiWatame\u003c/a\u003e \u003cbr\u003e鷹嶺ルイ \u003ca href=\"https://www.youtube.com/@TakaneLui\" target=\"_blank\"\u003e@TakaneLui\u003c/a\u003e \u003cbr\u003e\u003cbr\u003e-------\u003cbr\u003e\u003cbr\u003eAll Instruments：R・O・N\u003cbr\u003eVocal Direction：磯野涼（TRIFRONTIER）\u003cbr\u003eVocal Rec Engineer：丸岡詩織\u003cbr\u003eMix Engineer：中村悠二（VERYGOO）\u003cbr\u003e\u003cbr\u003eプロデューサー：本間 綾一郎（HATCH）\u003cbr\u003eプロダクションマネージャー：市川 剛 / 木下 賢治\u003cbr\u003eプロダクションアシスタント：加藤 カイ / 青山 実樹 / 原田 季和\u003cbr\u003eプロダクション：Creative Hub Swimmy\u003cbr\u003eディレクター：前川 達哉（Creative Hub Swimmy）\u003cbr\u003e助監督：石井 純\u003cbr\u003e\u003cbr\u003e出演：常闇トワ\u003cbr\u003eコレオグラファー：そらん\u003cbr\u003eサブキャスト：秋穂 / ゆうり / 岡村 咲良 / 高木 和\u003cbr\u003eサブキャスト（Gt）：寺澤 虹太 / 藤井 凱也\u003cbr\u003eサブキャスト（Key）：mii\u003cbr\u003eサブキャスト（Ba）：碧\u003cbr\u003eサブキャスト（Dr）：小野寺 啓斗\u003cbr\u003e\u003cbr\u003e撮影監督（DoP）：後藤 武浩 / 中島 唱太\u003cbr\u003eアシスタントカメラ（AC）：吉田 悠太 / 玉貴 州統\u003cbr\u003e照明技師：森下 義之（みこし）\u003cbr\u003e照明チーフ：佐藤 秀峰（みこし）\u003cbr\u003e照明助手：桃塚 健誠 / 文 浩峰\u003cbr\u003e\u003cbr\u003eカラーリスト：根本 恒（KASSEN）\u003cbr\u003eオンライン編集 管理：石ヶ谷宜昭\u003cbr\u003eオンライン編集：金野淳也 / 白﨑誠二 / 石井豪流\u003cbr\u003eタイトルデザイン：前田 定則\u003cbr\u003e\u003cbr\u003eスタイリスト：八木 啓紀\u003cbr\u003eヘアメイク：箙 あおい / 山下 奈巳\u003cbr\u003e衣装協力：dexi\u003cbr\u003eエキストラ協力：国本学園吹奏楽部 / 常闇眷属エキストラの皆さま\u003cbr\u003e\u003cbr\u003eアニメーション制作：bees inc.\u003cbr\u003eアニメーションディレクター / 演出：のをか（STUDIO NOWOKA-bees inc.）\u003cbr\u003eアニメーションプロデューサー：YAMAAD（bees inc.）\u003cbr\u003e総作画監督 / キャラクターデザイン：my0nruri（bees inc.）\u003cbr\u003eキャラクターデザイン原案：猫山 桜梨（bees inc.）\u003cbr\u003e制作進行：ふな（bees.inc）\u003cbr\u003e\u003cbr\u003e撮影： 中垣内 悠（Folium）\u003cbr\u003e\u003cbr\u003eCG アーティスト：井上 凱 / 金谷 健太郎\u003cbr\u003e\u003cbr\u003e制作協力：スペースネコカンパニー\u003cbr\u003e演出補佐： 青木 純（SPACE NEKO COMPANY）\u003cbr\u003e作画監督：松田 K子（SPACE NEKO COMPANY）/ 梁 佳緒里（SPACE NEKO COMPANY）\u003cbr\u003eLO・第二原画：陳 希（SPACE NEKO COMPANY）/ 黄 思敏  (SPACE NEKO COMPANY)\u003cbr\u003eLO：劉 洋（SPACE NEKO COMPANY）/ 吉 兆祺（SPACE NEKO COMPANY）/ 李 叔芹（SPACE NEKO COMPANY）\u003cbr\u003e第二原画：卓 桜子（SPACE NEKO COMPANY）\u003cbr\u003e制作進行：日髙 みどり（SPACE NEKO COMPANY）\u003cbr\u003e\u003cbr\u003e動画：お水 / 木根渕 まさこ / 紺のプリン / しまうま / ネコウヤ / 野口　極 / やけん / ワア / ZYES / cacaotane / めだい / 森出虎\u003cbr\u003e\u003cbr\u003e仕上げ：上甲 愛士（hakumei）/ おーん（hakumei）/ 鈴ki / Mikuron / あけぼしあまね\u003cbr\u003e\u003cbr\u003e字幕：\u003cbr\u003eBigsky Sunshine\u003cbr\u003eLamine\u003cbr\u003e( \u003ca href=\"https://x.com/La_mi_ne\" target=\"_blank\"\u003ehttps://x.com/La_mi_ne\u003c/a\u003e )\u003cbr\u003eT-chan \u003cbr\u003e\u003cbr\u003e■special thanks\u003cbr\u003e常闇眷属\u003cbr\u003e--------------------------------\u003cbr\u003e※ホロライブプロダクションから未成年の視聴者の方々へのお願い\u003cbr\u003e[カバー 未成年者の方々へ]で検索してお読みいただくか、下記リンクをご確認の上、お楽しみください。\u003cbr\u003e\u003ca href=\"https://hololivepro.com/request-to-minors/\" target=\"_blank\"\u003ehttps://hololivepro.com/request-to-minors/\u003c/a\u003e\u003cbr\u003e--------------------------------",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/5kSJOT5hOVo/maxresdefault.jpg",
      "publishedAt": "2025-10-08T11:00:06Z"
    },
    {
      "youtubeId": "3nfkl8_tWM0",
      "originalName": {
        "ja": "【 MV 】君と明かした夜【 常闇トワ × 獅白ぼたん 】",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "君と明かした夜",
        "en": "",
        "kr": ""
      },
      "artist": "常闇トワ",
      "viewCount": 242950,
      "likeCount": 15802,
      "singers": [
        "tokoyamitowa",
        "shishirobotan"
      ],
      "lyrics": [
        "東京真中"
      ],
      "composition": [
        "東京真中"
      ],
      "arrangement": [
        "東京真中"
      ],
      "isAvailableMV": true,
      "release": [
        "君と明かした夜"
      ],
      "releaseAt": "2025/09/02",
      "order": 1,
      "type": "original",
      "descriptionHtml": {
        "ja": "▼各種配信サイトでの視聴はこちら▼\u003cbr\u003e\u003ca href=\"https://cover.lnk.to/AAUyjV\" target=\"_blank\"\u003ehttps://cover.lnk.to/AAUyjV\u003c/a\u003e\u003cbr\u003e---\u003cbr\u003e週刊少年マガジン連載中『灰仭巫覡(カイジンフゲキ)』イメージソング\u003cbr\u003e\u003cbr\u003e▷Music▷\u003cbr\u003eVocal：常闇トワ、獅白ぼたん\u003cbr\u003eLyrics,Music,Arrangement : 東京真中\u003cbr\u003eStrings Arrangement, Violin, Viola, Cello: アーモンド\u003cbr\u003eBass: へくぼき\u003cbr\u003eElectric Piano: wagataki\u003cbr\u003eMixing Engineer : NNZN\u003cbr\u003e\u003cbr\u003e▷Music Video▷\u003cbr\u003eIllust：大暮維人\u003cbr\u003eMovie：kotose\u003cbr\u003e\u003cbr\u003e#hololive #hololiveRECORDS\u003cbr\u003e#常闇トワ #獅白ぼたん #灰仭巫覡\u003cbr\u003e\u003cbr\u003e\u003cbr\u003eホロライブ公式YouTubeチャンネル「メンバーシップ」では、ホロライブ公式YouTubeチャンネルに関連したコンテンツをお届けしています。\u003cbr\u003e\u003cbr\u003eデラックスプランでは、ホロライブメンバーが出演する2D・3D「限定コンテンツ」をご覧いただけます！\u003cbr\u003eその他、ホロぐらの一部先行公開やホロライブ事務所スタッフの限定配信なども視聴可能です！\u003cbr\u003eご加入はブラウザをご活用ください→ \u003ca href=\"https://www.youtube.com/channel/UCJFZiqLMntJufDCHc6bQixg/join\" target=\"_blank\"\u003ehttps://www.youtube.com/channel/UCJFZiqLMntJufDCHc6bQixg/join\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e▶配信を楽しんでいただくためのお願い/Rule▷\u003cbr\u003e・待機所やコメント欄は、お互いマナーを守ってご利用ください。\u003cbr\u003e・コメントやスーパーチャットがオンの時は、他の方のご迷惑になる言動はご遠慮ください。また、そのような言動に対して反応することもお控えください。\u003cbr\u003e- Please be respectful to others in stream waiting rooms and live chat.\u003cbr\u003e- When comments or Super Chats are enabled, please refrain from sending inappropriate messages or responding to such messages.\u003cbr\u003e\u003cbr\u003e-----\u003cbr\u003e※ホロライブプロダクションから未成年の視聴者の方々へのお願い\u003cbr\u003e下記リンクをご確認の上、お楽しみください。\u003cbr\u003e\u003ca href=\"https://www.hololive.tv/request-to-minors\" target=\"_blank\"\u003ehttps://www.hololive.tv/request-to-minors\u003c/a\u003e",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/3nfkl8_tWM0/maxresdefault.jpg",
      "publishedAt": "2025-09-02T11:00:07Z"
    },
    {
      "youtubeId": "pTwFsTxsf4w",
      "originalName": {
        "ja": "「パンダヒーロー」 - 音乃瀬奏＆星街すいせい＆常闇トワ＆角巻わため（cover）",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "パンダヒーロー",
        "en": "",
        "kr": ""
      },
      "artist": "ハチ",
      "viewCount": 6546268,
      "likeCount": 80542,
      "singers": [
        "otonosekanade",
        "hoshimachisuisei",
        "tokoyamitowa",
        "tsunomakiwatame"
      ],
      "lyrics": null,
      "composition": null,
      "arrangement": null,
      "isAvailableMV": true,
      "release": null,
      "releaseAt": "",
      "order": 0,
      "type": "cover",
      "descriptionHtml": {
        "ja": "歌いたかった曲を歌いたいメンバーで歌ってみました。\u003cbr\u003e\u003cbr\u003e-\u003cbr\u003e\u003cbr\u003eOriginal：ハチ MV「パンダヒーロー」HACHI / Panda Hero\u003cbr\u003e\u003ca href=\"https://youtu.be/0RU_05zpETo?si=GCrrJB7PXEx80Iu5\" target=\"_blank\"\u003ehttps://youtu.be/0RU_05zpETo?si=GCrrJB7PXEx80Iu5\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e#パンダヒーロー #ハチ #歌ってみた  \u003cbr\u003e\u003cbr\u003e-\u003cbr\u003e\u003cbr\u003eVocal：音乃瀬奏\u003cbr\u003eVocal：星街すいせい（ \u003ca href=\"https://www.youtube.com/@HoshimachiSuisei\" target=\"_blank\"\u003e@HoshimachiSuisei\u003c/a\u003e  ）\u003cbr\u003eVocal：常闇トワ（ \u003ca href=\"https://www.youtube.com/@TokoyamiTowa\" target=\"_blank\"\u003e@TokoyamiTowa\u003c/a\u003e  ）\u003cbr\u003eVocal：角巻わため（ \u003ca href=\"https://www.youtube.com/@TsunomakiWatame\" target=\"_blank\"\u003e@TsunomakiWatame\u003c/a\u003e  ）\u003cbr\u003e\u003cbr\u003eInst：快晴P（\u003ca href=\"https://x.com/KAISE_P\" target=\"_blank\"\u003ehttps://x.com/KAISE_P\u003c/a\u003e  ）\u003cbr\u003eIllust：ちゃっぴー（\u003ca href=\"https://x.com/Chapi__01\" target=\"_blank\"\u003ehttps://x.com/Chapi__01\u003c/a\u003e ）\u003cbr\u003eMovie：kotose（\u003ca href=\"https://x.com/ro_kotose\" target=\"_blank\"\u003ehttps://x.com/ro_kotose\u003c/a\u003e  ）\u003cbr\u003eMix：さんかくずわり（\u003ca href=\"https://x.com/Sankaku_Mix\" target=\"_blank\"\u003ehttps://x.com/Sankaku_Mix\u003c/a\u003e ）\u003cbr\u003e\u003cbr\u003e-\u003cbr\u003e\u003cbr\u003e※ホロライブプロダクションから未成年の視聴者の方々へのお願い\u003cbr\u003e[カバー 未成年者の方々へ]で検索してお読みいただくか、下記リンクをご確認の上、お楽しみください。\u003cbr\u003e\u003ca href=\"https://hololivepro.com/request-to-minors/\" target=\"_blank\"\u003ehttps://hololivepro.com/request-to-minors/\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e-\u003cbr\u003e\u003cbr\u003e[音乃瀬奏]\u003cbr\u003e\u003cbr\u003eX（Twitter） : \u003ca href=\"https://twitter.com/otonosekanade\" target=\"_blank\"\u003ehttps://twitter.com/otonosekanade\u003c/a\u003e\u003cbr\u003eYoutube : \u003ca href=\"https://www.youtube.com/@OtonoseKanade/?sub_confirmation=1\" target=\"_blank\"\u003ehttps://www.youtube.com/@OtonoseKanade/?sub_confirmation=1\u003c/a\u003e",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/pTwFsTxsf4w/maxresdefault.jpg",
      "publishedAt": "2025-08-09T09:00:07Z"
    },
    {
      "youtubeId": "din8MpMohyg",
      "originalName": {
        "ja": "ChewyChewy / 常闇トワ (official)",
        "en": "ChewyChewy / 常闇トワ (official)",
        "kr": "ChewyChewy / 常闇トワ (official)"
      },
      "displayName": {
        "ja": "ChewyChewy",
        "en": "",
        "kr": ""
      },
      "artist": "常闇トワ",
      "viewCount": 2251473,
      "likeCount": 54839,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": [
        "nqrse"
      ],
      "composition": [
        "nqrse"
      ],
      "arrangement": [
        "柿迫ヒカル"
      ],
      "isAvailableMV": true,
      "release": [
        "SHIN",
        "ChewyChewy"
      ],
      "releaseAt": "2025/08/09",
      "order": 6,
      "type": "original",
      "descriptionHtml": {
        "ja": "【 芯 】\u003cbr\u003eくだらねえ いつも笑って惑わせる\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e▼楽曲配信リンク\u003cbr\u003e\u003cbr\u003e2025年8月9日0:00 (2025年8月8日24:00）\u003cbr\u003e\u003cbr\u003e常闇トワ『ChewyChewy』\u003cbr\u003e\u003ca href=\"https://cover.lnk.to/dWnaPE\" target=\"_blank\"\u003ehttps://cover.lnk.to/dWnaPE\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e🎧2025年10月8日(水) Release 2nd Album『SHIN』🎧\u003cbr\u003e\u003ca href=\"https://cover.lnk.to/SHIN\" target=\"_blank\"\u003ehttps://cover.lnk.to/SHIN\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e👾Tokoyami Towa 2nd Live \"SHINier\"👾\u003cbr\u003e2025年10月29日 (水) に有明アリーナにて開催！\u003cbr\u003e\u003ca href=\"https://shinier.hololivepro.com/\" target=\"_blank\"\u003ehttps://shinier.hololivepro.com/\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e🎫現地チケット1次先行受付中！🎫\u003cbr\u003e【受付期間：2025年8月8日(金) 21:00 ～ 2025年8月17日(日) 23:59】\u003cbr\u003e▼現地/配信チケットページ\u003cbr\u003e・JP ：\u003ca href=\"https://shinier.hololivepro.com/ticket\" target=\"_blank\"\u003ehttps://shinier.hololivepro.com/ticket\u003c/a\u003e\u003cbr\u003e・EN：\u003ca href=\"https://shinier.hololivepro.com/ticket-en\" target=\"_blank\"\u003ehttps://shinier.hololivepro.com/ticket-en\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e♦ｰｰｰｰｰｰｰｰｰｰ♦\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e常闇トワ\u003cbr\u003e\u003ca href=\"https://x.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://x.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■作詞・作曲\u003cbr\u003enqrse 様\u003cbr\u003e\u003ca href=\"https://x.com/nqrse\" target=\"_blank\"\u003ehttps://x.com/nqrse\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■編曲\u003cbr\u003e柿迫ヒカル 様\u003cbr\u003e\u003cbr\u003e-------\u003cbr\u003e\u003cbr\u003e▼映像\u003cbr\u003eDirector, Editor, Compositor : Takahito Matsuno (maxilla)\u003cbr\u003eProducer : Seiya Suzuki (maxilla)\u003cbr\u003e\u003cbr\u003eTechnical Artist : Murasaqi (stu)\u003cbr\u003eTechnical Artist : Satoshi Okano (stu)\u003cbr\u003eTechnical Artist : Kuyuri Iroha\u003cbr\u003eCG Artist : Yamamoto\u003cbr\u003e\u003cbr\u003eAnimation Director : YORUGATA\u003cbr\u003eAnimation Producer : zohyo\u003cbr\u003eAnimator : Sakura Yamada, Luv, Sumisi Kazuhana\u003cbr\u003eColor Director : zohyo\u003cbr\u003ePainter : zohyo, trout, sukoyakakonbu, pechiko\u003cbr\u003e3DCG : lecter\u003cbr\u003e\u003cbr\u003eProduction : maxilla\u003cbr\u003eMotion Capture: STUDIO Soup.\u003cbr\u003e\u003cbr\u003e-------\u003cbr\u003e\u003cbr\u003e■special thanks\u003cbr\u003e常闇眷属\u003cbr\u003e\u003cbr\u003e--------------------------------\u003cbr\u003e※ホロライブプロダクションから未成年の視聴者の方々へのお願い\u003cbr\u003e下記リンクをご確認の上、お楽しみください。\u003cbr\u003e\u003ca href=\"https://www.hololive.tv/request-to-minors\" target=\"_blank\"\u003ehttps://www.hololive.tv/request-to-minors\u003c/a\u003e\u003cbr\u003e--------------------------------",
        "en": "【 芯 】\u003cbr\u003eくだらねえ いつも笑って惑わせる\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e▼楽曲配信リンク\u003cbr\u003e\u003cbr\u003e2025年8月9日0:00 (2025年8月8日24:00）\u003cbr\u003e\u003cbr\u003e常闇トワ『ChewyChewy』\u003cbr\u003e\u003ca href=\"https://cover.lnk.to/dWnaPE\" target=\"_blank\"\u003ehttps://cover.lnk.to/dWnaPE\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e🎧2025年10月8日(水) Release 2nd Album『SHIN』🎧\u003cbr\u003e\u003ca href=\"https://cover.lnk.to/SHIN\" target=\"_blank\"\u003ehttps://cover.lnk.to/SHIN\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e👾Tokoyami Towa 2nd Live \"SHINier\"👾\u003cbr\u003e2025年10月29日 (水) に有明アリーナにて開催！\u003cbr\u003e\u003ca href=\"https://shinier.hololivepro.com/\" target=\"_blank\"\u003ehttps://shinier.hololivepro.com/\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e🎫現地チケット1次先行受付中！🎫\u003cbr\u003e【受付期間：2025年8月8日(金) 21:00 ～ 2025年8月17日(日) 23:59】\u003cbr\u003e▼現地/配信チケットページ\u003cbr\u003e・JP ：\u003ca href=\"https://shinier.hololivepro.com/ticket\" target=\"_blank\"\u003ehttps://shinier.hololivepro.com/ticket\u003c/a\u003e\u003cbr\u003e・EN：\u003ca href=\"https://shinier.hololivepro.com/ticket-en\" target=\"_blank\"\u003ehttps://shinier.hololivepro.com/ticket-en\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e♦ｰｰｰｰｰｰｰｰｰｰ♦\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e常闇トワ\u003cbr\u003e\u003ca href=\"https://x.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://x.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■作詞・作曲\u003cbr\u003enqrse 様\u003cbr\u003e\u003ca href=\"https://x.com/nqrse\" target=\"_blank\"\u003ehttps://x.com/nqrse\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■編曲\u003cbr\u003e柿迫ヒカル 様\u003cbr\u003e\u003cbr\u003e-------\u003cbr\u003e\u003cbr\u003e▼映像\u003cbr\u003eDirector, Editor, Compositor : Takahito Matsuno (maxilla)\u003cbr\u003eProducer : Seiya Suzuki (maxilla)\u003cbr\u003e\u003cbr\u003eTechnical Artist : Murasaqi (stu)\u003cbr\u003eTechnical Artist : Satoshi Okano (stu)\u003cbr\u003eTechnical Artist : Kuyuri Iroha\u003cbr\u003eCG Artist : Yamamoto\u003cbr\u003e\u003cbr\u003eAnimation Director : YORUGATA\u003cbr\u003eAnimation Producer : zohyo\u003cbr\u003eAnimator : Sakura Yamada, Luv, Sumisi Kazuhana\u003cbr\u003eColor Director : zohyo\u003cbr\u003ePainter : zohyo, trout, sukoyakakonbu, pechiko\u003cbr\u003e3DCG : lecter\u003cbr\u003e\u003cbr\u003eProduction : maxilla\u003cbr\u003eMotion Capture: STUDIO Soup.\u003cbr\u003e\u003cbr\u003e-------\u003cbr\u003e\u003cbr\u003e■special thanks\u003cbr\u003e常闇眷属\u003cbr\u003e\u003cbr\u003e--------------------------------\u003cbr\u003e※ホロライブプロダクションから未成年の視聴者の方々へのお願い\u003cbr\u003e下記リンクをご確認の上、お楽しみください。\u003cbr\u003e\u003ca href=\"https://www.hololive.tv/request-to-minors\" target=\"_blank\"\u003ehttps://www.hololive.tv/request-to-minors\u003c/a\u003e\u003cbr\u003e--------------------------------",
        "kr": "【 芯 】\u003cbr\u003eくだらねえ いつも笑って惑わせる\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e▼楽曲配信リンク\u003cbr\u003e\u003cbr\u003e2025年8月9日0:00 (2025年8月8日24:00）\u003cbr\u003e\u003cbr\u003e常闇トワ『ChewyChewy』\u003cbr\u003e\u003ca href=\"https://cover.lnk.to/dWnaPE\" target=\"_blank\"\u003ehttps://cover.lnk.to/dWnaPE\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e🎧2025年10月8日(水) Release 2nd Album『SHIN』🎧\u003cbr\u003e\u003ca href=\"https://cover.lnk.to/SHIN\" target=\"_blank\"\u003ehttps://cover.lnk.to/SHIN\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e👾Tokoyami Towa 2nd Live \"SHINier\"👾\u003cbr\u003e2025年10月29日 (水) に有明アリーナにて開催！\u003cbr\u003e\u003ca href=\"https://shinier.hololivepro.com/\" target=\"_blank\"\u003ehttps://shinier.hololivepro.com/\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e🎫現地チケット1次先行受付中！🎫\u003cbr\u003e【受付期間：2025年8月8日(金) 21:00 ～ 2025年8月17日(日) 23:59】\u003cbr\u003e▼現地/配信チケットページ\u003cbr\u003e・JP ：\u003ca href=\"https://shinier.hololivepro.com/ticket\" target=\"_blank\"\u003ehttps://shinier.hololivepro.com/ticket\u003c/a\u003e\u003cbr\u003e・EN：\u003ca href=\"https://shinier.hololivepro.com/ticket-en\" target=\"_blank\"\u003ehttps://shinier.hololivepro.com/ticket-en\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e♦ｰｰｰｰｰｰｰｰｰｰ♦\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e常闇トワ\u003cbr\u003e\u003ca href=\"https://x.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://x.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■作詞・作曲\u003cbr\u003enqrse 様\u003cbr\u003e\u003ca href=\"https://x.com/nqrse\" target=\"_blank\"\u003ehttps://x.com/nqrse\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■編曲\u003cbr\u003e柿迫ヒカル 様\u003cbr\u003e\u003cbr\u003e-------\u003cbr\u003e\u003cbr\u003e▼映像\u003cbr\u003eDirector, Editor, Compositor : Takahito Matsuno (maxilla)\u003cbr\u003eProducer : Seiya Suzuki (maxilla)\u003cbr\u003e\u003cbr\u003eTechnical Artist : Murasaqi (stu)\u003cbr\u003eTechnical Artist : Satoshi Okano (stu)\u003cbr\u003eTechnical Artist : Kuyuri Iroha\u003cbr\u003eCG Artist : Yamamoto\u003cbr\u003e\u003cbr\u003eAnimation Director : YORUGATA\u003cbr\u003eAnimation Producer : zohyo\u003cbr\u003eAnimator : Sakura Yamada, Luv, Sumisi Kazuhana\u003cbr\u003eColor Director : zohyo\u003cbr\u003ePainter : zohyo, trout, sukoyakakonbu, pechiko\u003cbr\u003e3DCG : lecter\u003cbr\u003e\u003cbr\u003eProduction : maxilla\u003cbr\u003eMotion Capture: STUDIO Soup.\u003cbr\u003e\u003cbr\u003e-------\u003cbr\u003e\u003cbr\u003e■special thanks\u003cbr\u003e常闇眷属\u003cbr\u003e\u003cbr\u003e--------------------------------\u003cbr\u003e※ホロライブプロダクションから未成年の視聴者の方々へのお願い\u003cbr\u003e下記リンクをご確認の上、お楽しみください。\u003cbr\u003e\u003ca href=\"https://www.hololive.tv/request-to-minors\" target=\"_blank\"\u003ehttps://www.hololive.tv/request-to-minors\u003c/a\u003e\u003cbr\u003e--------------------------------"
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/din8MpMohyg/maxresdefault.jpg",
      "publishedAt": "2025-08-08T11:50:06Z"
    },
    {
      "youtubeId": "X2KpK47AacY",
      "originalName": {
        "ja": "【Mythmash】Queen of the Night - Mori Calliope x Tokoyami Towa",
        "en": "【Mythmash】Queen of the Night - Mori Calliope x Tokoyami Towa",
        "kr": ""
      },
      "displayName": {
        "ja": "Queen of the Night",
        "en": "",
        "kr": ""
      },
      "artist": "Mori Calliope \u0026 常闇トワ",
      "viewCount": 762805,
      "likeCount": 31417,
      "singers": [
        "moricalliope",
        "tokoyamitowa"
      ],
      "lyrics": [
        "Steph",
        "Berry Risa"
      ],
      "composition": [
        "Stand Alone",
        "Akane Nore"
      ],
      "arrangement": [
        "Stand Alone"
      ],
      "isAvailableMV": true,
      "release": [
        "Queen of the Night"
      ],
      "releaseAt": "2025/07/30",
      "order": 1,
      "type": "original",
      "descriptionHtml": {
        "ja": "streaming: \u003ca href=\"https://cover.lnk.to/eyHtsR\" target=\"_blank\"\u003ehttps://cover.lnk.to/eyHtsR\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e◆ CREDITS\u003cbr\u003e\u003cbr\u003eVocal: Mori Calliope \u0026 Tokoyami Towa\u003cbr\u003eLyrics: Steph, Berry Risa\u003cbr\u003eComposition: Stand Alone, Akane Nore\u003cbr\u003eProducer/Arrangement: Stand Alone\u003cbr\u003eMix: Shohei Ishikawa (ONEly inc.)\u003cbr\u003eIllustration: Gashino\u003cbr\u003eMV: お菊\u003cbr\u003e\u003cbr\u003e--------------------------------------------------------------\u003cbr\u003e\u003cbr\u003e▶Cast\u003cbr\u003e\u003ca href=\"https://www.youtube.com/@MoriCalliope\" target=\"_blank\"\u003ehttps://www.youtube.com/@MoriCalliope\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e◆OFFICIAL HASHTAG\u003cbr\u003e#mythmashchemythtry\u003cbr\u003e\u003cbr\u003e--------------------------------------------------------------\u003cbr\u003e\u003cbr\u003e◆hololive English ‐Myth‐\u003cbr\u003e\u003cbr\u003e▶ Mori Calliope\u003cbr\u003e\u003ca href=\"https://www.youtube.com/@MoriCalliope\" target=\"_blank\"\u003ehttps://www.youtube.com/@MoriCalliope\u003c/a\u003e\u003cbr\u003e\u003ca href=\"https://x.com/moricalliope\" target=\"_blank\"\u003ehttps://x.com/moricalliope\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e▶ Takanashi Kiara\u003cbr\u003e\u003ca href=\"https://www.youtube.com/@TakanashiKiara\" target=\"_blank\"\u003ehttps://www.youtube.com/@TakanashiKiara\u003c/a\u003e\u003cbr\u003e\u003ca href=\"https://x.com/takanashikiara\" target=\"_blank\"\u003ehttps://x.com/takanashikiara\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e▶ Ninomae Ina’nis\u003cbr\u003e\u003ca href=\"https://www.youtube.com/@NinomaeInanis\" target=\"_blank\"\u003ehttps://www.youtube.com/@NinomaeInanis\u003c/a\u003e\u003cbr\u003e\u003ca href=\"https://x.com/ninomaeinanis\" target=\"_blank\"\u003ehttps://x.com/ninomaeinanis\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e--------------------------------------------------------------\u003cbr\u003eFollow the official hololive English accounts!\u003cbr\u003e▶Official YouTube channel: \u003ca href=\"https://www.youtube.com/@hololiveEnglish\" target=\"_blank\"\u003ehttps://www.youtube.com/@hololiveEnglish\u003c/a\u003e\u003cbr\u003e▶Official X: \u003ca href=\"https://x.com/hololive_En\" target=\"_blank\"\u003ehttps://x.com/hololive_En\u003c/a\u003e\u003cbr\u003e▶Official Facebook: \u003ca href=\"https://www.facebook.com/hololivetv/\" target=\"_blank\"\u003ehttps://www.facebook.com/hololivetv/\u003c/a\u003e\u003cbr\u003e▶Official Instagram: \u003ca href=\"https://www.instagram.com/hololiveproduction_en/\" target=\"_blank\"\u003ehttps://www.instagram.com/hololiveproduction_en/\u003c/a\u003e\u003cbr\u003e▶Official TikTok: \u003ca href=\"https://www.tiktok.com/@hololive_english\" target=\"_blank\"\u003ehttps://www.tiktok.com/@hololive_english\u003c/a\u003e\u003cbr\u003e▶Official Reddit: \u003ca href=\"https://www.reddit.com/r/Hololive/\" target=\"_blank\"\u003ehttps://www.reddit.com/r/Hololive/\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e▶Request from hololive production to underage viewers:\u003cbr\u003ePlease be sure to check the link below before viewing our content.\u003cbr\u003e\u003ca href=\"https://hololivepro.com/en/request-to-minors/\" target=\"_blank\"\u003ehttps://hololivepro.com/en/request-to-minors/\u003c/a\u003e\u003cbr\u003e\u003cbr\u003eTranslations: Gomadare\u003cbr\u003eCaptions: T-chan",
        "en": "streaming: \u003ca href=\"https://cover.lnk.to/eyHtsR\" target=\"_blank\"\u003ehttps://cover.lnk.to/eyHtsR\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e◆ CREDITS\u003cbr\u003e\u003cbr\u003eVocal: Mori Calliope \u0026 Tokoyami Towa\u003cbr\u003eLyrics: Steph, Berry Risa\u003cbr\u003eComposition: Stand Alone, Akane Nore\u003cbr\u003eProducer/Arrangement: Stand Alone\u003cbr\u003eMix: Shohei Ishikawa (ONEly inc.)\u003cbr\u003eIllustration: Gashino\u003cbr\u003eMV: お菊\u003cbr\u003e\u003cbr\u003e--------------------------------------------------------------\u003cbr\u003e\u003cbr\u003e▶Cast\u003cbr\u003e\u003ca href=\"https://www.youtube.com/@MoriCalliope\" target=\"_blank\"\u003ehttps://www.youtube.com/@MoriCalliope\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e◆OFFICIAL HASHTAG\u003cbr\u003e#mythmashchemythtry\u003cbr\u003e\u003cbr\u003e--------------------------------------------------------------\u003cbr\u003e\u003cbr\u003e◆hololive English ‐Myth‐\u003cbr\u003e\u003cbr\u003e▶ Mori Calliope\u003cbr\u003e\u003ca href=\"https://www.youtube.com/@MoriCalliope\" target=\"_blank\"\u003ehttps://www.youtube.com/@MoriCalliope\u003c/a\u003e\u003cbr\u003e\u003ca href=\"https://x.com/moricalliope\" target=\"_blank\"\u003ehttps://x.com/moricalliope\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e▶ Takanashi Kiara\u003cbr\u003e\u003ca href=\"https://www.youtube.com/@TakanashiKiara\" target=\"_blank\"\u003ehttps://www.youtube.com/@TakanashiKiara\u003c/a\u003e\u003cbr\u003e\u003ca href=\"https://x.com/takanashikiara\" target=\"_blank\"\u003ehttps://x.com/takanashikiara\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e▶ Ninomae Ina’nis\u003cbr\u003e\u003ca href=\"https://www.youtube.com/@NinomaeInanis\" target=\"_blank\"\u003ehttps://www.youtube.com/@NinomaeInanis\u003c/a\u003e\u003cbr\u003e\u003ca href=\"https://x.com/ninomaeinanis\" target=\"_blank\"\u003ehttps://x.com/ninomaeinanis\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e--------------------------------------------------------------\u003cbr\u003eFollow the official hololive English accounts!\u003cbr\u003e▶Official YouTube channel: \u003ca href=\"https://www.youtube.com/@hololiveEnglish\" target=\"_blank\"\u003ehttps://www.youtube.com/@hololiveEnglish\u003c/a\u003e\u003cbr\u003e▶Official X: \u003ca href=\"https://x.com/hololive_En\" target=\"_blank\"\u003ehttps://x.com/hololive_En\u003c/a\u003e\u003cbr\u003e▶Official Facebook: \u003ca href=\"https://www.facebook.com/hololivetv/\" target=\"_blank\"\u003ehttps://www.facebook.com/hololivetv/\u003c/a\u003e\u003cbr\u003e▶Official Instagram: \u003ca href=\"https://www.instagram.com/hololiveproduction_en/\" target=\"_blank\"\u003ehttps://www.instagram.com/hololiveproduction_en/\u003c/a\u003e\u003cbr\u003e▶Official TikTok: \u003ca href=\"https://www.tiktok.com/@hololive_english\" target=\"_blank\"\u003ehttps://www.tiktok.com/@hololive_english\u003c/a\u003e\u003cbr\u003e▶Official Reddit: \u003ca href=\"https://www.reddit.com/r/Hololive/\" target=\"_blank\"\u003ehttps://www.reddit.com/r/Hololive/\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e▶Request from hololive production to underage viewers:\u003cbr\u003ePlease be sure to check the link below before viewing our content.\u003cbr\u003e\u003ca href=\"https://hololivepro.com/en/request-to-minors/\" target=\"_blank\"\u003ehttps://hololivepro.com/en/request-to-minors/\u003c/a\u003e\u003cbr\u003e\u003cbr\u003eTranslations: Gomadare\u003cbr\u003eCaptions: T-chan",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/X2KpK47AacY/maxresdefault.jpg",
      "publishedAt": "2025-07-29T13:40:06Z"
    },
    {
      "youtubeId": "uxjcPq0Y_IA",
      "originalName": {
        "ja": "バズビバザヴ / 常闇トワ (official)",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "バズビバザヴ",
        "en": "",
        "kr": ""
      },
      "artist": "常闇トワ",
      "viewCount": 1885468,
      "likeCount": 43771,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": [
        "てにをは"
      ],
      "composition": [
        "てにをは"
      ],
      "arrangement": [
        "てにをは"
      ],
      "isAvailableMV": true,
      "release": [
        "SHIN",
        "バズビバザヴ"
      ],
      "releaseAt": "2025/06/20",
      "order": 4,
      "type": "original",
      "descriptionHtml": {
        "ja": "【 神 】\u003cbr\u003e声合わせ唱えましょう\u003cbr\u003e\u003cbr\u003e-------\u003cbr\u003e\u003cbr\u003e▼楽曲配信リンク\u003cbr\u003e常闇トワ『バズビバザヴ』\u003cbr\u003e\u003ca href=\"https://cover.lnk.to/wQjgC3\" target=\"_blank\"\u003ehttps://cover.lnk.to/wQjgC3\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e🎧2025年10月8日(水) Release 2nd Album『SHIN』🎧\u003cbr\u003e\u003ca href=\"https://cover.lnk.to/SHIN\" target=\"_blank\"\u003ehttps://cover.lnk.to/SHIN\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e👾Tokoyami Towa 2nd Live \"SHINier\"👾\u003cbr\u003e2025年10月29日 (水) に有明アリーナにて開催！\u003cbr\u003e\u003ca href=\"https://shinier.hololivepro.com/\" target=\"_blank\"\u003ehttps://shinier.hololivepro.com/\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e🎫配信チケットページ\u003cbr\u003e・JP ：\u003ca href=\"https://shinier.hololivepro.com/ticket\" target=\"_blank\"\u003ehttps://shinier.hololivepro.com/ticket\u003c/a\u003e\u003cbr\u003e・EN：\u003ca href=\"https://shinier.hololivepro.com/ticket-en\" target=\"_blank\"\u003ehttps://shinier.hololivepro.com/ticket-en\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e-------\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e常闇トワ\u003cbr\u003e\u003ca href=\"https://x.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://x.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■作詞・作曲・編曲\u003cbr\u003eてにをは 様\u003cbr\u003e\u003ca href=\"https://x.com/edogawa_sampo\" target=\"_blank\"\u003ehttps://x.com/edogawa_sampo\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e-------\u003cbr\u003e\u003cbr\u003e・Mix\u003cbr\u003e　丸岡詩織\u003cbr\u003e\u003cbr\u003e・映像制作\u003cbr\u003e    スタジオ プリコンポーズ\u003cbr\u003e    (\u003ca href=\"https://x.com/SPP_precompose\" target=\"_blank\"\u003ehttps://x.com/SPP_precompose\u003c/a\u003e )\u003cbr\u003e\u003cbr\u003e・監督\u003cbr\u003e    StudioXD    (\u003ca href=\"https://x.com/Refineddium\" target=\"_blank\"\u003ehttps://x.com/Refineddium\u003c/a\u003e )\u003cbr\u003e・アニメーター\u003cbr\u003e    StudioXD\u003cbr\u003e    匿名\u003cbr\u003e    ほしがき    (\u003ca href=\"https://x.com/hos16g\" target=\"_blank\"\u003ehttps://x.com/hos16g\u003c/a\u003e )\u003cbr\u003e    五城        (\u003ca href=\"https://x.com/fujimichiyo\" target=\"_blank\"\u003ehttps://x.com/fujimichiyo\u003c/a\u003e )\u003cbr\u003e    ふな        (\u003ca href=\"https://x.com/funakoshi\" target=\"_blank\"\u003ehttps://x.com/funakoshi\u003c/a\u003e )\u003cbr\u003e    あるみす    (\u003ca href=\"https://x.com/alumin_1225\" target=\"_blank\"\u003ehttps://x.com/alumin_1225\u003c/a\u003e )\u003cbr\u003e・プロップ\u003cbr\u003e    ふな\u003cbr\u003e    あるみす\u003cbr\u003e・3Dワーク\u003cbr\u003e    ふな\u003cbr\u003e・撮影\u003cbr\u003e    Wild_Drink    (\u003ca href=\"https://x.com/Wild_Drink_M\" target=\"_blank\"\u003ehttps://x.com/Wild_Drink_M\u003c/a\u003e )\u003cbr\u003e\u003cbr\u003e・ロゴ\u003cbr\u003e　椎名はる\u003cbr\u003e　( \u003ca href=\"https://x.com/HelloHalHalo\" target=\"_blank\"\u003ehttps://x.com/HelloHalHalo\u003c/a\u003e )\u003cbr\u003e\u003cbr\u003e・字幕\u003cbr\u003e　fts, \u003cbr\u003e　Lamine\u003cbr\u003e　( \u003ca href=\"https://x.com/La_mi_ne\" target=\"_blank\"\u003ehttps://x.com/La_mi_ne\u003c/a\u003e )\u003cbr\u003e　Tama\u003cbr\u003e　T-chan \u003cbr\u003e\u003cbr\u003e-------\u003cbr\u003e\u003cbr\u003e■special thanks\u003cbr\u003e常闇眷属\u003cbr\u003e\u003cbr\u003e--------------------------------\u003cbr\u003e※ホロライブプロダクションから未成年の視聴者の方々へのお願い\u003cbr\u003e下記リンクをご確認の上、お楽しみください。\u003cbr\u003e\u003ca href=\"https://www.hololive.tv/request-to-minors\" target=\"_blank\"\u003ehttps://www.hololive.tv/request-to-minors\u003c/a\u003e\u003cbr\u003e--------------------------------",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/uxjcPq0Y_IA/maxresdefault.jpg",
      "publishedAt": "2025-06-19T10:45:06Z"
    },
    {
      "youtubeId": "msqnELT59Nk",
      "originalName": {
        "ja": "mumei / 常闇トワ(cover)",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "mumei",
        "en": "",
        "kr": ""
      },
      "artist": "七詩ムメイ",
      "viewCount": 2577706,
      "likeCount": 85727,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": null,
      "composition": null,
      "arrangement": null,
      "isAvailableMV": true,
      "release": null,
      "releaseAt": "",
      "order": 0,
      "type": "cover",
      "descriptionHtml": {
        "ja": "Thank you \u003cbr\u003eNot forget  precious memories.\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e■素敵な本家様\u003cbr\u003e『mumei』/七詩ムメイ様\u003cbr\u003e\u003ca href=\"https://youtu.be/oA0CpI0vCK4?si=nWIo20BAo2V9H927\" target=\"_blank\"\u003ehttps://youtu.be/oA0CpI0vCK4?si=nWIo20BAo2V9H927\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■MIX\u003cbr\u003eYoP　様\u003cbr\u003e\u003ca href=\"https://x.com/yopyloid\" target=\"_blank\"\u003ehttps://x.com/yopyloid\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Illust\u003cbr\u003e旅行　様\u003cbr\u003e\u003ca href=\"https://x.com/3San_325\" target=\"_blank\"\u003ehttps://x.com/3San_325\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Movie\u003cbr\u003eサーナ　様\u003cbr\u003e\u003ca href=\"https://x.com/nonsosul123\" target=\"_blank\"\u003ehttps://x.com/nonsosul123\u003c/a\u003e \u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e常闇トワ　\u003ca href=\"https://www.youtube.com/@TokoyamiTowa\" target=\"_blank\"\u003e@TokoyamiTowa\u003c/a\u003e \u003cbr\u003e\u003ca href=\"https://twitter.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://twitter.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e#常闇トワ #歌ってみた #cover #mumei #七詩ムメイ #ムメイ #nanashimumei \u003cbr\u003e--------------------------------\u003cbr\u003e※ホロライブプロダクションから未成年の視聴者の方々へのお願い\u003cbr\u003e下記リンクをご確認の上、お楽しみください。\u003cbr\u003e\u003ca href=\"https://www.hololive.tv/request-to-mi...\" target=\"_blank\"\u003ehttps://www.hololive.tv/request-to-mi...\u003c/a\u003e\u003cbr\u003e--------------------------------",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/msqnELT59Nk/maxresdefault.jpg",
      "publishedAt": "2025-05-20T11:10:06Z"
    },
    {
      "youtubeId": "exQp5culB9o",
      "originalName": {
        "ja": "Bunny Girl / 常闇トワ(cover)",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "Bunny Girl",
        "en": "",
        "kr": ""
      },
      "artist": "AKASAKI",
      "viewCount": 2749330,
      "likeCount": 72021,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": null,
      "composition": null,
      "arrangement": null,
      "isAvailableMV": true,
      "release": null,
      "releaseAt": "",
      "order": 0,
      "type": "cover",
      "descriptionHtml": {
        "ja": "それくらいがいいんでしょ\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e■素敵な本家様\u003cbr\u003e『Bunny Girl』/AKASAKI様\u003cbr\u003e\u003ca href=\"https://www.youtube.com/watch?v=RCltAg_iK0E\" target=\"_blank\"\u003ehttps://www.youtube.com/watch?v=RCltAg_iK0E\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■MIX\u003cbr\u003e淳　洋一　様\u003cbr\u003e\u003cbr\u003e■Illust\u003cbr\u003eうごんば　様\u003cbr\u003e\u003ca href=\"https://x.com/ug0nba\" target=\"_blank\"\u003ehttps://x.com/ug0nba\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Movie\u003cbr\u003eSaiA　様\u003cbr\u003e\u003ca href=\"https://x.com/Shomijokun\" target=\"_blank\"\u003ehttps://x.com/Shomijokun\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e常闇トワ　\u003ca href=\"https://www.youtube.com/@TokoyamiTowa\" target=\"_blank\"\u003e@TokoyamiTowa\u003c/a\u003e \u003cbr\u003e\u003ca href=\"https://twitter.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://twitter.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e#常闇トワ #歌ってみた #cover #AKASAKI #BunnyGirl #バニーガール\u003cbr\u003e--------------------------------\u003cbr\u003e※ホロライブプロダクションから未成年の視聴者の方々へのお願い\u003cbr\u003e下記リンクをご確認の上、お楽しみください。\u003cbr\u003e\u003ca href=\"https://www.hololive.tv/request-to-mi...\" target=\"_blank\"\u003ehttps://www.hololive.tv/request-to-mi...\u003c/a\u003e\u003cbr\u003e--------------------------------",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/exQp5culB9o/maxresdefault.jpg",
      "publishedAt": "2025-04-01T11:00:06Z"
    },
    {
      "youtubeId": "PMgjFPqXZV4",
      "originalName": {
        "ja": "My Abyss / 常闇トワ (official)",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "My Abyss",
        "en": "",
        "kr": ""
      },
      "artist": "常闇トワ",
      "viewCount": 1152731,
      "likeCount": 42200,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": [
        "YAMAAD"
      ],
      "composition": [
        "YAMAAD"
      ],
      "arrangement": [
        "YAMAAD"
      ],
      "isAvailableMV": true,
      "release": [
        "SHIN",
        "My Abyss"
      ],
      "releaseAt": "2025/03/02",
      "order": 8,
      "type": "original",
      "descriptionHtml": {
        "ja": "【深】\u003cbr\u003e\u003cbr\u003e深い闇へ堕ちてく\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e▼楽曲配信リンク\u003cbr\u003e\u003cbr\u003e2025年3月2日0:00　（2025年3月1日24:00）\u003cbr\u003e\u003cbr\u003e常闇トワ『My Abyss』\u003cbr\u003e\u003ca href=\"https://cover.lnk.to/TxBlie\" target=\"_blank\"\u003ehttps://cover.lnk.to/TxBlie\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e♦ｰｰｰｰｰｰｰｰｰｰ♦\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e常闇トワ\u003cbr\u003e\u003ca href=\"https://x.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://x.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■作詞・作曲・編曲\u003cbr\u003eYAMAAD 様\u003cbr\u003e\u003ca href=\"https://x.com/YAMAADv\" target=\"_blank\"\u003ehttps://x.com/YAMAADv\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■字幕\u003cbr\u003eLamine 様\u003cbr\u003e\u003ca href=\"https://x.com/La_mi_ne\" target=\"_blank\"\u003ehttps://x.com/La_mi_ne\u003c/a\u003e\u003cbr\u003e-------\u003cbr\u003e\u003cbr\u003eRec ＆ Mixing Engineer: Shohei Kojima (birdiehouse)\u003cbr\u003eMastering: Akihiro Shiba (TEMAS)\u003cbr\u003e\u003cbr\u003eChoreography: iri (CDA Inc.)\u003cbr\u003eDance: Towa Tokoyami\u003cbr\u003e\u003cbr\u003e3D Costume Designs \u0026 Modeling: Uchida Hiroaki (exsa Corp.)\u003cbr\u003e3D Costume Modeling: Ishii Minori (exsa Corp.)\u003cbr\u003e3D Costume Producer: Fukushima Ryo (exsa Corp.) \u003cbr\u003e\u003cbr\u003eMovie Director: Nonolu\u003cbr\u003eArt Director: okina (NANON CREATIVE)\u003cbr\u003e\u003cbr\u003eCG Producer: Keita Sugai (Cyran)\u003cbr\u003eCG Artist: okina (NANON CREATIVE)\u003cbr\u003eStage Design: Nonolu\u003cbr\u003eMotion Capture: STUDIO Soup.\u003cbr\u003e\u003cbr\u003eLOGO \u0026 Lyric Design: Haduki\u003cbr\u003e\u003cbr\u003eCompositing: okina (NANON CREATIVE)\u003cbr\u003eMotion Graphics: okina (NANON CREATIVE)\u003cbr\u003e\u003cbr\u003e-------\u003cbr\u003e\u003cbr\u003e■special thanks\u003cbr\u003e常闇眷属\u003cbr\u003e\u003cbr\u003e--------------------------------\u003cbr\u003e※ホロライブプロダクションから未成年の視聴者の方々へのお願い\u003cbr\u003e下記リンクをご確認の上、お楽しみください。\u003cbr\u003e\u003ca href=\"https://www.hololive.tv/request-to-minors\" target=\"_blank\"\u003ehttps://www.hololive.tv/request-to-minors\u003c/a\u003e\u003cbr\u003e--------------------------------",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/PMgjFPqXZV4/maxresdefault.jpg",
      "publishedAt": "2025-03-01T10:00:06Z"
    },
    {
      "youtubeId": "Tkx4HOLIrEM",
      "originalName": {
        "ja": "GET THE CROWN",
        "en": "GET THE CROWN",
        "kr": ""
      },
      "displayName": {
        "ja": "GET THE CROWN",
        "en": "",
        "kr": ""
      },
      "artist": "Hoshimatic Project",
      "viewCount": 1942946,
      "likeCount": 24090,
      "singers": [
        "hoshimachisuisei",
        "tokinosora",
        "natsuiromatsuri",
        "akirose",
        "momosuzunene",
        "hakuikoyori",
        "oozorasubaru",
        "tokoyamitowa",
        "kazamairoha"
      ],
      "lyrics": [
        "玉木千尋"
      ],
      "composition": [
        "玉木千尋"
      ],
      "arrangement": [
        "玉木千尋"
      ],
      "isAvailableMV": false,
      "release": [
        "GET THE CROWN"
      ],
      "releaseAt": "2024/11/08",
      "order": 1,
      "type": "original",
      "descriptionHtml": {
        "ja": "Provided to YouTube by cover corp.\u003cbr\u003e\u003cbr\u003eGET THE CROWN · Hoshimachi Suisei · Tokino Sora · Natsuiro Matsuri · Aki Rosenthal · Momosuzu Nene · Hakui Koyori · Oozora Subaru · Tokoyami Towa · Kazama Iroha · Chihiro Tamaki · Chihiro Tamaki · Chihiro Tamaki\u003cbr\u003e\u003cbr\u003eGET THE CROWN\u003cbr\u003e\u003cbr\u003eReleased on: 2024-11-08\u003cbr\u003e\u003cbr\u003eAuto-generated by YouTube.",
        "en": "Provided to YouTube by cover corp.\u003cbr\u003e\u003cbr\u003eGET THE CROWN · Hoshimachi Suisei · Tokino Sora · Natsuiro Matsuri · Aki Rosenthal · Momosuzu Nene · Hakui Koyori · Oozora Subaru · Tokoyami Towa · Kazama Iroha · Chihiro Tamaki · Chihiro Tamaki · Chihiro Tamaki\u003cbr\u003e\u003cbr\u003eGET THE CROWN\u003cbr\u003e\u003cbr\u003eReleased on: 2024-11-08\u003cbr\u003e\u003cbr\u003eAuto-generated by YouTube.",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/Tkx4HOLIrEM/maxresdefault.jpg",
      "publishedAt": "2024-11-07T15:01:10Z"
    },
    {
      "youtubeId": "-4vCJggx2LY",
      "originalName": {
        "ja": "晩餐歌 / 常闇トワ × 大神ミオ (cover)",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "晩餐歌",
        "en": "",
        "kr": ""
      },
      "artist": "tuki.",
      "viewCount": 5316542,
      "likeCount": 65960,
      "singers": [
        "tokoyamitowa",
        "ookamimio"
      ],
      "lyrics": null,
      "composition": null,
      "arrangement": null,
      "isAvailableMV": true,
      "release": null,
      "releaseAt": "",
      "order": 0,
      "type": "cover",
      "descriptionHtml": {
        "ja": "君以外会いたくないんだよね\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e■素敵な本家様\u003cbr\u003e『晩餐歌』/tuki.様\u003cbr\u003e\u003ca href=\"https://www.youtube.com/watch?v=oZpYEEcvu5I\" target=\"_blank\"\u003ehttps://www.youtube.com/watch?v=oZpYEEcvu5I\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e■MIX\u003cbr\u003e淳　洋一　様\u003cbr\u003e\u003ca href=\"https://twitter.com/jun40am\" target=\"_blank\"\u003ehttps://twitter.com/jun40am\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Instrumental\u003cbr\u003e妄想フォレスト\u003cbr\u003eほきあ　様\u003cbr\u003e\u003ca href=\"https://twitter.com/stl_hokia\" target=\"_blank\"\u003ehttps://twitter.com/stl_hokia\u003c/a\u003e\u003cbr\u003e弦音オウリ　様\u003cbr\u003e\u003ca href=\"https://twitter.com/ouritsurune\" target=\"_blank\"\u003ehttps://twitter.com/ouritsurune\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Illust\u003cbr\u003emajamari　様\u003cbr\u003e\u003ca href=\"https://x.com/majamari17\" target=\"_blank\"\u003ehttps://x.com/majamari17\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Movie\u003cbr\u003eサーナ　様\u003cbr\u003e\u003ca href=\"https://x.com/nonsosul123\" target=\"_blank\"\u003ehttps://x.com/nonsosul123\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e常闇トワ　\u003ca href=\"https://www.youtube.com/@TokoyamiTowa\" target=\"_blank\"\u003e@TokoyamiTowa\u003c/a\u003e \u003cbr\u003e\u003ca href=\"https://twitter.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://twitter.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Vocal　\u003cbr\u003e大神ミオ　\u003ca href=\"https://www.youtube.com/@OokamiMio\" target=\"_blank\"\u003e@OokamiMio\u003c/a\u003e \u003cbr\u003e\u003ca href=\"https://x.com/ookamimio\" target=\"_blank\"\u003ehttps://x.com/ookamimio\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e--------------------------------\u003cbr\u003e※ホロライブプロダクションから未成年の視聴者の方々へのお願い\u003cbr\u003e下記リンクをご確認の上、お楽しみください。\u003cbr\u003e\u003ca href=\"https://www.hololive.tv/request-to-mi...\" target=\"_blank\"\u003ehttps://www.hololive.tv/request-to-mi...\u003c/a\u003e\u003cbr\u003e--------------------------------",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/-4vCJggx2LY/maxresdefault.jpg",
      "publishedAt": "2024-10-28T09:00:06Z"
    },
    {
      "youtubeId": "4jNnT1Mn0b8",
      "originalName": {
        "ja": "点描の唄 / 常闇トワ × Cpt (cover)",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "点描の唄",
        "en": "",
        "kr": ""
      },
      "artist": "Mrs. GREEN APPLE",
      "viewCount": 2464617,
      "likeCount": 50228,
      "singers": [
        "tokoyamitowa",
        "cpt"
      ],
      "lyrics": null,
      "composition": null,
      "arrangement": null,
      "isAvailableMV": true,
      "release": null,
      "releaseAt": "",
      "order": 0,
      "type": "cover",
      "descriptionHtml": {
        "ja": "夏よ、終わるな\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e■素敵な本家様\u003cbr\u003e『点描の唄』/Mrs. GREEN APPLE様\u003cbr\u003e\u003ca href=\"https://www.youtube.com/watch?v=rWsiVWlvw2E\" target=\"_blank\"\u003ehttps://www.youtube.com/watch?v=rWsiVWlvw2E\u003c/a\u003e\u003cbr\u003e作詞・作曲：大森元貴\u003cbr\u003e©2018  by  NICHION, INC.   \u003cbr\u003e \u0026   THEATRE ACADEMY\u003cbr\u003e \u0026   UNIVERSAL MUSIC ARTISTS LLC  \u003cbr\u003e\u003cbr\u003e■MIX\u003cbr\u003e淳　洋一　様\u003cbr\u003e\u003ca href=\"https://twitter.com/jun40am\" target=\"_blank\"\u003ehttps://twitter.com/jun40am\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Instrumental\u003cbr\u003e山本こーすけ　様\u003cbr\u003e\u003cbr\u003e■Illust\u003cbr\u003eカラスロ　様\u003cbr\u003eh\u003ca href=\"https://x.com/KyaRaSuRo\" target=\"_blank\"\u003ehttps://x.com/KyaRaSuRo\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Movie\u003cbr\u003eサーナ　様\u003cbr\u003e\u003ca href=\"https://x.com/nonsosul123\" target=\"_blank\"\u003ehttps://x.com/nonsosul123\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e常闇トワ　\u003ca href=\"https://www.youtube.com/@TokoyamiTowa\" target=\"_blank\"\u003e@TokoyamiTowa\u003c/a\u003e \u003cbr\u003e\u003ca href=\"https://twitter.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://twitter.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Vocal　\u003cbr\u003eCpt　\u003ca href=\"https://www.youtube.com/@CR_Cpt\" target=\"_blank\"\u003e@CR_Cpt\u003c/a\u003e \u003cbr\u003e\u003ca href=\"https://x.com/ApexerCpt\" target=\"_blank\"\u003ehttps://x.com/ApexerCpt\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e--------------------------------\u003cbr\u003e※ホロライブプロダクションから未成年の視聴者の方々へのお願い\u003cbr\u003e下記リンクをご確認の上、お楽しみください。\u003cbr\u003e\u003ca href=\"https://www.hololive.tv/request-to-mi...\" target=\"_blank\"\u003ehttps://www.hololive.tv/request-to-mi...\u003c/a\u003e\u003cbr\u003e--------------------------------",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/4jNnT1Mn0b8/maxresdefault.jpg",
      "publishedAt": "2024-09-26T10:00:22Z"
    },
    {
      "youtubeId": "pEIo7LHOxK8",
      "originalName": {
        "ja": "8.32 / Startend (Cover)",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "8.32",
        "en": "",
        "kr": ""
      },
      "artist": "*Luna",
      "viewCount": 4351390,
      "likeCount": -1,
      "singers": [
        "tokoyamitowa",
        "hoshimachisuisei",
        "minatoaqua"
      ],
      "lyrics": null,
      "composition": null,
      "arrangement": null,
      "isAvailableMV": true,
      "release": null,
      "releaseAt": "",
      "order": 0,
      "type": "cover",
      "descriptionHtml": {
        "ja": "終わらない夏を願った。\u003cbr\u003e\u003cbr\u003e☀8.32 / *Luna\u003cbr\u003e\u003ca href=\"https://youtu.be/rpEObcGvxP4?si=e-ZQHrwEhbfoWzdA\" target=\"_blank\"\u003ehttps://youtu.be/rpEObcGvxP4?si=e-ZQHrwEhbfoWzdA\u003c/a\u003e\u003cbr\u003e※一部原曲から歌詞やストーリーを改変している部分があります。\u003cbr\u003e\u003cbr\u003e☀MIX / なつめ千秋 様\u003cbr\u003e\u003ca href=\"https://twitter.com/cak_ntm\" target=\"_blank\"\u003ehttps://twitter.com/cak_ntm\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e☀イラスト / おかざきおか 様\u003cbr\u003e\u003ca href=\"https://x.com/okazakiokaa\" target=\"_blank\"\u003ehttps://x.com/okazakiokaa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e☀歌 / Startend\u003cbr\u003e\u003ca href=\"https://www.youtube.com/@HoshimachiSuisei\" target=\"_blank\"\u003e@HoshimachiSuisei\u003c/a\u003e \u003cbr\u003e\u003ca href=\"https://www.youtube.com/@TokoyamiTowa\" target=\"_blank\"\u003e@TokoyamiTowa\u003c/a\u003e \u003cbr\u003e\u003ca href=\"https://www.youtube.com/@MinatoAqua\" target=\"_blank\"\u003e@MinatoAqua\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼\u003cbr\u003e\u003cbr\u003e　※ホロライブプロダクションから未成年の視聴者の方々へのお願い\u003cbr\u003e　[カバー 未成年者の方々へ]で検索してお読みの上、お楽しみください。\u003cbr\u003e\u003cbr\u003e▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/pEIo7LHOxK8/maxresdefault.jpg",
      "publishedAt": "2024-09-01T09:00:07Z"
    },
    {
      "youtubeId": "35hMALocac8",
      "originalName": {
        "ja": "インテグラル / Startend (cover)",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "インテグラル",
        "en": "",
        "kr": ""
      },
      "artist": "*Luna",
      "viewCount": 2341716,
      "likeCount": 59824,
      "singers": [
        "tokoyamitowa",
        "hoshimachisuisei",
        "minatoaqua"
      ],
      "lyrics": null,
      "composition": null,
      "arrangement": null,
      "isAvailableMV": true,
      "release": null,
      "releaseAt": "",
      "order": 0,
      "type": "cover",
      "descriptionHtml": {
        "ja": "それでも僕らが　選び取った　未来だ\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e■素敵な本家様\u003cbr\u003e『インテグラル』/*Luna様\u003cbr\u003e\u003ca href=\"https://www.youtube.com/watch?v=gjLYd3iyPKM\" target=\"_blank\"\u003ehttps://www.youtube.com/watch?v=gjLYd3iyPKM\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■MIX\u003cbr\u003e淳　洋一　様\u003cbr\u003e\u003ca href=\"https://twitter.com/jun40am\" target=\"_blank\"\u003ehttps://twitter.com/jun40am\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Illust\u003cbr\u003enima　様\u003cbr\u003e\u003ca href=\"https://x.com/n_n_nima\" target=\"_blank\"\u003ehttps://x.com/n_n_nima\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Movie\u003cbr\u003eRoly　様\u003cbr\u003e\u003ca href=\"https://x.com/yosinO_mo\" target=\"_blank\"\u003ehttps://x.com/yosinO_mo\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Movie\u003cbr\u003e4ishii/あいしー　様\u003cbr\u003e\u003ca href=\"https://x.com/4ishiirendoring\" target=\"_blank\"\u003ehttps://x.com/4ishiirendoring\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e常闇トワ　\u003ca href=\"https://www.youtube.com/@TokoyamiTowa\" target=\"_blank\"\u003e@TokoyamiTowa\u003c/a\u003e \u003cbr\u003e\u003ca href=\"https://twitter.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://twitter.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Vocal　\u003cbr\u003e星街すいせい　\u003ca href=\"https://www.youtube.com/@HoshimachiSuisei\" target=\"_blank\"\u003e@HoshimachiSuisei\u003c/a\u003e \u003cbr\u003e\u003ca href=\"https://x.com/suisei_hosimati\" target=\"_blank\"\u003ehttps://x.com/suisei_hosimati\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Vocal　\u003cbr\u003e湊あくあ　 \u003ca href=\"https://www.youtube.com/@MinatoAqua\" target=\"_blank\"\u003e@MinatoAqua\u003c/a\u003e \u003cbr\u003e\u003ca href=\"https://x.com/minatoaqua\" target=\"_blank\"\u003ehttps://x.com/minatoaqua\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e--------------------------------\u003cbr\u003e※ホロライブプロダクションから未成年の視聴者の方々へのお願い\u003cbr\u003e下記リンクをご確認の上、お楽しみください。\u003cbr\u003e\u003ca href=\"https://www.hololive.tv/request-to-mi...\" target=\"_blank\"\u003ehttps://www.hololive.tv/request-to-mi...\u003c/a\u003e\u003cbr\u003e--------------------------------",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/35hMALocac8/maxresdefault.jpg",
      "publishedAt": "2024-08-27T10:30:06Z"
    },
    {
      "youtubeId": "_T-1Vvm1fPA",
      "originalName": {
        "ja": "快晴 ／ Startend cover",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "快晴",
        "en": "",
        "kr": ""
      },
      "artist": "Orangestar",
      "viewCount": 3845827,
      "likeCount": 92764,
      "singers": [
        "tokoyamitowa",
        "hoshimachisuisei",
        "minatoaqua"
      ],
      "lyrics": null,
      "composition": null,
      "arrangement": null,
      "isAvailableMV": true,
      "release": null,
      "releaseAt": "",
      "order": 0,
      "type": "cover",
      "descriptionHtml": {
        "ja": "君は笑っていて。\u003cbr\u003e\u003cbr\u003e■本家様：\u003ca href=\"https://www.youtube.com/watch?v=BwGpXK3W6tE\" target=\"_blank\"\u003ehttps://www.youtube.com/watch?v=BwGpXK3W6tE\u003c/a\u003e\u003cbr\u003e■vocal：湊あくあ　\u003ca href=\"https://x.com/minatoaqua\" target=\"_blank\"\u003ehttps://x.com/minatoaqua\u003c/a\u003e\u003cbr\u003e常闇トワ　\u003ca href=\"https://www.youtube.com/@TokoyamiTowa\" target=\"_blank\"\u003e@TokoyamiTowa\u003c/a\u003e \u003cbr\u003e星街すいせい　\u003ca href=\"https://www.youtube.com/@HoshimachiSuisei\" target=\"_blank\"\u003e@HoshimachiSuisei\u003c/a\u003e \u003cbr\u003e■Sound：Misato Ono　\u003ca href=\"https://x.com/misamisa_0817\" target=\"_blank\"\u003ehttps://x.com/misamisa_0817\u003c/a\u003e\u003cbr\u003e■Mix：NNZN　\u003ca href=\"https://twitter.com/NNZNsss\" target=\"_blank\"\u003ehttps://twitter.com/NNZNsss\u003c/a\u003e\u003cbr\u003e■Illust：brat 様　@brabrabrat00\u003cbr\u003e■Movie： 木葉はづく 様　\u003ca href=\"https://x.com/hazuqu\" target=\"_blank\"\u003ehttps://x.com/hazuqu\u003c/a\u003e\u003cbr\u003e■Movie Direction：紺色。(スタジオメイビー) 様　\u003ca href=\"https://x.com/kon7iro\" target=\"_blank\"\u003ehttps://x.com/kon7iro\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e※ホロライブプロダクションから未成年の視聴者の方々へのお願い\u003cbr\u003e[カバー 未成年者の方々へ]で検索してお読みいただくか、下記リンクをご確認の上、お楽しみください。\u003cbr\u003e\u003ca href=\"https://hololivepro.com/request-to-minors/\" target=\"_blank\"\u003ehttps://hololivepro.com/request-to-minors/\u003c/a\u003e",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/_T-1Vvm1fPA/maxresdefault.jpg",
      "publishedAt": "2024-08-25T10:00:06Z"
    },
    {
      "youtubeId": "sVYPWu3bxlM",
      "originalName": {
        "ja": "月を見ていた / 常闇トワ(cover)",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "月を見ていた",
        "en": "",
        "kr": ""
      },
      "artist": "米津玄師",
      "viewCount": 716852,
      "likeCount": 23916,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": null,
      "composition": null,
      "arrangement": null,
      "isAvailableMV": true,
      "release": null,
      "releaseAt": "",
      "order": 0,
      "type": "cover",
      "descriptionHtml": {
        "ja": "あなたがいれば幸せだったんだ\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e■素敵な本家様\u003cbr\u003e『月を見ていた』/米津玄師様\u003cbr\u003e\u003ca href=\"https://www.youtube.com/watch?v=1kUZ0LoUELI\" target=\"_blank\"\u003ehttps://www.youtube.com/watch?v=1kUZ0LoUELI\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■MIX\u003cbr\u003eなつめ千秋　様\u003cbr\u003e\u003ca href=\"https://x.com/cak_ntm\" target=\"_blank\"\u003ehttps://x.com/cak_ntm\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Instrumental\u003cbr\u003eSAZA　様\u003cbr\u003e\u003cbr\u003e■Illust\u003cbr\u003e猫目トヲル　様\u003cbr\u003e\u003ca href=\"https://x.com/towor_n\" target=\"_blank\"\u003ehttps://x.com/towor_n\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Movie\u003cbr\u003eサーナ　様\u003cbr\u003e\u003ca href=\"https://x.com/nonsosul123\" target=\"_blank\"\u003ehttps://x.com/nonsosul123\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■LyricMotion\u003cbr\u003e茅埜タト　様\u003cbr\u003e\u003ca href=\"https://x.com/kayanosototato\" target=\"_blank\"\u003ehttps://x.com/kayanosototato\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e常闇トワ　\u003ca href=\"https://www.youtube.com/@TokoyamiTowa\" target=\"_blank\"\u003e@TokoyamiTowa\u003c/a\u003e \u003cbr\u003e\u003ca href=\"https://twitter.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://twitter.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e#FINALFANTASYXVI  #ff16 \u003cbr\u003e--------------------------------\u003cbr\u003e※ホロライブプロダクションから未成年の視聴者の方々へのお願い\u003cbr\u003e下記リンクをご確認の上、お楽しみください。\u003cbr\u003e\u003ca href=\"https://www.hololive.tv/request-to-mi...\" target=\"_blank\"\u003ehttps://www.hololive.tv/request-to-mi...\u003c/a\u003e\u003cbr\u003e--------------------------------",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/sVYPWu3bxlM/maxresdefault.jpg",
      "publishedAt": "2024-08-01T14:00:06Z"
    },
    {
      "youtubeId": "DRtOWI6Lut0",
      "originalName": {
        "ja": "ホワイトノイズ / 常闇トワ(cover)",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "ホワイトノイズ",
        "en": "",
        "kr": ""
      },
      "artist": "Official髭男dism",
      "viewCount": 1984967,
      "likeCount": 39759,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": null,
      "composition": null,
      "arrangement": null,
      "isAvailableMV": true,
      "release": null,
      "releaseAt": "",
      "order": 0,
      "type": "cover",
      "descriptionHtml": {
        "ja": "何度しくじろうとも\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e■素敵な本家様\u003cbr\u003e『ホワイトノイズ』/Official髭男dism様\u003cbr\u003e\u003ca href=\"https://www.youtube.com/watch?v=_ciQX22n9NE\" target=\"_blank\"\u003ehttps://www.youtube.com/watch?v=_ciQX22n9NE\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■MIX\u003cbr\u003e淳　洋一　様\u003cbr\u003e\u003ca href=\"https://twitter.com/jun40am\" target=\"_blank\"\u003ehttps://twitter.com/jun40am\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Instrumental\u003cbr\u003eSAZA　様\u003cbr\u003e\u003cbr\u003e■Illust\u003cbr\u003eAKKE　様\u003cbr\u003e\u003ca href=\"https://x.com/akke299\" target=\"_blank\"\u003ehttps://x.com/akke299\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Movie\u003cbr\u003e有栖 永真　様\u003cbr\u003e\u003ca href=\"https://x.com/alice_eishin\" target=\"_blank\"\u003ehttps://x.com/alice_eishin\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e常闇トワ　\u003ca href=\"https://www.youtube.com/@TokoyamiTowa\" target=\"_blank\"\u003e@TokoyamiTowa\u003c/a\u003e \u003cbr\u003e\u003ca href=\"https://twitter.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://twitter.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e--------------------------------\u003cbr\u003e※ホロライブプロダクションから未成年の視聴者の方々へのお願い\u003cbr\u003e下記リンクをご確認の上、お楽しみください。\u003cbr\u003e\u003ca href=\"https://www.hololive.tv/request-to-mi...\" target=\"_blank\"\u003ehttps://www.hololive.tv/request-to-mi...\u003c/a\u003e\u003cbr\u003e--------------------------------",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/DRtOWI6Lut0/maxresdefault.jpg",
      "publishedAt": "2024-06-23T04:30:07Z"
    },
    {
      "youtubeId": "8bkICbOt1ck",
      "originalName": {
        "ja": "アンノウン・マザーグース / Hoshimatic Project(Cover)",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "アンノウン・マザーグース",
        "en": "",
        "kr": ""
      },
      "artist": "wowaka",
      "viewCount": 33902297,
      "likeCount": -1,
      "singers": [
        "hoshimachisuisei",
        "tokinosora",
        "natsuiromatsuri",
        "akirose",
        "momosuzunene",
        "hakuikoyori",
        "oozorasubaru",
        "tokoyamitowa",
        "kazamairoha",
        "sakamatachloe"
      ],
      "lyrics": null,
      "composition": null,
      "arrangement": null,
      "isAvailableMV": true,
      "release": null,
      "releaseAt": "",
      "order": 0,
      "type": "cover",
      "descriptionHtml": {
        "ja": "♡アンノウン・マザーグース / wowaka 様\u003cbr\u003e\u003ca href=\"https://youtu.be/P_CSdxSGfaA?si=E0I80NImUUR76mKM\" target=\"_blank\"\u003ehttps://youtu.be/P_CSdxSGfaA?si=E0I80NImUUR76mKM\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e♡イラスト /  てかとり 様\u003cbr\u003e\u003ca href=\"https://twitter.com/tktk_tori_R\" target=\"_blank\"\u003ehttps://twitter.com/tktk_tori_R\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e♡映像 /  ぷろっぷ 様\u003cbr\u003e\u003ca href=\"https://twitter.com/a_itwuimate_n\" target=\"_blank\"\u003ehttps://twitter.com/a_itwuimate_n\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e♡MIX / さんかくずわり 様\u003cbr\u003e\u003ca href=\"https://twitter.com/Sankaku_Mix\" target=\"_blank\"\u003ehttps://twitter.com/Sankaku_Mix\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e♡歌 / Hoshimatic Project\u003cbr\u003eときのそら -  \u003ca href=\"https://www.youtube.com/@TokinoSora\" target=\"_blank\"\u003e@TokinoSora\u003c/a\u003e \u003cbr\u003e星街すいせい -  \u003ca href=\"https://www.youtube.com/@HoshimachiSuisei\" target=\"_blank\"\u003e@HoshimachiSuisei\u003c/a\u003e \u003cbr\u003e夏色まつり -   \u003ca href=\"https://www.youtube.com/@NatsuiroMatsuri\" target=\"_blank\"\u003e@NatsuiroMatsuri\u003c/a\u003e \u003cbr\u003eアキ・ローゼンタール -  \u003ca href=\"https://www.youtube.com/@AkiRosenthal\" target=\"_blank\"\u003e@AkiRosenthal\u003c/a\u003e \u003cbr\u003e大空スバル -   \u003ca href=\"https://www.youtube.com/@OozoraSubaru\" target=\"_blank\"\u003e@OozoraSubaru\u003c/a\u003e \u003cbr\u003e常闇トワ -  \u003ca href=\"https://www.youtube.com/@TokoyamiTowa\" target=\"_blank\"\u003e@TokoyamiTowa\u003c/a\u003e \u003cbr\u003e桃鈴ねね -  \u003ca href=\"https://www.youtube.com/@MomosuzuNene\" target=\"_blank\"\u003e@MomosuzuNene\u003c/a\u003e \u003cbr\u003e博衣こより -  \u003ca href=\"https://www.youtube.com/@HakuiKoyori\" target=\"_blank\"\u003e@HakuiKoyori\u003c/a\u003e \u003cbr\u003e風真いろは -  \u003ca href=\"https://www.youtube.com/@kazamairoha\" target=\"_blank\"\u003e@kazamairoha\u003c/a\u003e \u003cbr\u003e沙花叉クロヱ -  \u003ca href=\"https://www.youtube.com/@SakamataChloe\" target=\"_blank\"\u003e@SakamataChloe\u003c/a\u003e \u003cbr\u003e\u003cbr\u003e\u003cbr\u003e▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼\u003cbr\u003e\u003cbr\u003e　※ホロライブプロダクションから未成年の視聴者の方々へのお願い\u003cbr\u003e　[カバー 未成年者の方々へ]で検索してお読みの上、お楽しみください。\u003cbr\u003e\u003cbr\u003e▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼▼",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/8bkICbOt1ck/maxresdefault.jpg",
      "publishedAt": "2024-03-09T12:15:07Z"
    },
    {
      "youtubeId": "0p54QSYd7-c",
      "originalName": {
        "ja": "ゴーストルール / 常闇トワ × 不知火フレア(cover)",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "ゴーストルール",
        "en": "",
        "kr": ""
      },
      "artist": "DECO*27",
      "viewCount": 3276587,
      "likeCount": 51618,
      "singers": [
        "tokoyamitowa",
        "shiranuiflare"
      ],
      "lyrics": null,
      "composition": null,
      "arrangement": null,
      "isAvailableMV": true,
      "release": null,
      "releaseAt": "",
      "order": 0,
      "type": "cover",
      "descriptionHtml": {
        "ja": "マボロシだって知るんだよ\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e■素敵な本家様\u003cbr\u003e『ゴーストルール』/DECO*27様\u003cbr\u003e\u003ca href=\"https://www.youtube.com/watch?v=KushW6zvazM\" target=\"_blank\"\u003ehttps://www.youtube.com/watch?v=KushW6zvazM\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■MIX\u003cbr\u003e淳　洋一　様\u003cbr\u003e\u003ca href=\"https://twitter.com/jun40am\" target=\"_blank\"\u003ehttps://twitter.com/jun40am\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Instrumental\u003cbr\u003e宮内椋太　様\u003cbr\u003e\u003ca href=\"https://twitter.com/mukudori_971\" target=\"_blank\"\u003ehttps://twitter.com/mukudori_971\u003c/a\u003e \u003cbr\u003e\u003cbr\u003e■Illust\u003cbr\u003eいずみけい　様\u003cbr\u003e\u003ca href=\"https://twitter.com/izumikei001\" target=\"_blank\"\u003ehttps://twitter.com/izumikei001\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Movie\u003cbr\u003e花春　様\u003cbr\u003e\u003ca href=\"https://twitter.com/KaSyun02\" target=\"_blank\"\u003ehttps://twitter.com/KaSyun02\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e常闇トワ　\u003ca href=\"https://www.youtube.com/@TokoyamiTowa\" target=\"_blank\"\u003e@TokoyamiTowa\u003c/a\u003e \u003cbr\u003e\u003ca href=\"https://twitter.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://twitter.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Vocal　\u003cbr\u003e不知火フレア　\u003ca href=\"https://www.youtube.com/@ShiranuiFlare\" target=\"_blank\"\u003e@ShiranuiFlare\u003c/a\u003e \u003cbr\u003e\u003ca href=\"https://twitter.com/shiranuiflare\" target=\"_blank\"\u003ehttps://twitter.com/shiranuiflare\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e--------------------------------\u003cbr\u003e※ホロライブプロダクションから未成年の視聴者の方々へのお願い\u003cbr\u003e下記リンクをご確認の上、お楽しみください。\u003cbr\u003e\u003ca href=\"https://www.hololive.tv/request-to-mi...\" target=\"_blank\"\u003ehttps://www.hololive.tv/request-to-mi...\u003c/a\u003e\u003cbr\u003e--------------------------------",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/0p54QSYd7-c/maxresdefault.jpg",
      "publishedAt": "2024-03-08T11:00:07Z"
    },
    {
      "youtubeId": "v7XbruOYI8g",
      "originalName": {
        "ja": "Blue Journey – 「水たまり」 （Music Video）",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "水たまり",
        "en": "",
        "kr": ""
      },
      "artist": "Blue Journey",
      "viewCount": 1291335,
      "likeCount": 10305,
      "singers": [
        "akirose",
        "shirakamifubuki",
        "minatoaqua",
        "yuzukichoco",
        "oozorasubaru",
        "ookamimio",
        "sakuramiko",
        "nekomataokayu",
        "inugamikorone",
        "usadapekora",
        "shiranuiflare",
        "shiroganenoel",
        "housyoumarine",
        "amanekanata",
        "tsunomakiwatame",
        "tokoyamitowa",
        "himemoriluna",
        "yukihanalamy",
        "shishirobotan",
        "omarupolka",
        "takanelui",
        "hakuikoyori",
        "sakamatachloe"
      ],
      "lyrics": [
        "Carlos.K"
      ],
      "composition": [
        "Carlos.K"
      ],
      "arrangement": [
        "Carlos.K"
      ],
      "isAvailableMV": false,
      "release": [
        "水たまり"
      ],
      "releaseAt": "2024/02/07",
      "order": 1,
      "type": "original",
      "descriptionHtml": {
        "ja": "Blue Journey Major 1st Single「水たまり」\u003cbr\u003e2024.02.07 CDリリース #BlueJourney\u003cbr\u003e\u003cbr\u003eCDのご予約：\u003ca href=\"https://lnk.to/bluejourney_mizutamari\" target=\"_blank\"\u003ehttps://lnk.to/bluejourney_mizutamari\u003c/a\u003e\u003cbr\u003eStreaming \u0026 Download : \u003ca href=\"https://lnk.to/BJ_mt\" target=\"_blank\"\u003ehttps://lnk.to/BJ_mt\u003c/a\u003e\u003cbr\u003e\u003cbr\u003eホロライブプロダクション傘下の女性VTuberグループ「ホロライブ」による新しい音楽プロジェクト「Blue Journey」。錚々たる女性グループ楽曲を手がけてきたCarlos K.提供による今作「水たまり」は、水たまりに映った空虚に現実を受け入れていた今までの自分と決別し、本音を吐き捨て、踏みつけ、前に進んでいくセンセーショナルな楽曲。\u003cbr\u003e\u003cbr\u003eカップリングにはInstrumentalの他に、1st Live「夜明けのうた」の中で初披露された「水たまり」のライブ音源をこのシングルのためにミックスしたPerformance ver.、「水たまり」の世界観により浸っていただけるピアノアレンジを施したInstrumental Piano Arrange ver.を収録。\u003cbr\u003e\u003cbr\u003e初回限定盤、完全生産限定 UNIVERSAL MUSIC STORE盤にはBonus Trackとして、一部タレントの「水たまり」レコーディング NG テイク集を収録。本来世に出ないレコーディングの様子、自然な姿が音源で楽しめる内容となっている。\u003cbr\u003e\u003cbr\u003eまた初回限定盤、完全生産限定 UNIVERSAL MUSIC STORE盤のみに付属する32Pアートブックにはメンバーのソロジャケットイラストの他、Blue JourneyプロデューサーとサウンドプロデューサーCarlos K.の2名の貴重なインタビュー、Blue Journeyの衣装設定図が収録される。\u003cbr\u003e\u003cbr\u003e更に、完全生産限定 UNIVERSAL MUSIC STORE盤には指定するメンバー1名のジャケットイラストソロアクリルスタンド(H270〜300mm / W91〜155mm)とジャケットイラストソロA3クリアポスターが同梱される。\u003cbr\u003e\u003cbr\u003e他、封入特典多数、全形態に応募抽選特典[メンバー個別複製手紙]シリアルコードを封入。\u003cbr\u003e◉初回限定盤 ［CD+BOOK］\u003cbr\u003e【三方背トールケース仕様】\u003cbr\u003e品番：UPCH-89551\u003cbr\u003e￥2,750(税込) / ¥2,500(税抜)\u003cbr\u003e\u003cbr\u003e【封入特典】\u003cbr\u003e・32Pアートブック（メンバーソロジャケットイラスト＋プロデューサーインタビュー、衣装設定図収録）\u003cbr\u003e・「水たまり」推し活デコステッカーシート（ジャケットイラスト）\u003cbr\u003e・「水たまり」スタンプステッカー\u003cbr\u003e・トレーディングカード（ジャケットイラスト/メンバーソロ/全23種うち1種ランダム）\u003cbr\u003e・「水たまり」メロディー譜面\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e◉通常盤-初回プレス- ［CD］\u003cbr\u003e品番：UPCH-89552\u003cbr\u003e￥1,320(税込) / ¥1,200(税抜)\u003cbr\u003e【通常盤-初回プレス-封入特典】\u003cbr\u003e・旅先からのレターカード\u003cbr\u003e・「水たまり」スタンプステッカー\u003cbr\u003e・トレーディングカード（ジャケットイラスト/メンバーソロ/全23種うち1種ランダム）\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e◉完全生産限定 UNIVERSAL MUSIC STORE盤 ［CD＋BOOK+GOODS］\u003cbr\u003e【三方背トールケース仕様】\u003cbr\u003e品番：DSKU-12806\u003cbr\u003e￥11,000(税込) / ¥10,000(税抜)\u003cbr\u003e【封入特典】\u003cbr\u003e・32Pアートブック（メンバーソロジャケットイラスト＋プロデューサーインタビュー、衣装設定図収録）\u003cbr\u003e・「水たまり」推し活デコステッカーシート（ジャケットイラスト）\u003cbr\u003e・「水たまり」スタンプステッカー\u003cbr\u003e・「水たまり」メロディー譜面\u003cbr\u003e※封入特典のトレーディングカードは完全生産限定 UNIVERSAL MUSIC STORE盤には付きません。　\u003cbr\u003e\u003cbr\u003e【グッズ】\u003cbr\u003e・ジャケットイラストソロアクリルスタンド\u003cbr\u003e　※本体 H270〜300mm / W91〜155mm\u003cbr\u003e　　台座 約H70×W100mm\u003cbr\u003e・メンバーによりサイズが異なります。\u003cbr\u003e・製造過程で多少サイズが前後する可能性がございますので予めご了承ください。\u003cbr\u003e・ジャケットイラストソロA3クリアポスター\u003cbr\u003e※ご購入時にご希望のメンバー1名をご指定いただけます。\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e【収録内容】\u003cbr\u003eM1:水たまり\u003cbr\u003eM2:水たまり(Instrumental)\u003cbr\u003eM3:水たまり(Performance ver.） \u003cbr\u003eM4:水たまり(Instrumental Piano Arrange ver.)\u003cbr\u003eBonus Track:「水たまり」レコーディング NG テイク集\u003cbr\u003e※Bonus Trackは初回限定盤、完全生産限定UNIVERSAL MUSIC STORE盤のみ収録となります。\u003cbr\u003e\u003cbr\u003eVocal:\u003cbr\u003eアキ・ローゼンタール, 白上フブキ, 湊あくあ, 癒月ちょこ, 大空スバル, 大神ミオ, さくらみこ, 猫又おかゆ, 戌神ころね, 兎田ぺこら, 不知火フレア, 白銀ノエル, 宝鐘マリン, 天音かなた, 角巻わため, 常闇トワ, 姫森ルーナ, 雪花ラミィ, 獅白ぼたん, 尾丸ポルカ, 鷹嶺ルイ, 博衣こより, 沙花叉クロヱ\u003cbr\u003efrom BlueJourney\u003cbr\u003e\u003cbr\u003e※ホロライブプロダクションから未成年の視聴者の方々へのお願い\u003cbr\u003e[カバー 未成年者の方々へ]で検索してお読みいただくか、下記リンクをご確認の上、お楽しみください。\u003cbr\u003e\u003ca href=\"https://hololivepro.com/request-to-minors/\" target=\"_blank\"\u003ehttps://hololivepro.com/request-to-minors/\u003c/a\u003e",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/v7XbruOYI8g/maxresdefault.jpg",
      "publishedAt": "2024-02-01T10:00:51Z"
    },
    {
      "youtubeId": "EvQwQFA1Adg",
      "originalName": {
        "ja": "ANIMA / 桃鈴ねね 常闇トワ (cover) 【歌ってみた】",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "ANIMA",
        "en": "",
        "kr": ""
      },
      "artist": "ReoNa",
      "viewCount": 1662679,
      "likeCount": 26959,
      "singers": [
        "tokoyamitowa",
        "momosuzunene"
      ],
      "lyrics": null,
      "composition": null,
      "arrangement": null,
      "isAvailableMV": true,
      "release": null,
      "releaseAt": "",
      "order": 0,
      "type": "cover",
      "descriptionHtml": {
        "ja": "何色なんだよ！！！！！！！！！！！！！！！！！！\u003cbr\u003e\u003cbr\u003eほんけ：\u003ca href=\"https://www.youtube.com/watch?v=haCJtSnfNEg\" target=\"_blank\"\u003ehttps://www.youtube.com/watch?v=haCJtSnfNEg\u003c/a\u003e\u003cbr\u003e\u003cbr\u003eうた：桃鈴ねね　常闇トワ\u003ca href=\"https://www.youtube.com/@TokoyamiTowa\" target=\"_blank\"\u003e@TokoyamiTowa\u003c/a\u003e \u003cbr\u003eみっくす：よしけん\u003cbr\u003eインスト：ハイカラサウンド\u003cbr\u003e映像：バルス\u003cbr\u003eえいぞう：らいり\u003cbr\u003e\u003cbr\u003e☆歌ってみたリスト☆\u003cbr\u003e\u003ca href=\"https://www.youtube.com/playlist?list=PLet0wKVboCzEMtX-hZQn1obu40HWVKn7q\" target=\"_blank\"\u003ehttps://www.youtube.com/playlist?list=PLet0wKVboCzEMtX-hZQn1obu40HWVKn7q\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e※ホロライブプロダクションから未成年の視聴者の方々へのお願い\u003cbr\u003e[カバー 未成年者の方々へ]で検索してお読みいただくか、下記リンクをご確認の上、お楽しみください。\u003cbr\u003e\u003ca href=\"https://hololivepro.com/request-to-minors/\" target=\"_blank\"\u003ehttps://hololivepro.com/request-to-minors/\u003c/a\u003e",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/EvQwQFA1Adg/maxresdefault.jpg",
      "publishedAt": "2024-02-04T10:00:11Z"
    },
    {
      "youtubeId": "kGlyohr8CXI",
      "originalName": {
        "ja": "【歌ってみた】レプリカ feat. IKE / BAK 【covered by 水無世燐央 x 常闇トワ　Minase Rio x Tokoyami Towa 】",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "レプリカ feat. IKE",
        "en": "",
        "kr": ""
      },
      "artist": "BAK",
      "viewCount": 339166,
      "likeCount": 13183,
      "singers": [
        "tokoyamitowa",
        "minaserio"
      ],
      "lyrics": null,
      "composition": null,
      "arrangement": null,
      "isAvailableMV": true,
      "release": null,
      "releaseAt": "",
      "order": 0,
      "type": "cover",
      "descriptionHtml": {
        "ja": "■Original：BAK様\u003cbr\u003e\u003ca href=\"https://youtu.be/dp1UdYcHVU8\" target=\"_blank\"\u003ehttps://youtu.be/dp1UdYcHVU8\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Sound：Misato Ono様\u003cbr\u003e\u003ca href=\"https://twitter.com/misamisa_0817\" target=\"_blank\"\u003ehttps://twitter.com/misamisa_0817\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Mix：ごず様\u003cbr\u003e\u003ca href=\"https://twitter.com/_gozu777\" target=\"_blank\"\u003ehttps://twitter.com/_gozu777\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Illust：REO様\u003cbr\u003e\u003ca href=\"https://twitter.com/SRiokorr\" target=\"_blank\"\u003ehttps://twitter.com/SRiokorr\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Movie：ナギ様\u003cbr\u003e\u003ca href=\"https://twitter.com/nagitohana\" target=\"_blank\"\u003ehttps://twitter.com/nagitohana\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Vocal：常闇トワ\u003cbr\u003e\u003ca href=\"https://www.youtube.com/@TokoyamiTowa\" target=\"_blank\"\u003e@TokoyamiTowa\u003c/a\u003e \u003cbr\u003e\u003cbr\u003e■Vocal：水無世燐央\u003cbr\u003e\u003cbr\u003e素敵な楽曲をお借りいたしました。\u003cbr\u003eありがとうございます。\u003cbr\u003e\u003cbr\u003e☾••┈┈┈••┈┈┈••✶·̩͙☽︎‪︎✶••┈┈┈••┈┈┈••𓃠\u003cbr\u003eその他、以前歌わせていただいた歌ってみたはこちらから\u003cbr\u003eソロ【\u003ca href=\"https://youtube.com/playlist?list=PLlrWEgVsRXQgqTLqpPeTrQOf5m3LWD_GK\" target=\"_blank\"\u003ehttps://youtube.com/playlist?list=PLlrWEgVsRXQgqTLqpPeTrQOf5m3LWD_GK\u003c/a\u003e 】\u003cbr\u003e\u003cbr\u003eコラボ【\u003ca href=\"https://youtube.com/playlist?list=PLlrWEgVsRXQjazJlw9jdi8gcuxiIYL9nQ\" target=\"_blank\"\u003ehttps://youtube.com/playlist?list=PLlrWEgVsRXQjazJlw9jdi8gcuxiIYL9nQ\u003c/a\u003e 】\u003cbr\u003e\u003cbr\u003e11/5 3Dお披露目配信LIVEをさせていただきました！\u003cbr\u003e \u003ca href=\"https://youtu.be/0CzPQIpOttU\" target=\"_blank\"\u003ehttps://youtu.be/0CzPQIpOttU\u003c/a\u003e\u003cbr\u003e\u003cbr\u003eその他、配信スケジュールなど最新情報は\u003cbr\u003eXをチェックしてください！\u003cbr\u003e\u003cbr\u003e\u003ca href=\"https://twitter.com/minaserioch\" target=\"_blank\"\u003ehttps://twitter.com/minaserioch\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e☾••┈┈┈••┈┈┈••✶·̩͙☽︎‪︎✶••┈┈┈••┈┈┈••𓃠\u003cbr\u003e\u003cbr\u003eホロスターズグループ「UPROAR!!」所属の、水無世燐央です。\u003cbr\u003e歌うことが好きなのんびり幽霊。\u003cbr\u003eアイドルになるために！成仏はしません✌️\u003cbr\u003e\u003cbr\u003e▼ホロスターズグループ公式HP\u003cbr\u003e\u003ca href=\"https://holostars.hololivepro.com/\" target=\"_blank\"\u003ehttps://holostars.hololivepro.com/\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e☾••┈┈┈••┈┈┈••✶·̩͙☽︎‪︎✶••┈┈┈••┈┈┈••𓃠\u003cbr\u003e\u003cbr\u003e※ホロライブプロダクションから未成年の視聴者の方々へのお願い\u003cbr\u003e[カバー 未成年者の方々へ]で検索してお読みいただくか、下記リンクをご確認の上、お楽しみください。\u003cbr\u003e\u003ca href=\"https://hololivepro.com/request-to-minors/\" target=\"_blank\"\u003ehttps://hololivepro.com/request-to-minors/\u003c/a\u003e",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/kGlyohr8CXI/maxresdefault.jpg",
      "publishedAt": "2024-02-02T10:00:11Z"
    },
    {
      "youtubeId": "tLRMiqM5TXE",
      "originalName": {
        "ja": "S.T.Y.",
        "en": "S.T.Y.",
        "kr": ""
      },
      "displayName": {
        "ja": "S.T.Y.",
        "en": "",
        "kr": ""
      },
      "artist": "常闇トワ",
      "viewCount": 1126241,
      "likeCount": 11661,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": [
        "buzzG"
      ],
      "composition": [
        "buzzG"
      ],
      "arrangement": [
        "buzzG"
      ],
      "isAvailableMV": false,
      "release": [
        "S.T.Y."
      ],
      "releaseAt": "2024/01/04",
      "order": 1,
      "type": "original",
      "descriptionHtml": {
        "ja": "Provided to YouTube by cover corp.\u003cbr\u003e\u003cbr\u003eS.T.Y. · Tokoyami Towa · buzzG · buzzG · buzzG\u003cbr\u003e\u003cbr\u003eS.T.Y.\u003cbr\u003e\u003cbr\u003eReleased on: 2024-01-04\u003cbr\u003e\u003cbr\u003eAuto-generated by YouTube.",
        "en": "Provided to YouTube by cover corp.\u003cbr\u003e\u003cbr\u003eS.T.Y. · Tokoyami Towa · buzzG · buzzG · buzzG\u003cbr\u003e\u003cbr\u003eS.T.Y.\u003cbr\u003e\u003cbr\u003eReleased on: 2024-01-04\u003cbr\u003e\u003cbr\u003eAuto-generated by YouTube.",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/tLRMiqM5TXE/maxresdefault.jpg",
      "publishedAt": "2024-01-03T15:00:44Z"
    },
    {
      "youtubeId": "rLIz-w5cyeU",
      "originalName": {
        "ja": "オトナブルー / 常闇トワ feat, Hololive ID 2nd generation (cover)",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "オトナブルー",
        "en": "",
        "kr": ""
      },
      "artist": "新しい学校のリーダーズ",
      "viewCount": 1220854,
      "likeCount": 47854,
      "singers": [
        "tokoyamitowa",
        "kureijiollie",
        "pavoliareine",
        "anyamelfissa"
      ],
      "lyrics": null,
      "composition": null,
      "arrangement": null,
      "isAvailableMV": true,
      "release": null,
      "releaseAt": "",
      "order": 0,
      "type": "cover",
      "descriptionHtml": {
        "ja": "あなたの前でまた　大人振る\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e■素敵な本家様\u003cbr\u003e『オトナブルー』/新しい学校のリーダーズ 様\u003cbr\u003e\u003ca href=\"https://www.youtube.com/watch?v=l446hUqQ7GY\" target=\"_blank\"\u003ehttps://www.youtube.com/watch?v=l446hUqQ7GY\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■MIX\u003cbr\u003e淳　洋一　様\u003cbr\u003e\u003ca href=\"https://x.com/jun40am\" target=\"_blank\"\u003ehttps://x.com/jun40am\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Instrumental\u003cbr\u003eきこり　様\u003cbr\u003e\u003ca href=\"https://x.com/kikori_11\" target=\"_blank\"\u003ehttps://x.com/kikori_11\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Illust\u003cbr\u003eらん　様\u003cbr\u003e\u003ca href=\"https://x.com/runLan_0329\" target=\"_blank\"\u003ehttps://x.com/runLan_0329\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Movie\u003cbr\u003eぴろぱる　様\u003cbr\u003e\u003ca href=\"https://x.com/PIROPARU\" target=\"_blank\"\u003ehttps://x.com/PIROPARU\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e常闇トワ\u003cbr\u003e\u003ca href=\"https://twitter.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://twitter.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003eKureiji Ollie　様　\u003ca href=\"https://www.youtube.com/@KureijiOllie\" target=\"_blank\"\u003e@KureijiOllie\u003c/a\u003e \u003cbr\u003ePavolia Reine　様　\u003ca href=\"https://www.youtube.com/@PavoliaReine\" target=\"_blank\"\u003e@PavoliaReine\u003c/a\u003e \u003cbr\u003eAnya Melfissa　様　\u003ca href=\"https://www.youtube.com/@AnyaMelfissa\" target=\"_blank\"\u003e@AnyaMelfissa\u003c/a\u003e \u003cbr\u003e\u003cbr\u003e--------------------------------\u003cbr\u003e※ホロライブプロダクションから未成年の視聴者の方々へのお願い\u003cbr\u003e下記リンクをご確認の上、お楽しみください。\u003cbr\u003e\u003ca href=\"https://www.hololive.tv/request-to-mi...\" target=\"_blank\"\u003ehttps://www.hololive.tv/request-to-mi...\u003c/a\u003e\u003cbr\u003e--------------------------------",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/rLIz-w5cyeU/maxresdefault.jpg",
      "publishedAt": "2023-11-26T11:00:12Z"
    },
    {
      "youtubeId": "LEr8Z1tCSmk",
      "originalName": {
        "ja": "怪獣の花唄 / 常闇トワ (cover)",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "怪獣の花唄",
        "en": "",
        "kr": ""
      },
      "artist": "Vaundy",
      "viewCount": 6749031,
      "likeCount": 80893,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": null,
      "composition": null,
      "arrangement": null,
      "isAvailableMV": true,
      "release": null,
      "releaseAt": "",
      "order": 0,
      "type": "cover",
      "descriptionHtml": {
        "ja": "もう一度\u003cbr\u003eまた聞かせてくれよ\u003cbr\u003e聞きたいんだ\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e■素敵な本家様\u003cbr\u003e『怪獣の花唄』/Vaundy様\u003cbr\u003e\u003ca href=\"https://www.youtube.com/watch?v=UM9XNpgrqVk\" target=\"_blank\"\u003ehttps://www.youtube.com/watch?v=UM9XNpgrqVk\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■MIX\u003cbr\u003e淳　洋一　様\u003cbr\u003e\u003ca href=\"https://x.com/jun40am\" target=\"_blank\"\u003ehttps://x.com/jun40am\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Instrumental\u003cbr\u003eesP526　様\u003cbr\u003e\u003ca href=\"https://x.com/esP_526\" target=\"_blank\"\u003ehttps://x.com/esP_526\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Illust\u003cbr\u003eメレ　様\u003cbr\u003e\u003ca href=\"https://x.com/mele_ck\" target=\"_blank\"\u003ehttps://x.com/mele_ck\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Movie\u003cbr\u003e浅谷　様\u003cbr\u003e\u003ca href=\"https://x.com/asaya_yaa\" target=\"_blank\"\u003ehttps://x.com/asaya_yaa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e常闇トワ\u003cbr\u003e\u003ca href=\"https://twitter.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://twitter.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■chorus\u003cbr\u003e夏色まつり　様　\u003ca href=\"https://www.youtube.com/@NatsuiroMatsuri\" target=\"_blank\"\u003e@NatsuiroMatsuri\u003c/a\u003e \u003cbr\u003e水無世燐央　様　@MinaseRio \u003cbr\u003eアクセル・シリオス　様　@AxelSyrios \u003cbr\u003e\u003cbr\u003e--------------------------------\u003cbr\u003e※ホロライブプロダクションから未成年の視聴者の方々へのお願い\u003cbr\u003e下記リンクをご確認の上、お楽しみください。\u003cbr\u003e\u003ca href=\"https://www.hololive.tv/request-to-mi...\" target=\"_blank\"\u003ehttps://www.hololive.tv/request-to-mi...\u003c/a\u003e\u003cbr\u003e--------------------------------",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/LEr8Z1tCSmk/maxresdefault.jpg",
      "publishedAt": "2023-10-28T10:00:09Z"
    },
    {
      "youtubeId": "U8Pl7dXU280",
      "originalName": {
        "ja": "Twilight / 常闇トワ(official)",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "Twilight",
        "en": "",
        "kr": ""
      },
      "artist": "常闇トワ",
      "viewCount": 638305,
      "likeCount": 22466,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": [
        "niki"
      ],
      "composition": [
        "niki"
      ],
      "arrangement": [
        "niki"
      ],
      "isAvailableMV": true,
      "release": [
        "Aster"
      ],
      "releaseAt": "2023/09/27",
      "order": 11,
      "type": "original",
      "descriptionHtml": {
        "ja": "僕たちは 過ちの中で何度も試されて \u003cbr\u003eまだ正義や愛とか言うけど \u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e1stアルバム『Aster』\u003cbr\u003e発売日　：2023年9月27日（水） \u003cbr\u003e価格 ：3,300円（税込） \u003cbr\u003e\u003cbr\u003e▼予約はこちら\u003cbr\u003e\u003ca href=\"https://cover.lnk.to/Aster\" target=\"_blank\"\u003ehttps://cover.lnk.to/Aster\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e\u003ca href=\"https://www.youtube.com/watch?v=T7YnrWTa9-w\" target=\"_blank\"\u003ehttps://www.youtube.com/watch?v=T7YnrWTa9-w\u003c/a\u003e\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e常闇トワ\u003cbr\u003e\u003ca href=\"https://x.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://x.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■作詞・作曲・編曲\u003cbr\u003eniki 様\u003cbr\u003e\u003ca href=\"https://x.com/niki_reverse\" target=\"_blank\"\u003ehttps://x.com/niki_reverse\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Illust\u003cbr\u003e火照ちげ 様\u003cbr\u003e\u003ca href=\"https://x.com/hotetige\" target=\"_blank\"\u003ehttps://x.com/hotetige\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■映像/ディレクション\u003cbr\u003eRoly 様\u003cbr\u003e\u003ca href=\"https://twitter.com/yosinO_mo\" target=\"_blank\"\u003ehttps://twitter.com/yosinO_mo\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Videographer\u003cbr\u003e三峰 様\u003cbr\u003e\u003ca href=\"https://x.com/MtsuMne\" target=\"_blank\"\u003ehttps://x.com/MtsuMne\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Storyboard\u003cbr\u003e飴田的 様\u003cbr\u003e\u003ca href=\"https://x.com/amedamato\" target=\"_blank\"\u003ehttps://x.com/amedamato\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■ロゴデザイン\u003cbr\u003e柊綴 様\u003cbr\u003e\u003ca href=\"https://x.com/hiiragi_tudu?s=20\" target=\"_blank\"\u003ehttps://x.com/hiiragi_tudu?s=20\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■字幕\u003cbr\u003e韓国語　자막 제작: Lamine, Hiro様\u003cbr\u003e\u003cbr\u003e--------------------------------\u003cbr\u003e※ホロライブプロダクションから未成年の視聴者の方々へのお願い\u003cbr\u003e下記リンクをご確認の上、お楽しみください。\u003cbr\u003e\u003ca href=\"https://www.hololive.tv/request-to-mi...\" target=\"_blank\"\u003ehttps://www.hololive.tv/request-to-mi...\u003c/a\u003e\u003cbr\u003e--------------------------------",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/U8Pl7dXU280/maxresdefault.jpg",
      "publishedAt": "2023-09-26T12:10:07Z"
    },
    {
      "youtubeId": "V30BhRAUCD0",
      "originalName": {
        "ja": "タイダナワンダー",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "タイダナワンダー",
        "en": "",
        "kr": ""
      },
      "artist": "常闇トワ",
      "viewCount": 847741,
      "likeCount": 6083,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": [
        "ぼっちぼろまる"
      ],
      "composition": [
        "ぼっちぼろまる"
      ],
      "arrangement": [
        "ぼっちぼろまる"
      ],
      "isAvailableMV": false,
      "release": [
        "Aster"
      ],
      "releaseAt": "2023/09/27",
      "order": 4,
      "type": "original",
      "descriptionHtml": {
        "ja": "Provided to YouTube by cover corp.\u003cbr\u003e\u003cbr\u003eタイダナワンダー · Tokoyami Towa · botchiboromaru · botchiboromaru · botchiboromaru\u003cbr\u003e\u003cbr\u003eAster\u003cbr\u003e\u003cbr\u003eReleased on: 2023-09-27\u003cbr\u003e\u003cbr\u003eAuto-generated by YouTube.",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/V30BhRAUCD0/maxresdefault.jpg",
      "publishedAt": "2023-09-26T15:00:20Z"
    },
    {
      "youtubeId": "TfOx00AOfKo",
      "originalName": {
        "ja": "ライメイ / 常闇トワ(official)",
        "en": "",
        "kr": "라이메이 / 토코야미 토와 (공식)"
      },
      "displayName": {
        "ja": "ライメイ",
        "en": "",
        "kr": "라이메이"
      },
      "artist": "常闇トワ",
      "viewCount": 4655675,
      "likeCount": 80721,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": [
        "buzzG"
      ],
      "composition": [
        "buzzG"
      ],
      "arrangement": [
        "buzzG"
      ],
      "isAvailableMV": true,
      "release": [
        "Aster",
        "ライメイ"
      ],
      "releaseAt": "2023/09/27",
      "order": 6,
      "type": "original",
      "descriptionHtml": {
        "ja": "ああ、このまま　地獄へと、\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e2023.2.1　0:00 配信開始\u003cbr\u003e\u003ca href=\"https://cover.lnk.to/raimei\" target=\"_blank\"\u003ehttps://cover.lnk.to/raimei\u003c/a\u003e\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e常闇トワ\u003cbr\u003e\u003ca href=\"https://twitter.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://twitter.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e■作詞・作曲・編曲\u003cbr\u003ebuzzG 様\u003cbr\u003e\u003ca href=\"https://twitter.com/buzz_g\" target=\"_blank\"\u003ehttps://twitter.com/buzz_g\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Illust\u003cbr\u003eぶきやまいちこ 様\u003cbr\u003e\u003ca href=\"https://twitter.com/i_yamaichi\" target=\"_blank\"\u003ehttps://twitter.com/i_yamaichi\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■映像\u003cbr\u003eRoly 様\u003cbr\u003e\u003ca href=\"https://twitter.com/yosinO_mo\" target=\"_blank\"\u003ehttps://twitter.com/yosinO_mo\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■リリックデザイン\u003cbr\u003e椎名はる 様\u003cbr\u003e\u003ca href=\"https://twitter.com/HelloHalHalo\" target=\"_blank\"\u003ehttps://twitter.com/HelloHalHalo\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■ロゴ\u003cbr\u003eミナトデザイン 様\u003cbr\u003e\u003ca href=\"https://twitter.com/minato_design_s\" target=\"_blank\"\u003ehttps://twitter.com/minato_design_s\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e字幕制作：fts, Lamine, T-chan",
        "en": "",
        "kr": "아아, 이대로 지옥으로\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e2023년 2월 1일 0시 스트리밍 개시\u003cbr\u003e\u003ca href=\"https://cover.lnk.to/raimei\" target=\"_blank\"\u003ehttps://cover.lnk.to/raimei\u003c/a\u003e\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e■보컬\u003cbr\u003e토코야미 토와\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e/ tokoyamitowa\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e■작사, 작곡, 편곡\u003cbr\u003ebuzzG\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e/ buzz_g\u003cbr\u003e\u003cbr\u003e■일러스트\u003cbr\u003eぶきやまいちこ\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e/ i_yamaichi\u003cbr\u003e\u003cbr\u003e■영상\u003cbr\u003eRoly\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e/ yosino_mo\u003cbr\u003e\u003cbr\u003e■타이포그래피\u003cbr\u003e椎名はる\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e/ hellohalhalo\u003cbr\u003e\u003cbr\u003e■로고\u003cbr\u003eミナトデザイン\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e/ minato_design_s\u003cbr\u003e\u003cbr\u003e자막 제작: Lamine, Hiro"
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/TfOx00AOfKo/maxresdefault.jpg",
      "publishedAt": "2023-01-31T11:00:10Z"
    },
    {
      "youtubeId": "2EFxaXWinJc",
      "originalName": {
        "ja": "Antares / 常闇トワ(official)",
        "en": "",
        "kr": "Antares / 토코야미 토와 (공식)"
      },
      "displayName": {
        "ja": "Antares",
        "en": "",
        "kr": ""
      },
      "artist": "常闇トワ",
      "viewCount": 2114624,
      "likeCount": 54104,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": [
        "TakoyakiKZY"
      ],
      "composition": [
        "TakoyakiKZY"
      ],
      "arrangement": [
        "TakoyakiKZY"
      ],
      "isAvailableMV": true,
      "release": [
        "Aster"
      ],
      "releaseAt": "2023/09/27",
      "order": 9,
      "type": "original",
      "descriptionHtml": {
        "ja": "何光年も離れていたけど\u003cbr\u003e作り上げた世界だ\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e1stアルバム『Aster』\u003cbr\u003e発売日　：2023年9月27日（水） \u003cbr\u003e価格 ：3,300円（税込） \u003cbr\u003e\u003cbr\u003e▼購入はこちらから\u003cbr\u003e\u003ca href=\"https://cover.lnk.to/Aster\" target=\"_blank\"\u003ehttps://cover.lnk.to/Aster\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e\u003ca href=\"https://www.youtube.com/watch?v=T7YnrWTa9-w\" target=\"_blank\"\u003ehttps://www.youtube.com/watch?v=T7YnrWTa9-w\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e♦ｰｰｰｰｰｰｰｰｰｰ♦\u003cbr\u003e\u003cbr\u003e1stソロライブ『Break your ×××』開催決定\u003cbr\u003e\u003cbr\u003e開催日　：2023/10/13 (Fri) 19:00~\u003cbr\u003e場所　：立川ガーデンステージ\u003cbr\u003e\u003cbr\u003e▼特設サイト\u003cbr\u003e\u003ca href=\"https://towa1stlive.hololivepro.com/\" target=\"_blank\"\u003ehttps://towa1stlive.hololivepro.com/\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e▼チケットについて\u003cbr\u003e\u003ca href=\"https://towa1stlive.hololivepro.com/tickets\" target=\"_blank\"\u003ehttps://towa1stlive.hololivepro.com/tickets\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e常闇トワ\u003cbr\u003e\u003ca href=\"https://x.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://x.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■作詞・作曲・編曲\u003cbr\u003eTakoyakiKZY 様\u003cbr\u003e\u003ca href=\"https://x.com/TakoyakiKZY\" target=\"_blank\"\u003ehttps://x.com/TakoyakiKZY\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Illust\u0026Animation\u003cbr\u003eかかげ 様\u003cbr\u003e\u003ca href=\"https://x.com/kakage0904\" target=\"_blank\"\u003ehttps://x.com/kakage0904\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Movie\u003cbr\u003eRitz 様\u003cbr\u003e\u003ca href=\"https://x.com/youtube_ritz_\" target=\"_blank\"\u003ehttps://x.com/youtube_ritz_\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■direction\u003cbr\u003eRoly 様\u003cbr\u003e\u003ca href=\"https://x.com/yosinO_mo\" target=\"_blank\"\u003ehttps://x.com/yosinO_mo\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Movie Assistant\u003cbr\u003eオムカ 様\u003cbr\u003e\u003ca href=\"https://x.com/rexmeltykiss\" target=\"_blank\"\u003ehttps://x.com/rexmeltykiss\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Chorus\u003cbr\u003eアステル・レダ 様\u003cbr\u003ecpt 様\u003cbr\u003e渋谷ハル 様\u003cbr\u003e橘ひなの 様\u003cbr\u003e万象院ハッカ 様\u003cbr\u003eHakos Baelz 様\u003cbr\u003e星街すいせい 様\u003cbr\u003eMoona Hoshinova 様\u003cbr\u003eラトナ・プティ 様\u003cbr\u003e\u003cbr\u003e■Illust(敬称略)\u003cbr\u003e\u003cbr\u003eWAGAMAMA'S( selly/エクス・アルビオ )\u003cbr\u003esai 様\u003cbr\u003e\u003ca href=\"https://x.com/saiqun_31\" target=\"_blank\"\u003ehttps://x.com/saiqun_31\u003c/a\u003e\u003cbr\u003e\u003cbr\u003eスパイス一家( だるまいずごっど/ありさか )\u003cbr\u003eNAGY 様\u003cbr\u003e\u003ca href=\"https://x.com/cindy32ok123\" target=\"_blank\"\u003ehttps://x.com/cindy32ok123\u003c/a\u003e\u003cbr\u003e\u003cbr\u003eCANDY☆POP( 胡桃のあ/cpt )\u003cbr\u003eじろ 様\u003cbr\u003e\u003ca href=\"https://x.com/regoied\" target=\"_blank\"\u003ehttps://x.com/regoied\u003c/a\u003e\u003cbr\u003e\u003cbr\u003eJewel box( 猫汰つな/八雲べに )\u003cbr\u003eゆやぃやうい 様\u003cbr\u003e\u003ca href=\"https://x.com/yuyaiyaui\" target=\"_blank\"\u003ehttps://x.com/yuyaiyaui\u003c/a\u003e\u003cbr\u003e\u003cbr\u003eStartend( 湊あくあ/星街すいせい )\u003cbr\u003e五月　様\u003cbr\u003e\u003ca href=\"https://x.com/satsukl_5\" target=\"_blank\"\u003ehttps://x.com/satsukl_5\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Logo design\u003cbr\u003e煉 様\u003cbr\u003e\u003ca href=\"https://x.com/ren00_re\" target=\"_blank\"\u003ehttps://x.com/ren00_re\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■special thanks\u003cbr\u003e常闇眷属のみんな\u003cbr\u003eお友達のみんな\u003cbr\u003eすべてのみんなへ\u003cbr\u003e\u003cbr\u003e--------------------------------\u003cbr\u003e※ホロライブプロダクションから未成年の視聴者の方々へのお願い\u003cbr\u003e下記リンクをご確認の上、お楽しみください。\u003cbr\u003e\u003ca href=\"https://www.hololive.tv/request-to-minors\" target=\"_blank\"\u003ehttps://www.hololive.tv/request-to-minors\u003c/a\u003e\u003cbr\u003e--------------------------------",
        "en": "",
        "kr": "몇 광년이나 떨어져 있었지만\u003cbr\u003e만들어낸 세상이야\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e1st 앨범 \"Aster\"\u003cbr\u003e발매: 2023년 9월 27일 수요일\u003cbr\u003e가격: 3,300엔 (세금 포함)\u003cbr\u003e\u003cbr\u003e▼앨범 구매\u003cbr\u003e\u003ca href=\"https://cover.lnk.to/Aster\" target=\"_blank\"\u003ehttps://cover.lnk.to/Aster\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e• 토코야미 토와 1st 앨범 \"Aster\" 티저\u003cbr\u003e\u003cbr\u003e♦ｰｰｰｰｰｰｰｰｰｰ♦\u003cbr\u003e\u003cbr\u003e1st 솔로 콘서트 \"Break your ×××\" 개최 결정\u003cbr\u003e\u003cbr\u003e날짜: 2023년 10월 13일 금요일 19시~\u003cbr\u003e장소: 타치카와 가든 스테이지\u003cbr\u003e\u003cbr\u003e▼특설 사이트\u003cbr\u003e\u003ca href=\"https://towa1stlive.hololivepro.com/\" target=\"_blank\"\u003ehttps://towa1stlive.hololivepro.com/\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e▼티켓 관련 정보\u003cbr\u003e\u003ca href=\"https://towa1stlive.hololivepro.com/t...\" target=\"_blank\"\u003ehttps://towa1stlive.hololivepro.com/t...\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e■보컬\u003cbr\u003e토코야미 토와\u003cbr\u003e\u003ca href=\"https://x.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://x.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■작사, 작곡, 편곡\u003cbr\u003eTakoyakiKZY\u003cbr\u003e\u003ca href=\"https://x.com/TakoyakiKZY\" target=\"_blank\"\u003ehttps://x.com/TakoyakiKZY\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■일러스트 \u0026 애니메이션\u003cbr\u003eかかげ\u003cbr\u003e\u003ca href=\"https://x.com/kakage0904\" target=\"_blank\"\u003ehttps://x.com/kakage0904\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■영상\u003cbr\u003eRitz\u003cbr\u003e\u003ca href=\"https://x.com/youtube_ritz_\" target=\"_blank\"\u003ehttps://x.com/youtube_ritz_\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■연출\u003cbr\u003eRoly\u003cbr\u003e\u003ca href=\"https://x.com/yosinO_mo\" target=\"_blank\"\u003ehttps://x.com/yosinO_mo\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■영상 어시스턴트\u003cbr\u003eオムカ\u003cbr\u003e\u003ca href=\"https://x.com/rexmeltykiss\" target=\"_blank\"\u003ehttps://x.com/rexmeltykiss\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■코러스\u003cbr\u003e아스텔 레다\u003cbr\u003ecpt\u003cbr\u003e渋谷ハル\u003cbr\u003e橘ひなの\u003cbr\u003e반조인 핫카\u003cbr\u003e하코스 벨즈\u003cbr\u003e호시마치 스이세이\u003cbr\u003e무나 호시노바\u003cbr\u003eラトナ・プティ\u003cbr\u003e\u003cbr\u003e■일러스트\u003cbr\u003e\u003cbr\u003eWAGAMAMA'S( selly/エクス・アルビオ )\u003cbr\u003esai\u003cbr\u003e\u003ca href=\"https://x.com/saiqun_31\" target=\"_blank\"\u003ehttps://x.com/saiqun_31\u003c/a\u003e\u003cbr\u003e\u003cbr\u003eスパイス一家(だるまいずごっど/ありさか)\u003cbr\u003eNAGY\u003cbr\u003e\u003ca href=\"https://x.com/cindy32ok123\" target=\"_blank\"\u003ehttps://x.com/cindy32ok123\u003c/a\u003e\u003cbr\u003e\u003cbr\u003eCANDY☆POP(胡桃のあ/cpt)\u003cbr\u003eじろ\u003cbr\u003e\u003ca href=\"https://x.com/regoied\" target=\"_blank\"\u003ehttps://x.com/regoied\u003c/a\u003e\u003cbr\u003e\u003cbr\u003eJewel box(猫汰つな/八雲べに)\u003cbr\u003eゆやぃやうい\u003cbr\u003e\u003ca href=\"https://x.com/yuyaiyaui\" target=\"_blank\"\u003ehttps://x.com/yuyaiyaui\u003c/a\u003e\u003cbr\u003e\u003cbr\u003eStartend(미나토 아쿠아/호시마치 스이세이)\u003cbr\u003e五月\u003cbr\u003e\u003ca href=\"https://x.com/satsukl_5\" target=\"_blank\"\u003ehttps://x.com/satsukl_5\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■로고 디자인\u003cbr\u003e煉\u003cbr\u003e\u003ca href=\"https://x.com/ren00_re\" target=\"_blank\"\u003ehttps://x.com/ren00_re\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■special thanks\u003cbr\u003e토코야미 권속들\u003cbr\u003e친구들\u003cbr\u003e그리고 모두 \u003cbr\u003e\u003cbr\u003e--------------------------------\u003cbr\u003e* 미성년자 시청자분들께 부탁드립니다\u003cbr\u003e저희의 콘텐츠를 시청하기 전 부디 아래의 링크를 확인해 주시길 바랍니다\u003cbr\u003e\u003ca href=\"https://hololivepro.com/request-to-mi...\" target=\"_blank\"\u003ehttps://hololivepro.com/request-to-mi...\u003c/a\u003e\u003cbr\u003e--------------------------------\u003cbr\u003e\u003cbr\u003e자막 제작: Lamine, Hiro"
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/2EFxaXWinJc/maxresdefault.jpg",
      "publishedAt": "2023-10-11T11:00:09Z"
    },
    {
      "youtubeId": "vKSRL1THYeM",
      "originalName": {
        "ja": "Cry Out",
        "en": "Cry Out",
        "kr": ""
      },
      "displayName": {
        "ja": "Cry Out",
        "en": "",
        "kr": ""
      },
      "artist": "常闇トワ",
      "viewCount": 734489,
      "likeCount": 6384,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": [
        "t+pazolite"
      ],
      "composition": [
        "t+pazolite"
      ],
      "arrangement": [
        "t+pazolite"
      ],
      "isAvailableMV": false,
      "release": [
        "Aster"
      ],
      "releaseAt": "2023/09/27",
      "order": 10,
      "type": "original",
      "descriptionHtml": {
        "ja": "Provided to YouTube by cover corp.\u003cbr\u003e\u003cbr\u003eCry Out · Tokoyami Towa · t+pazolite · t+pazolite · t+pazolite\u003cbr\u003e\u003cbr\u003eAster\u003cbr\u003e\u003cbr\u003eReleased on: 2023-09-27\u003cbr\u003e\u003cbr\u003eAuto-generated by YouTube.",
        "en": "Provided to YouTube by cover corp.\u003cbr\u003e\u003cbr\u003eCry Out · Tokoyami Towa · t+pazolite · t+pazolite · t+pazolite\u003cbr\u003e\u003cbr\u003eAster\u003cbr\u003e\u003cbr\u003eReleased on: 2023-09-27\u003cbr\u003e\u003cbr\u003eAuto-generated by YouTube.",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/vKSRL1THYeM/maxresdefault.jpg",
      "publishedAt": "2023-09-26T15:00:46Z"
    },
    {
      "youtubeId": "1A-UuoGQaOM",
      "originalName": {
        "ja": "Purple Disease",
        "en": "Purple Disease",
        "kr": ""
      },
      "displayName": {
        "ja": "Purple Disease",
        "en": "",
        "kr": ""
      },
      "artist": "常闇トワ",
      "viewCount": 1639037,
      "likeCount": 14303,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": [
        "かめりあ"
      ],
      "composition": [
        "かめりあ"
      ],
      "arrangement": [
        "かめりあ"
      ],
      "isAvailableMV": false,
      "release": [
        "Aster"
      ],
      "releaseAt": "2023/09/27",
      "order": 7,
      "type": "original",
      "descriptionHtml": {
        "ja": "Provided to YouTube by cover corp.\u003cbr\u003e\u003cbr\u003ePurple Disease · Tokoyami Towa · Camellia · Camellia · Camellia\u003cbr\u003e\u003cbr\u003eAster\u003cbr\u003e\u003cbr\u003eReleased on: 2023-09-27\u003cbr\u003e\u003cbr\u003eAuto-generated by YouTube.",
        "en": "Provided to YouTube by cover corp.\u003cbr\u003e\u003cbr\u003ePurple Disease · Tokoyami Towa · Camellia · Camellia · Camellia\u003cbr\u003e\u003cbr\u003eAster\u003cbr\u003e\u003cbr\u003eReleased on: 2023-09-27\u003cbr\u003e\u003cbr\u003eAuto-generated by YouTube.",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/1A-UuoGQaOM/maxresdefault.jpg",
      "publishedAt": "2023-09-26T15:00:01Z"
    },
    {
      "youtubeId": "cY8gQ7LtbKI",
      "originalName": {
        "ja": "Whose thorns?",
        "en": "Whose thorns?",
        "kr": ""
      },
      "displayName": {
        "ja": "Whose thorns?",
        "en": "",
        "kr": ""
      },
      "artist": "常闇トワ",
      "viewCount": 659235,
      "likeCount": 5224,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": [
        "中村未来(Co shu Nie)"
      ],
      "composition": [
        "中村未来(Co shu Nie)"
      ],
      "arrangement": [
        "中村未来(Co shu Nie)"
      ],
      "isAvailableMV": false,
      "release": [
        "Aster"
      ],
      "releaseAt": "2023/09/27",
      "order": 5,
      "type": "original",
      "descriptionHtml": {
        "ja": "Provided to YouTube by cover corp.\u003cbr\u003e\u003cbr\u003eWhose thorns? · Tokoyami Towa · MIKU NAKAMURA(Cö shu Nie） · MIKU NAKAMURA(Cö shu Nie） · MIKU NAKAMURA(Cö shu Nie）\u003cbr\u003e\u003cbr\u003eAster\u003cbr\u003e\u003cbr\u003eReleased on: 2023-09-27\u003cbr\u003e\u003cbr\u003eAuto-generated by YouTube.",
        "en": "Provided to YouTube by cover corp.\u003cbr\u003e\u003cbr\u003eWhose thorns? · Tokoyami Towa · MIKU NAKAMURA(Cö shu Nie） · MIKU NAKAMURA(Cö shu Nie） · MIKU NAKAMURA(Cö shu Nie）\u003cbr\u003e\u003cbr\u003eAster\u003cbr\u003e\u003cbr\u003eReleased on: 2023-09-27\u003cbr\u003e\u003cbr\u003eAuto-generated by YouTube.",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/cY8gQ7LtbKI/maxresdefault.jpg",
      "publishedAt": "2023-09-26T15:00:26Z"
    },
    {
      "youtubeId": "VaXpo1S21oY",
      "originalName": {
        "ja": "二人三脚 feat.猫汰つな / 常闇トワ(official)",
        "en": "",
        "kr": "2인3각 feat. 네코타 츠나/ 토코야미 토와 (공식)"
      },
      "displayName": {
        "ja": "二人三脚 feat.猫汰つな",
        "en": "",
        "kr": "2인3각 feat. 네코타 츠나"
      },
      "artist": "常闇トワ",
      "viewCount": 1609436,
      "likeCount": 36695,
      "singers": [
        "tokoyamitowa",
        "nekotatsuna"
      ],
      "lyrics": [
        "徳田光希"
      ],
      "composition": [
        "三好啓太・徳田光希"
      ],
      "arrangement": [
        "三好啓太・徳田光希"
      ],
      "isAvailableMV": true,
      "release": [
        "Aster"
      ],
      "releaseAt": "2023/09/27",
      "order": 12,
      "type": "original",
      "descriptionHtml": {
        "ja": "どこにいても　二人三脚\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e1stアルバム『Aster』\u003cbr\u003e発売日　：2023年9月27日（水） \u003cbr\u003e価格 ：3,300円（税込） \u003cbr\u003e\u003cbr\u003e▼購入はこちらから\u003cbr\u003e\u003ca href=\"https://cover.lnk.to/Aster\" target=\"_blank\"\u003ehttps://cover.lnk.to/Aster\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e\u003ca href=\"https://www.youtube.com/watch?v=T7YnrWTa9-w\" target=\"_blank\"\u003ehttps://www.youtube.com/watch?v=T7YnrWTa9-w\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e♦ｰｰｰｰｰｰｰｰｰｰ♦\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e常闇トワ\u003cbr\u003e\u003ca href=\"https://x.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://x.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e猫汰つな\u003cbr\u003e\u003ca href=\"https://www.youtube.com/@tsuna_nekota\" target=\"_blank\"\u003e@tsuna_nekota\u003c/a\u003e \u003cbr\u003e\u003cbr\u003e■作曲・編曲\u003cbr\u003e三好啓太 様\u003cbr\u003e\u003ca href=\"https://x.com/KeitaMiyoshi\" target=\"_blank\"\u003ehttps://x.com/KeitaMiyoshi\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■作詞・作曲・編曲\u003cbr\u003e徳田光希 様\u003cbr\u003e\u003ca href=\"https://x.com/109da32ki\" target=\"_blank\"\u003ehttps://x.com/109da32ki\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Illust\u003cbr\u003eSai 様\u003cbr\u003e\u003ca href=\"https://x.com/saiqun_31\" target=\"_blank\"\u003ehttps://x.com/saiqun_31\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Movie\u003cbr\u003eSaiA 様\u003cbr\u003e\u003ca href=\"https://x.com/Shomijokun\" target=\"_blank\"\u003ehttps://x.com/Shomijokun\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■字幕\u003cbr\u003e韓国語　자막 제작: Lamine, Hiro様\u003cbr\u003e\u003cbr\u003e■special thanks\u003cbr\u003e常闇眷属のみんな\u003cbr\u003eお友達のみんな\u003cbr\u003eすべてのみんなへ\u003cbr\u003e\u003cbr\u003e--------------------------------\u003cbr\u003e※ホロライブプロダクションから未成年の視聴者の方々へのお願い\u003cbr\u003e下記リンクをご確認の上、お楽しみください。\u003cbr\u003e\u003ca href=\"https://www.hololive.tv/request-to-minors\" target=\"_blank\"\u003ehttps://www.hololive.tv/request-to-minors\u003c/a\u003e\u003cbr\u003e--------------------------------",
        "en": "",
        "kr": "어디에 있더라도 2인3각\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e1st 앨범 \"Aster\"\u003cbr\u003e발매: 2023년 9월 27일 수요일\u003cbr\u003e가격: 3,300엔 (세금 포함)\u003cbr\u003e\u003cbr\u003e▼앨범 구매\u003cbr\u003e\u003ca href=\"https://cover.lnk.to/Aster\" target=\"_blank\"\u003ehttps://cover.lnk.to/Aster\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e• 토코야미 토와 1st 앨범 \"Aster\" 티저\u003cbr\u003e\u003cbr\u003e♦ｰｰｰｰｰｰｰｰｰｰ♦\u003cbr\u003e\u003cbr\u003e■보컬\u003cbr\u003e토코야미 토와\u003cbr\u003e\u003ca href=\"https://x.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://x.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■보컬\u003cbr\u003e네코타 츠나\u003cbr\u003e\u003ca href=\"https://www.youtube.com/@tsuna_nekota\" target=\"_blank\"\u003e@tsuna_nekota\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■작곡, 편곡\u003cbr\u003e三好啓太 様\u003cbr\u003e\u003ca href=\"https://x.com/KeitaMiyoshi\" target=\"_blank\"\u003ehttps://x.com/KeitaMiyoshi\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■작사, 작곡, 편곡\u003cbr\u003e徳田光希 様\u003cbr\u003e\u003ca href=\"https://x.com/109da32ki\" target=\"_blank\"\u003ehttps://x.com/109da32ki\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■일러스트\u003cbr\u003eSai 様\u003cbr\u003e\u003ca href=\"https://x.com/saiqun_32\" target=\"_blank\"\u003ehttps://x.com/saiqun_32\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■영상\u003cbr\u003eSaiA 様\u003cbr\u003e\u003ca href=\"https://x.com/Shomijokun\" target=\"_blank\"\u003ehttps://x.com/Shomijokun\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■special thanks\u003cbr\u003e토코야미 권속들\u003cbr\u003e친구들\u003cbr\u003e그리고 모두에게\u003cbr\u003e\u003cbr\u003e--------------------------------\u003cbr\u003e* 미성년자 시청자분들께 부탁드립니다\u003cbr\u003e저희의 콘텐츠를 시청하기 전 부디 아래의 링크를 확인해 주시길 바랍니다\u003cbr\u003e\u003ca href=\"https://hololivepro.com/request-to-mi...\" target=\"_blank\"\u003ehttps://hololivepro.com/request-to-mi...\u003c/a\u003e\u003cbr\u003e--------------------------------\u003cbr\u003e\u003cbr\u003e자막 제작: Lamine, Hiro"
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/VaXpo1S21oY/maxresdefault.jpg",
      "publishedAt": "2023-12-25T11:00:07Z"
    },
    {
      "youtubeId": "Srx6Qs0So_Q",
      "originalName": {
        "ja": "魁",
        "en": "魁",
        "kr": ""
      },
      "displayName": {
        "ja": "魁",
        "en": "",
        "kr": ""
      },
      "artist": "常闇トワ",
      "viewCount": 1365169,
      "likeCount": 10295,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": [
        "Q-MHz"
      ],
      "composition": [
        "Q-MHz"
      ],
      "arrangement": [
        "Q-MHz"
      ],
      "isAvailableMV": false,
      "release": [
        "Aster"
      ],
      "releaseAt": "2023/09/27",
      "order": 2,
      "type": "original",
      "descriptionHtml": {
        "ja": "Provided to YouTube by cover corp.\u003cbr\u003e\u003cbr\u003e魁 · Tokoyami Towa · Q-MHz · Q-MHz · Q-MHz\u003cbr\u003e\u003cbr\u003eAster\u003cbr\u003e\u003cbr\u003eReleased on: 2023-09-27\u003cbr\u003e\u003cbr\u003eAuto-generated by YouTube.",
        "en": "Provided to YouTube by cover corp.\u003cbr\u003e\u003cbr\u003e魁 · Tokoyami Towa · Q-MHz · Q-MHz · Q-MHz\u003cbr\u003e\u003cbr\u003eAster\u003cbr\u003e\u003cbr\u003eReleased on: 2023-09-27\u003cbr\u003e\u003cbr\u003eAuto-generated by YouTube.",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/Srx6Qs0So_Q/maxresdefault.jpg",
      "publishedAt": "2023-09-26T15:00:19Z"
    },
    {
      "youtubeId": "llLjylG44DQ",
      "originalName": {
        "ja": "Present Day",
        "en": "Present Day",
        "kr": ""
      },
      "displayName": {
        "ja": "Present Day",
        "en": "",
        "kr": ""
      },
      "artist": "常闇トワ",
      "viewCount": 979079,
      "likeCount": 8168,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": [
        "古閑翔平"
      ],
      "composition": [
        "古閑翔平"
      ],
      "arrangement": [
        "YOURNESS"
      ],
      "isAvailableMV": false,
      "release": [
        "Aster"
      ],
      "releaseAt": "2023/09/27",
      "order": 1,
      "type": "original",
      "descriptionHtml": {
        "ja": "Provided to YouTube by cover corp.\u003cbr\u003e\u003cbr\u003ePresent Day · Tokoyami Towa · Shohei Koga · Shohei Koga · yourness\u003cbr\u003e\u003cbr\u003eAster\u003cbr\u003e\u003cbr\u003eReleased on: 2023-09-27\u003cbr\u003e\u003cbr\u003eAuto-generated by YouTube.",
        "en": "Provided to YouTube by cover corp.\u003cbr\u003e\u003cbr\u003ePresent Day · Tokoyami Towa · Shohei Koga · Shohei Koga · yourness\u003cbr\u003e\u003cbr\u003eAster\u003cbr\u003e\u003cbr\u003eReleased on: 2023-09-27\u003cbr\u003e\u003cbr\u003eAuto-generated by YouTube.",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/llLjylG44DQ/maxresdefault.jpg",
      "publishedAt": "2023-09-26T15:00:41Z"
    },
    {
      "youtubeId": "uvc5TdgT3K0",
      "originalName": {
        "ja": "Blue Journey - サザンクロス（歌い分け） - 癒月ちょこ / 大空スバル / さくらみこ / 常闇トワ / 沙花叉クロヱ",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "サザンクロス",
        "en": "",
        "kr": ""
      },
      "artist": "Blue Journey",
      "viewCount": 270869,
      "likeCount": 5556,
      "singers": [
        "oozorasubaru",
        "tokoyamitowa",
        "yuzukichoco",
        "sakamatachloe",
        "sakuramiko"
      ],
      "lyrics": [
        "竹市佳伸"
      ],
      "composition": [
        "竹市佳伸"
      ],
      "arrangement": [
        "竹市佳伸"
      ],
      "isAvailableMV": true,
      "release": [
        "夜明けのうた"
      ],
      "releaseAt": "2023/09/06",
      "order": 12,
      "type": "original",
      "descriptionHtml": {
        "ja": "『サザンクロス』 Streaming \u0026 Download : \u003ca href=\"https://lnk.to/BJ_yu\" target=\"_blank\"\u003ehttps://lnk.to/BJ_yu\u003c/a\u003e （「夜明けのうた」収録楽曲）\u003cbr\u003e\u003cbr\u003e2024.02.07 Release! Blue Journey Major 1st Single 『水たまり』 \u003cbr\u003e詳細はこちら : \u003ca href=\"https://www.universal-music.co.jp/blue-journey/news/mizu/\" target=\"_blank\"\u003ehttps://www.universal-music.co.jp/blue-journey/news/mizu/\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e▼Major 1st Single 『水たまり』シングル予約購入リンク\u003cbr\u003e\u003ca href=\"https://lnk.to/bluejourney_mizutamari\" target=\"_blank\"\u003ehttps://lnk.to/bluejourney_mizutamari\u003c/a\u003e\u003cbr\u003e \u003cbr\u003e▼Blue Journey - Major 1st Single 『水たまり』Teaser Movie\u003cbr\u003e\u003ca href=\"https://youtu.be/oJT166tEmoM\" target=\"_blank\"\u003ehttps://youtu.be/oJT166tEmoM\u003c/a\u003e\u003cbr\u003e\u003cbr\u003eVocal:\u003cbr\u003eアキ・ローゼンタール, 白上フブキ, 湊あくあ, 癒月ちょこ, 大空スバル, 大神ミオ, さくらみこ, 猫又おかゆ, 戌神ころね, 兎田ぺこら, 不知火フレア, 白銀ノエル, 宝鐘マリン, 天音かなた, 角巻わため, 常闇トワ, 姫森ルーナ, 雪花ラミィ, 獅白ぼたん, 尾丸ポルカ, 鷹嶺ルイ, 博衣こより, 沙花叉クロヱ\u003cbr\u003efrom BlueJourney\u003cbr\u003e\u003cbr\u003e【Blue Journey Major 1st Single 『水たまり』 商品概要】\u003cbr\u003e■発売日: 2024.02.07\u003cbr\u003e\u003cbr\u003e◉初回限定盤 ［CD+BOOK］\u003cbr\u003e【三方背トールケース仕様】\u003cbr\u003e品番：UPCH-89551\u003cbr\u003e￥2,750(税込) / ¥2,500(税抜)\u003cbr\u003e\u003cbr\u003e【封入特典】\u003cbr\u003e・32Pアートブック（メンバーソロジャケットイラスト＋プロデューサーインタビュー、衣装設定図収録）\u003cbr\u003e・「水たまり」推し活デコステッカーシート（ジャケットイラスト）\u003cbr\u003e・「水たまり」スタンプステッカー\u003cbr\u003e・トレーディングカード（ジャケットイラスト/メンバーソロ/全23種うち1種ランダム）\u003cbr\u003e・「水たまり」メロディー譜面\u003cbr\u003e\u003cbr\u003e◉通常盤-初回プレス- ［CD］\u003cbr\u003e品番：UPCH-89552\u003cbr\u003e￥1,320(税込) / ¥1,200(税抜)\u003cbr\u003e \u003cbr\u003e【通常盤-初回プレス-封入特典】\u003cbr\u003e・旅先からのレターカード\u003cbr\u003e・「水たまり」スタンプステッカー\u003cbr\u003e・トレーディングカード（ジャケットイラスト/メンバーソロ/全23種うち1種ランダム）\u003cbr\u003e\u003cbr\u003e◉完全生産限定 UNIVERSAL MUSIC STORE盤 ［CD＋BOOK+GOODS］\u003cbr\u003e【三方背トールケース仕様】\u003cbr\u003e品番：DSKU-12806\u003cbr\u003e￥11,000(税込) / ¥10,000(税抜)\u003cbr\u003e \u003cbr\u003e【封入特典】\u003cbr\u003e・32Pアートブック（メンバーソロジャケットイラスト＋プロデューサーインタビュー、衣装設定図収録）\u003cbr\u003e・「水たまり」推し活デコステッカーシート（ジャケットイラスト）\u003cbr\u003e・「水たまり」スタンプステッカー\u003cbr\u003e・「水たまり」メロディー譜面\u003cbr\u003e※封入特典のトレーディングカードは完全生産限定 UNIVERSAL MUSIC STORE盤には付きません。　\u003cbr\u003e\u003cbr\u003e【グッズ】\u003cbr\u003e・ジャケットイラストソロアクリルスタンド\u003cbr\u003e　※本体 H270~300mm / W91〜155mm\u003cbr\u003e　　台座 約H70×W100mm\u003cbr\u003e・メンバーによりサイズが異なります。\u003cbr\u003e・製造過程で多少サイズが前後する可能性がございますので予めご了承ください。\u003cbr\u003e・ジャケットイラストソロA3クリアポスター\u003cbr\u003e※ご購入時にご希望のメンバー1名をご指定いただけます。\u003cbr\u003e※数量限定となっておりますので、完全生産限定 UNIVERSAL MUSIC STORE盤を確実にご購入いただくには12月24日(日)23:59までにご予約ください。\u003cbr\u003e\u003cbr\u003e【収録内容】\u003cbr\u003eM1:水たまり\u003cbr\u003eM2:水たまり(Instrumental)\u003cbr\u003eM3:水たまり(Performance ver.） \u003cbr\u003eM4:水たまり(Instrumental Piano Arrange ver.)\u003cbr\u003eBonus Track:「水たまり」レコーディング NG テイク集\u003cbr\u003e※Bonus Trackは初回限定盤、完全生産限定UNIVERSAL MUSIC STORE盤のみ収録となります。\u003cbr\u003e\u003cbr\u003e【法人別特典】\u003cbr\u003eAmazon.co.jp：ビジュアルシート\u003cbr\u003e楽天ブックス：チケットフォルダー \u003cbr\u003eセブンネット：缶バッジ （44mm） \u003cbr\u003eHMV：ビッグポストカード（140mm×210mm） \u003cbr\u003eタワーレコード：マグネット \u003cbr\u003eアニメイト：2L判ブロマイド \u003cbr\u003eゲーマーズ：A4クリアファイル ＋L判ブロマイド\u003cbr\u003eUNIVERSAL MUSIC STORE：\u003cbr\u003e・初回限定盤、完全生産限定UNIVERSAL MUSIC STORE盤：A4クリアポスター \u003cbr\u003e・通常盤-初回プレス-：アナザージャケット※23種の中から1種ソロジャケットを選択可能\u003cbr\u003e・1st Live「夜明けのうた」シリアルコード配布特典：告知ポスター \u003cbr\u003e応援店：スマホサイズステッカー \u003cbr\u003e \u003cbr\u003e※チェーン毎に特典絵柄が異なります。\u003cbr\u003e※全国のCDショップにて2024年2月7日 (水)発売のCDをご予約・ご購入のお客様に、先着で上記オリジナル特典をプレゼント。各店舗で用意している特典数量には限りがございますので、お早目のご予約をおすすめいたします。\u003cbr\u003e※一部取扱いのない店舗もございます。(詳しくは店頭にてお問い合わせください。)\u003cbr\u003e \u003cbr\u003e【初回プレスCD封入シリアルコード特典】\u003cbr\u003eBlue Journeyのシングル「水たまり」の初回限定盤／通常盤-初回プレス-／完全生産限定UNIVERSAL MUSIC STORE盤にシリアルコード封入。\u003cbr\u003eメンバー個別複製手紙を抽選でプレゼント！\u003cbr\u003e詳細は後日発表させていただきます。\u003cbr\u003e\u003cbr\u003e---\u003cbr\u003e\u003cbr\u003eサザンクロス\u003cbr\u003e\u003cbr\u003e夕日が沈みかける頃 \u003cbr\u003e秋風で散る花を見て \u003cbr\u003eいつまでこうして僕らは \u003cbr\u003eいれるかなんて思った \u003cbr\u003e\u003cbr\u003e霞んだ淡い空 帰り道 \u003cbr\u003e少し寄り道して \u003cbr\u003e\u003cbr\u003e儚くてどこか優しい\u003cbr\u003e僕らが辿るこの日々は\u003cbr\u003e思い出になるときが来ても\u003cbr\u003e輝いてるきっと\u003cbr\u003e「それじゃあ、またあした」\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e先のことなんて\u003cbr\u003eまだわからなくて\u003cbr\u003e速すぎる時の流れも\u003cbr\u003e気づかないふりをした \u003cbr\u003e\u003cbr\u003e未来図を描くほど増えてゆく\u003cbr\u003e今は解けない問い\u003cbr\u003e\u003cbr\u003e悩む時間も眩しくって\u003cbr\u003e離したくないものになって\u003cbr\u003e季節が変わり葉が落ちても\u003cbr\u003e続いてゆくきっと\u003cbr\u003e僕たちの日々は\u003cbr\u003e\u003cbr\u003e「きっと続いてゆく」嘘でも言ってほしい\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e「またあした」と言える今日が\u003cbr\u003e記憶に残らないとしても\u003cbr\u003e二度とは戻らない時間が\u003cbr\u003e答えになって僕を導いてくれるから\u003cbr\u003e\u003cbr\u003e進む道はみんな違うけど\u003cbr\u003e「さよなら、またあした」\u003cbr\u003e\u003cbr\u003e---\u003cbr\u003e\u003cbr\u003e※ホロライブプロダクションから未成年の視聴者の方々へのお願い 下記リンクをご確認の上、お楽しみください。 \u003cbr\u003e\u003ca href=\"https://hololivepro.com/request-to-minors/\" target=\"_blank\"\u003ehttps://hololivepro.com/request-to-minors/\u003c/a\u003e",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/uvc5TdgT3K0/maxresdefault.jpg",
      "publishedAt": "2023-12-27T09:00:42Z"
    },
    {
      "youtubeId": "UyS1mJ7TD5E",
      "originalName": {
        "ja": "Blue Journey - また傷に触れる（歌い分け）- 不知火フレア / 常闇トワ / 尾丸ポルカ",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "また傷に触れる",
        "en": "",
        "kr": ""
      },
      "artist": "Blue Journey",
      "viewCount": 426438,
      "likeCount": 8550,
      "singers": [
        "tokoyamitowa",
        "shiranuiflare",
        "omarupolka"
      ],
      "lyrics": [
        "中居廉"
      ],
      "composition": [
        "中居廉"
      ],
      "arrangement": [
        "樂"
      ],
      "isAvailableMV": true,
      "release": [
        "夜明けのうた"
      ],
      "releaseAt": "2023/09/06",
      "order": 2,
      "type": "original",
      "descriptionHtml": {
        "ja": "『また傷に触れる』 Streaming \u0026 Download : \u003ca href=\"https://lnk.to/BJ_yu\" target=\"_blank\"\u003ehttps://lnk.to/BJ_yu\u003c/a\u003e （「夜明けのうた」収録楽曲）\u003cbr\u003e\u003cbr\u003e2024.02.07 Release! Blue Journey Major 1st Single 『水たまり』 \u003cbr\u003e詳細はこちら : \u003ca href=\"https://www.universal-music.co.jp/blue-journey/news/mizu/\" target=\"_blank\"\u003ehttps://www.universal-music.co.jp/blue-journey/news/mizu/\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e▼Major 1st Single 『水たまり』シングル予約購入リンク\u003cbr\u003e\u003ca href=\"https://lnk.to/bluejourney_mizutamari\" target=\"_blank\"\u003ehttps://lnk.to/bluejourney_mizutamari\u003c/a\u003e\u003cbr\u003e \u003cbr\u003e▼Blue Journey - Major 1st Single 『水たまり』Teaser Movie\u003cbr\u003e\u003ca href=\"https://youtu.be/oJT166tEmoM\" target=\"_blank\"\u003ehttps://youtu.be/oJT166tEmoM\u003c/a\u003e\u003cbr\u003e\u003cbr\u003eVocal:\u003cbr\u003eアキ・ローゼンタール, 白上フブキ, 湊あくあ, 癒月ちょこ, 大空スバル, 大神ミオ, さくらみこ, 猫又おかゆ, 戌神ころね, 兎田ぺこら, 不知火フレア, 白銀ノエル, 宝鐘マリン, 天音かなた, 角巻わため, 常闇トワ, 姫森ルーナ, 雪花ラミィ, 獅白ぼたん, 尾丸ポルカ, 鷹嶺ルイ, 博衣こより, 沙花叉クロヱ\u003cbr\u003efrom BlueJourney\u003cbr\u003e\u003cbr\u003e【Blue Journey Major 1st Single 『水たまり』 商品概要】\u003cbr\u003e■発売日: 2024.02.07\u003cbr\u003e\u003cbr\u003e◉初回限定盤 ［CD+BOOK］\u003cbr\u003e【三方背トールケース仕様】\u003cbr\u003e品番：UPCH-89551\u003cbr\u003e￥2,750(税込) / ¥2,500(税抜)\u003cbr\u003e\u003cbr\u003e【封入特典】\u003cbr\u003e・32Pアートブック（メンバーソロジャケットイラスト＋プロデューサーインタビュー、衣装設定図収録）\u003cbr\u003e・「水たまり」推し活デコステッカーシート（ジャケットイラスト）\u003cbr\u003e・「水たまり」スタンプステッカー\u003cbr\u003e・トレーディングカード（ジャケットイラスト/メンバーソロ/全23種うち1種ランダム）\u003cbr\u003e・「水たまり」メロディー譜面\u003cbr\u003e\u003cbr\u003e◉通常盤-初回プレス- ［CD］\u003cbr\u003e品番：UPCH-89552\u003cbr\u003e￥1,320(税込) / ¥1,200(税抜)\u003cbr\u003e \u003cbr\u003e【通常盤-初回プレス-封入特典】\u003cbr\u003e・旅先からのレターカード\u003cbr\u003e・「水たまり」スタンプステッカー\u003cbr\u003e・トレーディングカード（ジャケットイラスト/メンバーソロ/全23種うち1種ランダム）\u003cbr\u003e\u003cbr\u003e◉完全生産限定 UNIVERSAL MUSIC STORE盤 ［CD＋BOOK+GOODS］\u003cbr\u003e【三方背トールケース仕様】\u003cbr\u003e品番：DSKU-12806\u003cbr\u003e￥11,000(税込) / ¥10,000(税抜)\u003cbr\u003e \u003cbr\u003e【封入特典】\u003cbr\u003e・32Pアートブック（メンバーソロジャケットイラスト＋プロデューサーインタビュー、衣装設定図収録）\u003cbr\u003e・「水たまり」推し活デコステッカーシート（ジャケットイラスト）\u003cbr\u003e・「水たまり」スタンプステッカー\u003cbr\u003e・「水たまり」メロディー譜面\u003cbr\u003e※封入特典のトレーディングカードは完全生産限定 UNIVERSAL MUSIC STORE盤には付きません。　\u003cbr\u003e\u003cbr\u003e【グッズ】\u003cbr\u003e・ジャケットイラストソロアクリルスタンド\u003cbr\u003e　※本体 H270~300mm / W91〜155mm\u003cbr\u003e　　台座 約H70×W100mm\u003cbr\u003e・メンバーによりサイズが異なります。\u003cbr\u003e・製造過程で多少サイズが前後する可能性がございますので予めご了承ください。\u003cbr\u003e・ジャケットイラストソロA3クリアポスター\u003cbr\u003e※ご購入時にご希望のメンバー1名をご指定いただけます。\u003cbr\u003e※数量限定となっておりますので、完全生産限定 UNIVERSAL MUSIC STORE盤を確実にご購入いただくには12月24日(日)23:59までにご予約ください。\u003cbr\u003e\u003cbr\u003e【収録内容】\u003cbr\u003eM1:水たまり\u003cbr\u003eM2:水たまり(Instrumental)\u003cbr\u003eM3:水たまり(Performance ver.） \u003cbr\u003eM4:水たまり(Instrumental Piano Arrange ver.)\u003cbr\u003eBonus Track:「水たまり」レコーディング NG テイク集\u003cbr\u003e※Bonus Trackは初回限定盤、完全生産限定UNIVERSAL MUSIC STORE盤のみ収録となります。\u003cbr\u003e\u003cbr\u003e【法人別特典】\u003cbr\u003eAmazon.co.jp：ビジュアルシート\u003cbr\u003e楽天ブックス：チケットフォルダー \u003cbr\u003eセブンネット：缶バッジ （44mm） \u003cbr\u003eHMV：ビッグポストカード（140mm×210mm） \u003cbr\u003eタワーレコード：マグネット \u003cbr\u003eアニメイト：2L判ブロマイド \u003cbr\u003eゲーマーズ：A4クリアファイル ＋L判ブロマイド\u003cbr\u003eUNIVERSAL MUSIC STORE：\u003cbr\u003e・初回限定盤、完全生産限定UNIVERSAL MUSIC STORE盤：A4クリアポスター \u003cbr\u003e・通常盤-初回プレス-：アナザージャケット※23種の中から1種ソロジャケットを選択可能\u003cbr\u003e・1st Live「夜明けのうた」シリアルコード配布特典：告知ポスター \u003cbr\u003e応援店：スマホサイズステッカー \u003cbr\u003e \u003cbr\u003e※チェーン毎に特典絵柄が異なります。\u003cbr\u003e※全国のCDショップにて2024年2月7日 (水)発売のCDをご予約・ご購入のお客様に、先着で上記オリジナル特典をプレゼント。各店舗で用意している特典数量には限りがございますので、お早目のご予約をおすすめいたします。\u003cbr\u003e※一部取扱いのない店舗もございます。(詳しくは店頭にてお問い合わせください。)\u003cbr\u003e \u003cbr\u003e【初回プレスCD封入シリアルコード特典】\u003cbr\u003eBlue Journeyのシングル「水たまり」の初回限定盤／通常盤-初回プレス-／完全生産限定UNIVERSAL MUSIC STORE盤にシリアルコード封入。\u003cbr\u003eメンバー個別複製手紙を抽選でプレゼント！\u003cbr\u003e詳細は後日発表させていただきます。\u003cbr\u003e\u003cbr\u003e---\u003cbr\u003e\u003cbr\u003eまた傷に触れる\u003cbr\u003e\u003cbr\u003e迷いや憂いを紙に溶かし 記憶の線をなぞる\u003cbr\u003eあの日の孤独に色を足して僕らを描いてゆく\u003cbr\u003e\u003cbr\u003e揺れた\u003cbr\u003e未来見たい世界なら あなたとここにあったはずなのに\u003cbr\u003e空っぽのまま\u003cbr\u003eねぇ、ここが痛いのは あなたがここにあったはずだから\u003cbr\u003e覗き込んで\u003cbr\u003e\u003cbr\u003e触れた最後の日、僕は黙ったまま\u003cbr\u003eその手を離せなくて\u003cbr\u003e「隣にいるから」 なんて言えなくて\u003cbr\u003e心に嘘をついて\u003cbr\u003e\u003cbr\u003eさりげない笑顔もきっと（あなたのような）\u003cbr\u003e呟いた言葉もずっと（眩しく光る)\u003cbr\u003e僕だけの意味を全部残したくて（その理由が知りたかったの ねぇ今だから）\u003cbr\u003eただそれをエゴだと切って（言えるけど）\u003cbr\u003eあなたを描く振りをして（あなたのこと）\u003cbr\u003eあなただけの痛みには気づけなくて（私ずっと気づいてたよ）\u003cbr\u003e\u003cbr\u003e\u003cbr\u003eLa la la...\u003cbr\u003e\u003cbr\u003e\u003cbr\u003eねぇ、ここが痛いのは\u003cbr\u003eねぇ、ここにいたいのは\u003cbr\u003eねぇ、そこにいるのなら\u003cbr\u003eもう今は届くから\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e触れた最後の日、僕は黙ったまま\u003cbr\u003eその手を握りしめて\u003cbr\u003e隣を見渡せば 僕にも見えたから\u003cbr\u003e心に気づいたから\u003cbr\u003e\u003cbr\u003eあなただけの声や仕草も（あなたのこの）\u003cbr\u003e触れられぬ痛みもきっと(心の中)\u003cbr\u003eその全てが僕にとってのあなただったの（その理由を見つけたんだ ねぇ今ならば）\u003cbr\u003eもう今なら言えるから（言えるから)\u003cbr\u003eあなたにあげられるから（あなたはもう)\u003cbr\u003e誰よりも色づいて、ああ（気づいているから）\u003cbr\u003e\u003cbr\u003e閉じ込めた言葉を（誤魔化したもの）\u003cbr\u003eあなたを忘れないように（本当の心を）\u003cbr\u003e今、僕は走る（見落としたこと）\u003cbr\u003eもう二度とあなたを見失いたくないから（大切な言葉を）\u003cbr\u003eまた傷に触れる\u003cbr\u003e---\u003cbr\u003e\u003cbr\u003e※ホロライブプロダクションから未成年の視聴者の方々へのお願い 下記リンクをご確認の上、お楽しみください。 \u003cbr\u003e\u003ca href=\"https://hololivepro.com/request-to-minors/\" target=\"_blank\"\u003ehttps://hololivepro.com/request-to-minors/\u003c/a\u003e",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/UyS1mJ7TD5E/maxresdefault.jpg",
      "publishedAt": "2023-12-04T09:00:30Z"
    },
    {
      "youtubeId": "ScTHsLH_0js",
      "originalName": {
        "ja": "サンビタリア / 常闇トワ(official)",
        "en": "",
        "kr": "산비탈리아 / 토코야미 토와 (공식)"
      },
      "displayName": {
        "ja": "サンビタリア",
        "en": "",
        "kr": "산비탈리아"
      },
      "artist": "常闇トワ",
      "viewCount": 3576966,
      "likeCount": 56675,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": [
        "keeno"
      ],
      "composition": [
        "keeno"
      ],
      "arrangement": [
        "keeno"
      ],
      "isAvailableMV": true,
      "release": [
        "Aster",
        "サンビタリア"
      ],
      "releaseAt": "2023/08/09",
      "order": 8,
      "type": "original",
      "descriptionHtml": {
        "ja": "私の声で君が笑った\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e2023.8.9　0:00 配信開始\u003cbr\u003e\u003ca href=\"https://cover.lnk.to/Sanvitalia\" target=\"_blank\"\u003ehttps://cover.lnk.to/Sanvitalia\u003c/a\u003e\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e常闇トワ\u003cbr\u003e\u003ca href=\"https://twitter.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://twitter.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■作詞・作曲・編曲\u003cbr\u003ekeeno 様\u003cbr\u003e\u003ca href=\"https://twitter.com/kee_no\" target=\"_blank\"\u003ehttps://twitter.com/kee_no\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Mixing Engineer\u003cbr\u003eMasahiro Kawata 様\u003cbr\u003e\u003cbr\u003e■Illust\u003cbr\u003eAちき 様\u003cbr\u003e\u003ca href=\"https://twitter.com/atikix\" target=\"_blank\"\u003ehttps://twitter.com/atikix\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■映像\u003cbr\u003eRoly 様\u003cbr\u003e\u003ca href=\"https://twitter.com/yosinO_mo\" target=\"_blank\"\u003ehttps://twitter.com/yosinO_mo\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■アシスタント\u003cbr\u003eぱんたび 様\u003cbr\u003e\u003ca href=\"https://twitter.com/pantabi_v\" target=\"_blank\"\u003ehttps://twitter.com/pantabi_v\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■リリックデザイン\u003cbr\u003eはづき 様\u003cbr\u003e\u003ca href=\"https://twitter.com/Haduki_Dzn\" target=\"_blank\"\u003ehttps://twitter.com/Haduki_Dzn\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e常闇トワ\u003cbr\u003e\u003cbr\u003e--------------------------------\u003cbr\u003e※ホロライブプロダクションから未成年の視聴者の方々へのお願い\u003cbr\u003e下記リンクをご確認の上、お楽しみください。\u003cbr\u003e\u003ca href=\"https://www.hololive.tv/request-to-mi...\" target=\"_blank\"\u003ehttps://www.hololive.tv/request-to-mi...\u003c/a\u003e\u003cbr\u003e--------------------------------",
        "en": "",
        "kr": "나의 목소리에 네가 웃었어\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e2023년 8월 9일 0시 스트리밍 개시\u003cbr\u003e\u003ca href=\"https://cover.lnk.to/Sanvitalia\" target=\"_blank\"\u003ehttps://cover.lnk.to/Sanvitalia\u003c/a\u003e\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e■보컬\u003cbr\u003e토코야미 토와\u003cbr\u003e\u003ca href=\"https://twitter.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://twitter.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■작사, 작곡, 편곡\u003cbr\u003ekeeno\u003cbr\u003e\u003ca href=\"https://twitter.com/kee_no\" target=\"_blank\"\u003ehttps://twitter.com/kee_no\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■믹싱\u003cbr\u003eMasahiro Kawata\u003cbr\u003e\u003cbr\u003e■일러스트\u003cbr\u003eAちき\u003cbr\u003e\u003ca href=\"https://twitter.com/atikix\" target=\"_blank\"\u003ehttps://twitter.com/atikix\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■영상\u003cbr\u003eRoly\u003cbr\u003e\u003ca href=\"https://twitter.com/yosinO_mo\" target=\"_blank\"\u003ehttps://twitter.com/yosinO_mo\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■어시스턴트\u003cbr\u003eぱんたび\u003cbr\u003e\u003ca href=\"https://twitter.com/pantabi_v\" target=\"_blank\"\u003ehttps://twitter.com/pantabi_v\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■타이포그래피\u003cbr\u003eはづき\u003cbr\u003e\u003ca href=\"https://twitter.com/Haduki_Dzn\" target=\"_blank\"\u003ehttps://twitter.com/Haduki_Dzn\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e토코야미 토와\u003cbr\u003e\u003cbr\u003e--------------------------------\u003cbr\u003e* 미성년자 시청자분들께 부탁드립니다\u003cbr\u003e저희의 콘텐츠를 시청하기 전 부디 아래의 링크를 확인해 주시길 바랍니다\u003cbr\u003e\u003ca href=\"https://hololivepro.com/request-to-mi...\" target=\"_blank\"\u003ehttps://hololivepro.com/request-to-mi...\u003c/a\u003e\u003cbr\u003e--------------------------------\u003cbr\u003e\u003cbr\u003e자막 제작: Lamine, Hiro"
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/ScTHsLH_0js/maxresdefault.jpg",
      "publishedAt": "2023-08-08T11:45:08Z"
    },
    {
      "youtubeId": "G3J06ircgMA",
      "originalName": {
        "ja": "ANEMONE / 常闇トワ(official)",
        "en": "",
        "kr": "ANEMONE / 토코야미 토와 (공식)"
      },
      "displayName": {
        "ja": "ANEMONE",
        "en": "",
        "kr": ""
      },
      "artist": "常闇トワ",
      "viewCount": 2376540,
      "likeCount": 58729,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": [
        "ゆよゆっぺ"
      ],
      "composition": [
        "ゆよゆっぺ"
      ],
      "arrangement": [
        "ゆよゆっぺ"
      ],
      "isAvailableMV": true,
      "release": [
        "Aster",
        "ANEMONE"
      ],
      "releaseAt": "2023/07/24",
      "order": 3,
      "type": "original",
      "descriptionHtml": {
        "ja": "ありのまま生きていたいと\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e2023.7.24　0:00 配信開始\u003cbr\u003e\u003ca href=\"https://cover.lnk.to/ANEMONE\" target=\"_blank\"\u003ehttps://cover.lnk.to/ANEMONE\u003c/a\u003e\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e常闇トワ\u003cbr\u003e\u003ca href=\"https://twitter.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://twitter.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■作詞・作曲・編曲\u003cbr\u003eゆよゆっぺ 様\u003cbr\u003e\u003ca href=\"https://twitter.com/yupeyupe\" target=\"_blank\"\u003ehttps://twitter.com/yupeyupe\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Illust\u003cbr\u003e猫山桜梨 様\u003cbr\u003e\u003ca href=\"https://twitter.com/nekoyama_iori_\" target=\"_blank\"\u003ehttps://twitter.com/nekoyama_iori_\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■映像\u003cbr\u003eRoly 様\u003cbr\u003e\u003ca href=\"https://twitter.com/yosinO_mo\" target=\"_blank\"\u003ehttps://twitter.com/yosinO_mo\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■アシスタント\u003cbr\u003eぱんたび 様\u003cbr\u003e\u003ca href=\"https://twitter.com/pantabi_v\" target=\"_blank\"\u003ehttps://twitter.com/pantabi_v\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■リリックデザイン\u003cbr\u003e玉野ハヅキ 様\u003cbr\u003e\u003ca href=\"https://twitter.com/p_a_r_a_l_l_e_l\" target=\"_blank\"\u003ehttps://twitter.com/p_a_r_a_l_l_e_l\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e--------------------------------\u003cbr\u003e※ホロライブプロダクションから未成年の視聴者の方々へのお願い\u003cbr\u003e下記リンクをご確認の上、お楽しみください。\u003cbr\u003e\u003ca href=\"https://www.hololive.tv/request-to-mi...\" target=\"_blank\"\u003ehttps://www.hololive.tv/request-to-mi...\u003c/a\u003e\u003cbr\u003e--------------------------------",
        "en": "",
        "kr": "있는 그대로 살고 싶다고\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e2023년 7월 24일 0시 스트리밍 개시\u003cbr\u003e\u003ca href=\"https://cover.lnk.to/ANEMONE\" target=\"_blank\"\u003ehttps://cover.lnk.to/ANEMONE\u003c/a\u003e\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e■보컬\u003cbr\u003e토코야미 토와\u003cbr\u003e\u003ca href=\"https://twitter.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://twitter.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■작사, 작곡, 편곡\u003cbr\u003eゆよゆっぺ\u003cbr\u003e\u003ca href=\"https://twitter.com/yupeyupe\" target=\"_blank\"\u003ehttps://twitter.com/yupeyupe\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■일러스트\u003cbr\u003e猫山桜梨\u003cbr\u003e\u003ca href=\"https://twitter.com/nekoyama_iori_\" target=\"_blank\"\u003ehttps://twitter.com/nekoyama_iori_\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■영상\u003cbr\u003eRoly\u003cbr\u003e\u003ca href=\"https://twitter.com/yosinO_mo\" target=\"_blank\"\u003ehttps://twitter.com/yosinO_mo\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■어시스턴트\u003cbr\u003eぱんたび 様\u003cbr\u003e\u003ca href=\"https://twitter.com/pantabi_v\" target=\"_blank\"\u003ehttps://twitter.com/pantabi_v\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■타이포그래피\u003cbr\u003e玉野ハヅキ 様\u003cbr\u003e\u003ca href=\"https://twitter.com/p_a_r_a_l_l_e_l\" target=\"_blank\"\u003ehttps://twitter.com/p_a_r_a_l_l_e_l\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e자막 제작: Lamine, Hiro"
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/G3J06ircgMA/maxresdefault.jpg",
      "publishedAt": "2023-07-23T12:00:11Z"
    },
    {
      "youtubeId": "HUup3W2aMgk",
      "originalName": {
        "ja": "ラヴィ(Lavie) / 常闇トワ (cover)",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "ラヴィ(Lavie)",
        "en": "",
        "kr": ""
      },
      "artist": "すりぃ",
      "viewCount": 5884227,
      "likeCount": 75585,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": null,
      "composition": null,
      "arrangement": null,
      "isAvailableMV": true,
      "release": null,
      "releaseAt": "",
      "order": 0,
      "type": "cover",
      "descriptionHtml": {
        "ja": "無駄で無駄で愚かさすら気付けないよね\u003cbr\u003e\u003cbr\u003eスマホゲーム #コンパス 戦闘摂理解析システム　“ラヴィ” テーマソング\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e■素敵な本家様\u003cbr\u003e『ラヴィ(Lavie)』/すりぃ様\u003cbr\u003e\u003ca href=\"https://www.youtube.com/watch?v=mq88yUFdVng\" target=\"_blank\"\u003ehttps://www.youtube.com/watch?v=mq88yUFdVng\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■MIX\u003cbr\u003eアキモトユウスケ様\u003cbr\u003e\u003ca href=\"https://twitter.com/_uskuskusk_\" target=\"_blank\"\u003ehttps://twitter.com/_uskuskusk_\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Illust\u003cbr\u003eおにねこ様\u003cbr\u003e\u003ca href=\"https://twitter.com/onineko26\" target=\"_blank\"\u003ehttps://twitter.com/onineko26\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Movie\u003cbr\u003eSaiA様\u003cbr\u003e\u003ca href=\"https://twitter.com/Shomijokun\" target=\"_blank\"\u003ehttps://twitter.com/Shomijokun\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e常闇トワ\u003cbr\u003e\u003ca href=\"https://twitter.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://twitter.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e--------------------------------\u003cbr\u003e※ホロライブプロダクションから未成年の視聴者の方々へのお願い\u003cbr\u003e下記リンクをご確認の上、お楽しみください。\u003cbr\u003e\u003ca href=\"https://www.hololive.tv/request-to-mi...\" target=\"_blank\"\u003ehttps://www.hololive.tv/request-to-mi...\u003c/a\u003e\u003cbr\u003e--------------------------------",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/HUup3W2aMgk/maxresdefault.jpg",
      "publishedAt": "2023-07-19T11:55:12Z"
    },
    {
      "youtubeId": "_ByrYK3oppY",
      "originalName": {
        "ja": "アイデンティティ / 常闇トワ × Hakos Baelz(cover)",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "アイデンティティ",
        "en": "",
        "kr": ""
      },
      "artist": "Kanaria",
      "viewCount": 2992145,
      "likeCount": 56999,
      "singers": [
        "tokoyamitowa",
        "hakosbaelz"
      ],
      "lyrics": null,
      "composition": null,
      "arrangement": null,
      "isAvailableMV": true,
      "release": null,
      "releaseAt": "",
      "order": 0,
      "type": "cover",
      "descriptionHtml": {
        "ja": "やっと見つけた不思議の正体\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e■素敵な本家様\u003cbr\u003e『アイデンティティ』/Kanaria様\u003cbr\u003e\u003ca href=\"https://www.youtube.com/watch?v=M9moY0hEJRE\" target=\"_blank\"\u003ehttps://www.youtube.com/watch?v=M9moY0hEJRE\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■MIX\u003cbr\u003eアキモトユウスケ様\u003cbr\u003e\u003ca href=\"https://twitter.com/_uskuskusk_\" target=\"_blank\"\u003ehttps://twitter.com/_uskuskusk_\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Illust\u003cbr\u003eはこに様\u003cbr\u003e\u003ca href=\"https://twitter.com/852_box\" target=\"_blank\"\u003ehttps://twitter.com/852_box\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Movie\u003cbr\u003eゴマヒチ様\u003cbr\u003e\u003ca href=\"https://twitter.com/705gouki\" target=\"_blank\"\u003ehttps://twitter.com/705gouki\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e常闇トワ　\u003ca href=\"https://www.youtube.com/@TokoyamiTowa\" target=\"_blank\"\u003e@TokoyamiTowa\u003c/a\u003e \u003cbr\u003e\u003ca href=\"https://twitter.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://twitter.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Vocal　\u003ca href=\"https://www.youtube.com/@HakosBaelz\" target=\"_blank\"\u003e@HakosBaelz\u003c/a\u003e \u003cbr\u003eHakos Baelz\u003cbr\u003e\u003ca href=\"https://twitter.com/hakosbaelz\" target=\"_blank\"\u003ehttps://twitter.com/hakosbaelz\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e--------------------------------\u003cbr\u003e※ホロライブプロダクションから未成年の視聴者の方々へのお願い\u003cbr\u003e下記リンクをご確認の上、お楽しみください。\u003cbr\u003e\u003ca href=\"https://www.hololive.tv/request-to-mi...\" target=\"_blank\"\u003ehttps://www.hololive.tv/request-to-mi...\u003c/a\u003e\u003cbr\u003e--------------------------------",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/_ByrYK3oppY/maxresdefault.jpg",
      "publishedAt": "2023-06-19T11:00:10Z"
    },
    {
      "youtubeId": "fmDHfS0fXm4",
      "originalName": {
        "ja": "W/X/Y / 常闇トワ(cover)",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "W/X/Y",
        "en": "",
        "kr": ""
      },
      "artist": "Tani Yuuki",
      "viewCount": 10116161,
      "likeCount": 98708,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": null,
      "composition": null,
      "arrangement": null,
      "isAvailableMV": true,
      "release": null,
      "releaseAt": "",
      "order": 0,
      "type": "cover",
      "descriptionHtml": {
        "ja": "君がいなきゃ今もどこかで\u003cbr\u003e動けないままの僕で\u003cbr\u003eありがとうを伝えたいのです\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e■素敵な本家様\u003cbr\u003e『W/X/Y』/Tani Yuuki様\u003cbr\u003e\u003ca href=\"https://www.youtube.com/watch?v=mp2-w15SXms\" target=\"_blank\"\u003ehttps://www.youtube.com/watch?v=mp2-w15SXms\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■MIX\u003cbr\u003e淳 洋一様\u003cbr\u003e\u003ca href=\"https://twitter.com/jun40am\" target=\"_blank\"\u003ehttps://twitter.com/jun40am\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Illust\u003cbr\u003e眩しい様\u003cbr\u003e\u003ca href=\"https://twitter.com/MABUSHI__\" target=\"_blank\"\u003ehttps://twitter.com/MABUSHI__\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Movie\u003cbr\u003e花春様\u003cbr\u003e\u003ca href=\"https://twitter.com/KaSyun02\" target=\"_blank\"\u003ehttps://twitter.com/KaSyun02\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■instrumental\u003cbr\u003eきこり様\u003cbr\u003e\u003ca href=\"https://twitter.com/kikori_11\" target=\"_blank\"\u003ehttps://twitter.com/kikori_11\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e常闇トワ\u003cbr\u003e\u003ca href=\"https://twitter.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://twitter.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e--------------------------------\u003cbr\u003e※ホロライブプロダクションから未成年の視聴者の方々へのお願い\u003cbr\u003e下記リンクをご確認の上、お楽しみください。\u003cbr\u003e\u003ca href=\"https://www.hololive.tv/request-to-mi...\" target=\"_blank\"\u003ehttps://www.hololive.tv/request-to-mi...\u003c/a\u003e\u003cbr\u003e--------------------------------",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/fmDHfS0fXm4/maxresdefault.jpg",
      "publishedAt": "2023-05-13T09:00:10Z"
    },
    {
      "youtubeId": "p1lfwyWSGV4",
      "originalName": {
        "ja": "空奏列車 ／ Startend cover",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "空奏列車",
        "en": "",
        "kr": ""
      },
      "artist": "Orangestar",
      "viewCount": 7798640,
      "likeCount": 90705,
      "singers": [
        "tokoyamitowa",
        "hoshimachisuisei",
        "minatoaqua"
      ],
      "lyrics": null,
      "composition": null,
      "arrangement": null,
      "isAvailableMV": true,
      "release": null,
      "releaseAt": "",
      "order": 0,
      "type": "cover",
      "descriptionHtml": {
        "ja": "風になってしまえよ僕ら \u003cbr\u003e\u003cbr\u003e■本家様：\u003ca href=\"https://youtu.be/xzoShzMIlIM\" target=\"_blank\"\u003ehttps://youtu.be/xzoShzMIlIM\u003c/a\u003e\u003cbr\u003e■vocal：\u003cbr\u003e湊あくあ　\u003ca href=\"https://twitter.com/minatoaqua\" target=\"_blank\"\u003ehttps://twitter.com/minatoaqua\u003c/a\u003e\u003cbr\u003e常闇トワ　\u003ca href=\"https://www.youtube.com/@TokoyamiTowa\" target=\"_blank\"\u003e@TokoyamiTowa\u003c/a\u003e \u003cbr\u003e星街すいせい　\u003ca href=\"https://www.youtube.com/@HoshimachiSuisei\" target=\"_blank\"\u003e@HoshimachiSuisei\u003c/a\u003e \u003cbr\u003e■illust：brat 様　\u003ca href=\"https://twitter.com/brabrabrat00\" target=\"_blank\"\u003ehttps://twitter.com/brabrabrat00\u003c/a\u003e\u003cbr\u003e■Movie：空橋ナオト(スタジオメイビー) 様　\u003ca href=\"https://twitter.com/Sorahashi_Naoto\" target=\"_blank\"\u003ehttps://twitter.com/Sorahashi_Naoto\u003c/a\u003e\u003cbr\u003e■Movie Direction：紺色。(スタジオメイビー) 様　\u003ca href=\"https://twitter.com/kon7iro\" target=\"_blank\"\u003ehttps://twitter.com/kon7iro\u003c/a\u003e\u003cbr\u003e■ Guitar ：東山智有 \u003ca href=\"https://twitter.com/720tomoare\" target=\"_blank\"\u003ehttps://twitter.com/720tomoare\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e※ホロライブプロダクションから未成年の視聴者の方々へのお願い\u003cbr\u003e下記リンクをご確認の上、お楽しみください。\u003cbr\u003e\u003ca href=\"https://hololivepro.com/request-to-minors/\" target=\"_blank\"\u003ehttps://hololivepro.com/request-to-minors/\u003c/a\u003e",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/p1lfwyWSGV4/maxresdefault.jpg",
      "publishedAt": "2023-03-17T11:00:08Z"
    },
    {
      "youtubeId": "HBmss54l5zc",
      "originalName": {
        "ja": "U.F.O. - U Feel Overjoyed! - / 常闇トワ(official)",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "U.F.O. - U Feel Overjoyed! -",
        "en": "",
        "kr": ""
      },
      "artist": "常闇トワ",
      "viewCount": 1736533,
      "likeCount": 49620,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": [
        "Fuki(Unlucky Morpheus)"
      ],
      "composition": [
        "紫煉(Unlucky Morpheus)"
      ],
      "arrangement": [
        "紫煉(Unlucky Morpheus)"
      ],
      "isAvailableMV": true,
      "release": [
        "U.F.O. - U Feel Overjoyed! -"
      ],
      "releaseAt": "2023/03/01",
      "order": 1,
      "type": "original",
      "descriptionHtml": {
        "ja": "提供：日清焼そばU.F.O.\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e常闇トワ\u003cbr\u003e\u003ca href=\"https://twitter.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://twitter.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■作曲\u003cbr\u003e紫煉(Unlucky Morpheus)様\u003cbr\u003e\u003ca href=\"https://twitter.com/shiren_ANKM\" target=\"_blank\"\u003ehttps://twitter.com/shiren_ANKM\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■作詞\u003cbr\u003eFuki(Unlucky Morpheus)様\u003cbr\u003e\u003ca href=\"https://twitter.com/Fuki_official\" target=\"_blank\"\u003ehttps://twitter.com/Fuki_official\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Illust\u003cbr\u003eスコッティ様\u003cbr\u003e\u003ca href=\"https://twitter.com/Sco_ttie\" target=\"_blank\"\u003ehttps://twitter.com/Sco_ttie\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e■楽曲ロゴデザイン\u003cbr\u003e籠乃あさぎり様\u003cbr\u003e\u003ca href=\"https://twitter.com/kagono_asagiri\" target=\"_blank\"\u003ehttps://twitter.com/kagono_asagiri\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e■Special thanks\u003cbr\u003eChorus：Fuki（Unlucky Morpheus）様\u003cbr\u003eGuitar：紫煉（Unlucky Morpheus）様\u003cbr\u003eGuitar：仁耶（Unlucky Morpheus）様\u003cbr\u003eViolin：Jill（Unlucky Morpheus）様\u003cbr\u003eBass：Hiroyuki Ogawa（Unlucky Morpheus）様\u003cbr\u003eDrums：FUMIYA（Unlucky Morpheus）様\u003cbr\u003e\u003ca href=\"https://twitter.com/ankimo_official\" target=\"_blank\"\u003ehttps://twitter.com/ankimo_official\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e#アクマなUFO #ホロライブ #常闇トワ\u003cbr\u003e\u003cbr\u003e＜「常闇トワのアクマ的濃い濃いうまい!」キャンペーン実施中！＞\u003cbr\u003e本コラボ企画のために制作された楽曲を収録した「常闇トワ・コラボ楽曲特製CD」や、イラストレーターの加川壱互さんが描き下ろした「オリジナルB2サイズ タペストリー」などが合計3,600名に当たります。\u003cbr\u003e詳しくはこちら　\u003ca href=\"https://nissin-cp.com/u.f.o.-tokoyamitowa.2023/\" target=\"_blank\"\u003ehttps://nissin-cp.com/u.f.o.-tokoyamitowa.2023/\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e＜『アクマなデリシャスナイト』開催！＞\u003cbr\u003eコラボを記念した「常闇トワ」の初のオンラインソロライブを「日清食品 POWER STATION [REBOOT]」から配信いたします。オリジナルのコラボ楽曲を中心とした、「常闇トワ」の\"アクマ的\"な魅力が詰まったライブです。チケット絶賛販売中！！\u003cbr\u003e詳しくはこちら　\u003ca href=\"https://nissin-ps.com/live/detail/63c99d91\" target=\"_blank\"\u003ehttps://nissin-ps.com/live/detail/63c99d91\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e--------------------------------\u003cbr\u003e※ホロライブプロダクションから未成年の視聴者の方々へのお願い\u003cbr\u003e下記リンクをご確認の上、お楽しみください。\u003cbr\u003e\u003ca href=\"https://www.hololive.tv/request-to-minors\" target=\"_blank\"\u003ehttps://www.hololive.tv/request-to-minors\u003c/a\u003e\u003cbr\u003e--------------------------------",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/HBmss54l5zc/maxresdefault.jpg",
      "publishedAt": "2023-02-11T10:00:08Z"
    },
    {
      "youtubeId": "HM_El_RDfLY",
      "originalName": {
        "ja": "浴槽とネオンテトラ/ 常闇トワ × 猫又おかゆ(cover)",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "浴槽とネオンテトラ",
        "en": "",
        "kr": ""
      },
      "artist": "flower",
      "viewCount": 4496355,
      "likeCount": 66316,
      "singers": [
        "tokoyamitowa",
        "nekomataokayu"
      ],
      "lyrics": null,
      "composition": null,
      "arrangement": null,
      "isAvailableMV": true,
      "release": null,
      "releaseAt": "",
      "order": 0,
      "type": "cover",
      "descriptionHtml": {
        "ja": "-\u003cbr\u003e\u003cbr\u003e“つまんねえ 最後にキスしてあげない♡”\u003cbr\u003e\u003cbr\u003e本家様‣\u003ca href=\"https://youtu.be/NrfLlgv02hs\" target=\"_blank\"\u003ehttps://youtu.be/NrfLlgv02hs\u003c/a\u003e\u003cbr\u003e\u003cbr\u003eIllust :けんはる ( \u003ca href=\"https://twitter.com/harukenharu\" target=\"_blank\"\u003ehttps://twitter.com/harukenharu\u003c/a\u003e ) \u003cbr\u003eMix : ごず ( \u003ca href=\"https://twitter.com/_gozu777\" target=\"_blank\"\u003ehttps://twitter.com/_gozu777\u003c/a\u003e ) \u003cbr\u003eMovie : T A I H A N( \u003ca href=\"https://twitter.com/taihan90\" target=\"_blank\"\u003ehttps://twitter.com/taihan90\u003c/a\u003e ) \u003cbr\u003eVocal : 常闇トワ ( \u003ca href=\"https://www.youtube.com/@TokoyamiTowa\" target=\"_blank\"\u003e@TokoyamiTowa\u003c/a\u003e  ) 猫又おかゆ( \u003ca href=\"https://www.youtube.com/@NekomataOkayu\" target=\"_blank\"\u003e@NekomataOkayu\u003c/a\u003e  )\u003cbr\u003e\u003cbr\u003e❥・・ ┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈ ・・❥\u003cbr\u003e\u003cbr\u003eTwitter : \u003ca href=\"https://twitter.com/nekomataokayu\" target=\"_blank\"\u003ehttps://twitter.com/nekomataokayu\u003c/a\u003e\u003cbr\u003e( sub )  : \u003ca href=\"https://twitter.com/MO_OKAYU_GU\" target=\"_blank\"\u003ehttps://twitter.com/MO_OKAYU_GU\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e❥・・ ┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈ ・・❥\u003cbr\u003e\u003cbr\u003eMember ship 🍙\u003cbr\u003e❥ 毎月書き下ろしスマホ用壁紙配布\u003cbr\u003e❥ 名前の横にメンバーバッチの追加\u003cbr\u003e❥ 専用絵文字の使用\u003cbr\u003e❥ メンバーシップ限定配信( 企画系ASMR/セリフ読みetc... )\u003cbr\u003e\u003cbr\u003e登録はコチラから ୨୧⑅*\u003cbr\u003e\u003ca href=\"https://www.youtube.com/channel/UCvaTdHTWBGv3MKj3KVqJVCw/join\" target=\"_blank\"\u003ehttps://www.youtube.com/channel/UCvaTdHTWBGv3MKj3KVqJVCw/join\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e❥・・ ┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈ ・・❥\u003cbr\u003e\u003cbr\u003ehashtag 🍙\u003cbr\u003e生放送関連 : #生おかゆ 切り抜き : #おに切り\u003cbr\u003eファンネーム : #おにぎりゃー\u003cbr\u003e\u003cbr\u003e❥・・ ┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈ ・・❥\u003cbr\u003e\u003cbr\u003eGoods 📢\u003cbr\u003e\u003cbr\u003eLINE スタンプ : \u003ca href=\"https://store.line.me/stickershop/product/16921213/ja\" target=\"_blank\"\u003ehttps://store.line.me/stickershop/product/16921213/ja\u003c/a\u003e \u003cbr\u003e誕生日記念2022 ボイスフルセット : \u003ca href=\"https://shop.hololivepro.com/products/nekomataokayu_bd2022\" target=\"_blank\"\u003ehttps://shop.hololivepro.com/products/nekomataokayu_bd2022\u003c/a\u003e \u003cbr\u003e\u003cbr\u003e❥・・ ┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈┈ ・・❥\u003cbr\u003e\u003cbr\u003eホロライブプロダクション\u003cbr\u003e❥ 公式サイト\u003cbr\u003e\u003ca href=\"https://www.hololive.tv/\" target=\"_blank\"\u003ehttps://www.hololive.tv/\u003c/a\u003e\u003cbr\u003e❥ ホロジュール\u003cbr\u003e\u003ca href=\"https://schedule.hololive.tv/#hololive\" target=\"_blank\"\u003ehttps://schedule.hololive.tv/#hololive\u003c/a\u003e\u003cbr\u003e❥ 公式Twitter\u003cbr\u003e\u003ca href=\"https://twitter.com/hololivetv\" target=\"_blank\"\u003ehttps://twitter.com/hololivetv\u003c/a\u003e\u003cbr\u003e❥ 公式オンラインショップ\u003cbr\u003e\u003ca href=\"https://hololive.booth.pm/\" target=\"_blank\"\u003ehttps://hololive.booth.pm/\u003c/a\u003e\u003cbr\u003e❥ ホロライブ公式チャンネル\u003cbr\u003e\u003ca href=\"https://www.youtube.com/channel/UCJFZiqLMntJufDCHc6bQixg\" target=\"_blank\"\u003ehttps://www.youtube.com/channel/UCJFZiqLMntJufDCHc6bQixg\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e※ホロライブプロダクションから未成年の視聴者の方々へのお願い\u003cbr\u003e下記リンクをご確認の上、お楽しみください。\u003cbr\u003e\u003ca href=\"https://www.hololive.tv/request-to-minors\" target=\"_blank\"\u003ehttps://www.hololive.tv/request-to-minors\u003c/a\u003e",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/HM_El_RDfLY/maxresdefault.jpg",
      "publishedAt": "2023-01-30T09:00:09Z"
    },
    {
      "youtubeId": "_8L2KJeoHGo",
      "originalName": {
        "ja": "QUEEN/常闇トワ(cover)",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "QUEEN",
        "en": "",
        "kr": ""
      },
      "artist": "Kanaria",
      "viewCount": 1830048,
      "likeCount": 40750,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": null,
      "composition": null,
      "arrangement": null,
      "isAvailableMV": true,
      "release": null,
      "releaseAt": "",
      "order": 0,
      "type": "cover",
      "descriptionHtml": {
        "ja": "それなら僕と踊りませんか\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e■素敵な本家様\u003cbr\u003e『QUEEN』/Kanaria様\u003cbr\u003e\u003ca href=\"https://www.youtube.com/watch?v=KFCaSz_yYCM\" target=\"_blank\"\u003ehttps://www.youtube.com/watch?v=KFCaSz_yYCM\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■MIX\u003cbr\u003e淳 洋一様\u003cbr\u003e\u003ca href=\"https://twitter.com/jun40am\" target=\"_blank\"\u003ehttps://twitter.com/jun40am\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Illust\u003cbr\u003eNey様\u003cbr\u003e\u003ca href=\"https://twitter.com/cognacbear\" target=\"_blank\"\u003ehttps://twitter.com/cognacbear\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Movie\u003cbr\u003e花春様\u003cbr\u003e\u003ca href=\"https://twitter.com/KaSyun02\" target=\"_blank\"\u003ehttps://twitter.com/KaSyun02\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e常闇トワ\u003cbr\u003e\u003ca href=\"https://twitter.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://twitter.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*\u003cbr\u003e\u003cbr\u003e◆ホロライブプロダクション\u003cbr\u003e👾公式サイト👾\u003cbr\u003e\u003ca href=\"https://www.hololive.tv/\" target=\"_blank\"\u003ehttps://www.hololive.tv/\u003c/a\u003e\u003cbr\u003e👾公式Twitter👾\u003cbr\u003e\u003ca href=\"https://twitter.com/hololivetv\" target=\"_blank\"\u003ehttps://twitter.com/hololivetv\u003c/a\u003e\u003cbr\u003e👾公式チャンネル👾\u003cbr\u003e\u003ca href=\"https://www.youtube.com/channel/UCJFZ...\" target=\"_blank\"\u003ehttps://www.youtube.com/channel/UCJFZ...\u003c/a\u003e",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/_8L2KJeoHGo/maxresdefault.jpg",
      "publishedAt": "2023-01-03T13:00:24Z"
    },
    {
      "youtubeId": "08J6WAmX100",
      "originalName": {
        "ja": "【MV】Blooming in the Mud ・泥中に咲く  - ウォルピスカーター || HAKOS BAELZ X TOKOYAMI TOWA COVER",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "泥中に咲く",
        "en": "",
        "kr": ""
      },
      "artist": "ウォルピスカーター",
      "viewCount": 2645254,
      "likeCount": 54284,
      "singers": [
        "hakosbaelz",
        "tokoyamitowa"
      ],
      "lyrics": null,
      "composition": null,
      "arrangement": null,
      "isAvailableMV": true,
      "release": null,
      "releaseAt": "",
      "order": 0,
      "type": "cover",
      "descriptionHtml": {
        "ja": "This is a dream come true. \u003cbr\u003eI had the honor of covering this beautiful song with one of my singing idols!! T_T\u003cbr\u003ePlease enjoy this cover by myself and \u003ca href=\"https://www.youtube.com/@TokoyamiTowa\" target=\"_blank\"\u003e@TokoyamiTowa\u003c/a\u003e \u003cbr\u003e««-------------- ≪ °◇◆◇° ≫ --------------»»\u003cbr\u003e\u003cbr\u003e≪CREDITS≫\u003cbr\u003e\u003cbr\u003eOriginal Song: Wolpis Carter\u003cbr\u003eVocals: Hakos Baelz X Tokoyami Towa\u003cbr\u003eArrange Track: fu-rin\u003cbr\u003eMix: よしけん\u003cbr\u003eArt: まころん\u003cbr\u003eMovie: まるいち\u003cbr\u003e\u003cbr\u003eSubtitling: T-chan\u003cbr\u003e\u003cbr\u003eoriginal: \u003ca href=\"https://youtu.be/40dJS_LC6S8\" target=\"_blank\"\u003ehttps://youtu.be/40dJS_LC6S8\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e««-------------- ≪ °◇◆◇° ≫ --------------»»\u003cbr\u003e\u003cbr\u003e#holoCouncil \u003cbr\u003e#hololiveEnglish\u003cbr\u003e\u003cbr\u003e≪HASHTAGS≫\u003cbr\u003e\u003cbr\u003eLIVE: #enterbaelz/#ベール登場　\u003cbr\u003eMUSIC:#MADDOOFS\u003cbr\u003eFANART:#illustrayBAE/#ベーアート\u003cbr\u003eMEME:#YABAEL/#ヤベール\u003cbr\u003eFAN-NAME: #baerats (brats)\u003cbr\u003e\u003cbr\u003e≪TWITTER≫\u003cbr\u003e\u003ca href=\"https://twitter.com/hakosbaelz\" target=\"_blank\"\u003ehttps://twitter.com/hakosbaelz\u003c/a\u003e\u003cbr\u003e@hakosbaelz\u003cbr\u003e\u003cbr\u003e««-------------- ≪ °◇◆◇° ≫ --------------»»\u003cbr\u003e\u003cbr\u003e[Fan Work Guidelines]\u003cbr\u003e\u003ca href=\"https://en.hololive.tv/terms\" target=\"_blank\"\u003ehttps://en.hololive.tv/terms\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e««-------------- ≪ °◇◆◇° ≫ --------------»»\u003cbr\u003e\u003cbr\u003e[Official Online Shop]\u003cbr\u003e\u003ca href=\"https://hololive.booth.pm/\" target=\"_blank\"\u003ehttps://hololive.booth.pm/\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e[Holoschedule] (Check all members streaming schedules)\u003cbr\u003e\u003ca href=\"https://schedule.hololive.tv/#hololive\" target=\"_blank\"\u003ehttps://schedule.hololive.tv/#hololive\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e««-------------- ≪ °◇◆◇° ≫ --------------»»\u003cbr\u003e\u003cbr\u003e[Hololive Production]\u003cbr\u003e・Hololive English YouTube Channel: \u003ca href=\"https://t.co/LcYDgFF9V0?amp=1\" target=\"_blank\"\u003ehttps://t.co/LcYDgFF9V0?amp=1\u003c/a\u003e\u003cbr\u003e・Hololive Production Official Twitter: \u003ca href=\"https://twitter.com/hololivetv\" target=\"_blank\"\u003ehttps://twitter.com/hololivetv\u003c/a\u003e\u003cbr\u003e・Hololive English Official Twitter: \u003ca href=\"https://twitter.com/hololive_En\" target=\"_blank\"\u003ehttps://twitter.com/hololive_En\u003c/a\u003e\u003cbr\u003e・Hololive English Official Reddit: \u003ca href=\"https://www.reddit.com/r/Hololive/\" target=\"_blank\"\u003ehttps://www.reddit.com/r/Hololive/\u003c/a\u003e",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/08J6WAmX100/maxresdefault.jpg",
      "publishedAt": "2022-12-26T03:00:07Z"
    },
    {
      "youtubeId": "zu0DHyWBwpM",
      "originalName": {
        "ja": "光るなら / 常闇トワ×ロボ子さん×夜空メル×鷹嶺ルイ×沙花叉クロヱ(cover)",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "光るなら",
        "en": "",
        "kr": ""
      },
      "artist": "Goose house",
      "viewCount": 2976068,
      "likeCount": 65376,
      "singers": [
        "tokoyamitowa",
        "robocosan",
        "yozoramel",
        "takanelui",
        "sakamatachloe"
      ],
      "lyrics": null,
      "composition": null,
      "arrangement": null,
      "isAvailableMV": true,
      "release": null,
      "releaseAt": "",
      "order": 0,
      "type": "cover",
      "descriptionHtml": {
        "ja": "悲しみを笑顔に もう隠さないで\u003cbr\u003e煌めくどんな星も 君を照らすから\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e■素敵な本家様\u003cbr\u003e『光るなら』/ Goose house 様\u003cbr\u003e\u003ca href=\"https://www.youtube.com/watch?v=SnXkhkEvNIM\" target=\"_blank\"\u003ehttps://www.youtube.com/watch?v=SnXkhkEvNIM\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■MIX\u003cbr\u003e淳洋一様（@jun40am）\u003cbr\u003e\u003ca href=\"https://twitter.com/jun40am\" target=\"_blank\"\u003ehttps://twitter.com/jun40am\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Illust\u003cbr\u003eユウヤ 様（@yuya_illust_）\u003cbr\u003e\u003ca href=\"https://twitter.com/yuya_illust_\" target=\"_blank\"\u003ehttps://twitter.com/yuya_illust_\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Movie\u003cbr\u003eSyamo.G-しゃもじ- 様（@syamoji_0114）\u003cbr\u003e\u003ca href=\"https://twitter.com/syamoji_0114\" target=\"_blank\"\u003ehttps://twitter.com/syamoji_0114\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Inst\u003cbr\u003eきこり 様（@kikori_11）\u003cbr\u003e\u003ca href=\"https://twitter.com/kikori_11\" target=\"_blank\"\u003ehttps://twitter.com/kikori_11\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e常闇トワ（@tokoyamitowa）\u003ca href=\"https://www.youtube.com/@TokoyamiTowa\" target=\"_blank\"\u003e@TokoyamiTowa\u003c/a\u003e \u003cbr\u003e\u003ca href=\"https://twitter.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://twitter.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003eロボ子さん(@robocosan)  \u003ca href=\"https://www.youtube.com/@Robocosan\" target=\"_blank\"\u003e@Robocosan\u003c/a\u003e \u003cbr\u003e\u003ca href=\"https://twitter.com/robocosan\" target=\"_blank\"\u003ehttps://twitter.com/robocosan\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e夜空メル(@yozoramel)   \u003ca href=\"https://www.youtube.com/@YozoraMel\" target=\"_blank\"\u003e@YozoraMel\u003c/a\u003e \u003cbr\u003e\u003ca href=\"https://twitter.com/yozoramel\" target=\"_blank\"\u003ehttps://twitter.com/yozoramel\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e鷹嶺ルイ(@takanelui)   \u003ca href=\"https://www.youtube.com/@TakaneLui\" target=\"_blank\"\u003e@TakaneLui\u003c/a\u003e \u003cbr\u003e\u003ca href=\"https://twitter.com/takanelui\" target=\"_blank\"\u003ehttps://twitter.com/takanelui\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e沙花叉クロヱ(@sakamatachloe)   \u003ca href=\"https://www.youtube.com/@SakamataChloe\" target=\"_blank\"\u003e@SakamataChloe\u003c/a\u003e \u003cbr\u003e\u003ca href=\"https://twitter.com/sakamatachloe\" target=\"_blank\"\u003ehttps://twitter.com/sakamatachloe\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*\u003cbr\u003e\u003cbr\u003e◆ホロライブプロダクション\u003cbr\u003e👾公式サイト👾\u003cbr\u003e\u003ca href=\"https://www.hololive.tv/\" target=\"_blank\"\u003ehttps://www.hololive.tv/\u003c/a\u003e\u003cbr\u003e👾公式Twitter👾\u003cbr\u003e\u003ca href=\"https://twitter.com/hololivetv\" target=\"_blank\"\u003ehttps://twitter.com/hololivetv\u003c/a\u003e\u003cbr\u003e👾公式チャンネル👾\u003cbr\u003e\u003ca href=\"https://www.youtube.com/channel/UCJFZ...\" target=\"_blank\"\u003ehttps://www.youtube.com/channel/UCJFZ...\u003c/a\u003e",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/zu0DHyWBwpM/maxresdefault.jpg",
      "publishedAt": "2022-09-20T12:00:16Z"
    },
    {
      "youtubeId": "SVVyG36QwqI",
      "originalName": {
        "ja": "リモコン / 常闇トワ×桃鈴ねね(cover)",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "リモコン",
        "en": "",
        "kr": ""
      },
      "artist": "じーざすP",
      "viewCount": 3004589,
      "likeCount": 47823,
      "singers": [
        "tokoyamitowa",
        "momosuzunene"
      ],
      "lyrics": null,
      "composition": null,
      "arrangement": null,
      "isAvailableMV": true,
      "release": null,
      "releaseAt": "",
      "order": 0,
      "type": "cover",
      "descriptionHtml": {
        "ja": "気にしないのがアナタのポリシー？\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e■素敵な本家様\u003cbr\u003e『リモコン』/ じーざすP 様\u003cbr\u003e\u003ca href=\"https://www.youtube.com/watch?v=1st0XSY0VKQ\" target=\"_blank\"\u003ehttps://www.youtube.com/watch?v=1st0XSY0VKQ\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■MIX\u003cbr\u003e淳洋一様（@jun40am）\u003cbr\u003e\u003ca href=\"https://twitter.com/jun40am\" target=\"_blank\"\u003ehttps://twitter.com/jun40am\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Illust\u003cbr\u003eハルアキ四季 様（@haru4aki）\u003cbr\u003e\u003ca href=\"https://twitter.com/haru4aki\" target=\"_blank\"\u003ehttps://twitter.com/haru4aki\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Movie\u003cbr\u003eしょうけい 様（@shoukeisun）\u003cbr\u003e\u003ca href=\"https://twitter.com/shoukeisun\" target=\"_blank\"\u003ehttps://twitter.com/shoukeisun\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e常闇トワ（@tokoyamitowa）\u003ca href=\"https://www.youtube.com/@TokoyamiTowa\" target=\"_blank\"\u003e@TokoyamiTowa\u003c/a\u003e \u003cbr\u003e\u003ca href=\"https://twitter.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://twitter.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e桃鈴ねね(@momosuzunene) \u003ca href=\"https://www.youtube.com/@MomosuzuNene\" target=\"_blank\"\u003e@MomosuzuNene\u003c/a\u003e \u003cbr\u003e\u003ca href=\"https://twitter.com/momosuzunene\" target=\"_blank\"\u003ehttps://twitter.com/momosuzunene\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e#ねねねトワワ\u003cbr\u003e\u003cbr\u003e○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*\u003cbr\u003e\u003cbr\u003e◆ホロライブプロダクション\u003cbr\u003e👾公式サイト👾\u003cbr\u003e\u003ca href=\"https://www.hololive.tv/\" target=\"_blank\"\u003ehttps://www.hololive.tv/\u003c/a\u003e\u003cbr\u003e👾公式Twitter👾\u003cbr\u003e\u003ca href=\"https://twitter.com/hololivetv\" target=\"_blank\"\u003ehttps://twitter.com/hololivetv\u003c/a\u003e\u003cbr\u003e👾公式チャンネル👾\u003cbr\u003e\u003ca href=\"https://www.youtube.com/channel/UCJFZ...\" target=\"_blank\"\u003ehttps://www.youtube.com/channel/UCJFZ...\u003c/a\u003e",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/SVVyG36QwqI/maxresdefault.jpg",
      "publishedAt": "2022-08-25T11:15:10Z"
    },
    {
      "youtubeId": "TcwMO-QU3ak",
      "originalName": {
        "ja": "Like a Phoenix",
        "en": "Like a Phoenix",
        "kr": ""
      },
      "displayName": {
        "ja": "Like a Phoenix",
        "en": "",
        "kr": ""
      },
      "artist": "ORIO (天音かなた・常闇トワ)",
      "viewCount": 521658,
      "likeCount": 5595,
      "singers": [
        "amanekanata",
        "tokoyamitowa"
      ],
      "lyrics": [
        "やぎぬまかな"
      ],
      "composition": [
        "佐藤カズキ"
      ],
      "arrangement": [
        "佐藤カズキ"
      ],
      "isAvailableMV": false,
      "release": [
        "Over Time"
      ],
      "releaseAt": "2022/07/30",
      "order": 2,
      "type": "original",
      "descriptionHtml": {
        "ja": "Provided to YouTube by cover corp.\u003cbr\u003e\u003cbr\u003eLike a Phoenix · Amane Kanata · Tokoyami Towa · Kana Yaginuma · Kazuki Sato · Kazuki Sato\u003cbr\u003e\u003cbr\u003eOver Time\u003cbr\u003e\u003cbr\u003eReleased on: 2022-07-30\u003cbr\u003e\u003cbr\u003eAuto-generated by YouTube.",
        "en": "Provided to YouTube by cover corp.\u003cbr\u003e\u003cbr\u003eLike a Phoenix · Amane Kanata · Tokoyami Towa · Kana Yaginuma · Kazuki Sato · Kazuki Sato\u003cbr\u003e\u003cbr\u003eOver Time\u003cbr\u003e\u003cbr\u003eReleased on: 2022-07-30\u003cbr\u003e\u003cbr\u003eAuto-generated by YouTube.",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/TcwMO-QU3ak/maxresdefault.jpg",
      "publishedAt": "2022-07-29T10:07:49Z"
    },
    {
      "youtubeId": "9uyK-EMEDgA",
      "originalName": {
        "ja": "Pray",
        "en": "Pray",
        "kr": ""
      },
      "displayName": {
        "ja": "Pray",
        "en": "",
        "kr": ""
      },
      "artist": "ORIO (天音かなた・常闇トワ)",
      "viewCount": 807240,
      "likeCount": 8412,
      "singers": [
        "amanekanata",
        "tokoyamitowa"
      ],
      "lyrics": [
        "オフトントゥ"
      ],
      "composition": [
        "t+pazolite"
      ],
      "arrangement": [
        "t+pazolite"
      ],
      "isAvailableMV": false,
      "release": [
        "Over Time"
      ],
      "releaseAt": "2022/07/30",
      "order": 3,
      "type": "original",
      "descriptionHtml": {
        "ja": "Provided to YouTube by cover corp.\u003cbr\u003e\u003cbr\u003ePray · Amane Kanata · Tokoyami Towa · Ofutonttu · t+pazolite · t+pazolite\u003cbr\u003e\u003cbr\u003eOver Time\u003cbr\u003e\u003cbr\u003eReleased on: 2022-07-30\u003cbr\u003e\u003cbr\u003eAuto-generated by YouTube.",
        "en": "Provided to YouTube by cover corp.\u003cbr\u003e\u003cbr\u003ePray · Amane Kanata · Tokoyami Towa · Ofutonttu · t+pazolite · t+pazolite\u003cbr\u003e\u003cbr\u003eOver Time\u003cbr\u003e\u003cbr\u003eReleased on: 2022-07-30\u003cbr\u003e\u003cbr\u003eAuto-generated by YouTube.",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/9uyK-EMEDgA/maxresdefault.jpg",
      "publishedAt": "2022-07-29T10:07:32Z"
    },
    {
      "youtubeId": "nWP8Wmho188",
      "originalName": {
        "ja": "【Cover】シニカルナイトプラン (Cynical Night Plan) / Pavolia Reine × Tokoyami Towa",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "シニカルナイトプラン",
        "en": "",
        "kr": ""
      },
      "artist": "Ayase",
      "viewCount": 920893,
      "likeCount": 26552,
      "singers": [
        "tokoyamitowa",
        "pavoliareine"
      ],
      "lyrics": null,
      "composition": null,
      "arrangement": null,
      "isAvailableMV": true,
      "release": null,
      "releaseAt": "",
      "order": 0,
      "type": "cover",
      "descriptionHtml": {
        "ja": "シニカルナイトプラン / Ayase 様\u003cbr\u003e\u003ca href=\"https://www.youtube.com/watch?v=zyRt-nBM3dY\" target=\"_blank\"\u003ehttps://www.youtube.com/watch?v=zyRt-nBM3dY\u003c/a\u003e\u003cbr\u003e\u003cbr\u003eMix: REDSHiFT\u003cbr\u003e\u003ca href=\"https://twitter.com/REDSHiFT_ID\" target=\"_blank\"\u003ehttps://twitter.com/REDSHiFT_ID\u003c/a\u003e\u003cbr\u003e\u003cbr\u003eTuning: sagisapon\u003cbr\u003e\u003ca href=\"https://twitter.com/sagisapon\" target=\"_blank\"\u003ehttps://twitter.com/sagisapon\u003c/a\u003e\u003cbr\u003e\u003cbr\u003eIllust: Puunyan\u003cbr\u003e\u003ca href=\"https://twitter.com/Puunyannyan\" target=\"_blank\"\u003ehttps://twitter.com/Puunyannyan\u003c/a\u003e\u003cbr\u003e\u003cbr\u003eMovie: EveningLights [KuliKomis]\u003cbr\u003e\u003ca href=\"https://twitter.com/EveningLightsID\" target=\"_blank\"\u003ehttps://twitter.com/EveningLightsID\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e☆.｡.:*･ﾟ☆.｡.:*･ﾟ☆.｡.:*･ﾟ☆.｡.:*･ﾟ☆.｡.:*･ﾟ☆.｡.:*･ﾟ☆.｡.:*･ﾟ☆\u003cbr\u003e\u003cbr\u003eVocals:\u003cbr\u003ePavolia Reine\u003cbr\u003e\u003ca href=\"https://twitter.com/pavoliareine\" target=\"_blank\"\u003ehttps://twitter.com/pavoliareine\u003c/a\u003e\u003cbr\u003e\u003ca href=\"https://www.youtube.com/channel/UChgTyjG-pdNvxxhdsXfHQ5Q\" target=\"_blank\"\u003ehttps://www.youtube.com/channel/UChgTyjG-pdNvxxhdsXfHQ5Q\u003c/a\u003e\u003cbr\u003e\u003cbr\u003eTokoyami Towa/常闇トワ\u003cbr\u003e\u003ca href=\"https://twitter.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://twitter.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003ca href=\"https://www.youtube.com/channel/UC1uv2Oq6kNxgATlCiez59hw\" target=\"_blank\"\u003ehttps://www.youtube.com/channel/UC1uv2Oq6kNxgATlCiez59hw\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e☆.｡.:*･ﾟ☆.｡.:*･ﾟ☆.｡.:*･ﾟ☆.｡.:*･ﾟ☆.｡.:*･ﾟ☆.｡.:*･ﾟ☆.｡.:*･ﾟ☆\u003cbr\u003e【Twitter】\u003cbr\u003e\u003ca href=\"https://twitter.com/pavoliareine\" target=\"_blank\"\u003ehttps://twitter.com/pavoliareine\u003c/a\u003e\u003cbr\u003e【Instagram】\u003cbr\u003e\u003ca href=\"https://instagram.com/pavoliareine\" target=\"_blank\"\u003ehttps://instagram.com/pavoliareine\u003c/a\u003e\u003cbr\u003e【Facebook Page】\u003cbr\u003e\u003ca href=\"https://www.facebook.com/pavoliareine/\" target=\"_blank\"\u003ehttps://www.facebook.com/pavoliareine/\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e【Iida Pochi-mama】\u003cbr\u003e• Twitter: \u003ca href=\"https://twitter.com/lizhi3\" target=\"_blank\"\u003ehttps://twitter.com/lizhi3\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e【Ilie Tou-papa】\u003cbr\u003e• Twitter: \u003ca href=\"https://twitter.com/tou_ilie\" target=\"_blank\"\u003ehttps://twitter.com/tou_ilie\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e【BGM】\u003cbr\u003eMinari-san\u003cbr\u003e• Twitter: \u003ca href=\"https://twitter.com/minari_studio\" target=\"_blank\"\u003ehttps://twitter.com/minari_studio\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e↓↓↓Support the other holoID gen 2 girls!↓↓↓\u003cbr\u003e【Kureiji Ollie】\u003cbr\u003e• Channel: \u003ca href=\"https://t.co/VJ3jCqeGR3?amp=1\" target=\"_blank\"\u003ehttps://t.co/VJ3jCqeGR3?amp=1\u003c/a\u003e\u003cbr\u003e• Twitter: \u003ca href=\"https://twitter.com/kureijiollie\" target=\"_blank\"\u003ehttps://twitter.com/kureijiollie\u003c/a\u003e\u003cbr\u003e• Instagram: \u003ca href=\"https://instagram.com/kureijiollie\" target=\"_blank\"\u003ehttps://instagram.com/kureijiollie\u003c/a\u003e\u003cbr\u003e• Facebook: \u003ca href=\"https://www.facebook.com/kureijiollie\" target=\"_blank\"\u003ehttps://www.facebook.com/kureijiollie\u003c/a\u003e\u003cbr\u003e【Anya Melfissa】\u003cbr\u003e• Channel: \u003ca href=\"https://t.co/Up4HqrcnSG?amp=1\" target=\"_blank\"\u003ehttps://t.co/Up4HqrcnSG?amp=1\u003c/a\u003e\u003cbr\u003e• Twitter: \u003ca href=\"https://twitter.com/anyamelfissa\" target=\"_blank\"\u003ehttps://twitter.com/anyamelfissa\u003c/a\u003e\u003cbr\u003e• Instagram: \u003ca href=\"https://instagram.com/anyamelfissa\" target=\"_blank\"\u003ehttps://instagram.com/anyamelfissa\u003c/a\u003e\u003cbr\u003e• Facebook: \u003ca href=\"https://www.facebook.com/anyamelfissa/\" target=\"_blank\"\u003ehttps://www.facebook.com/anyamelfissa/\u003c/a\u003e \u003cbr\u003e\u003cbr\u003e↓↓↓and also our lovely gen 1 senpai!↓↓↓\u003cbr\u003e【Ayunda Risu】\u003cbr\u003e• Channel: \u003ca href=\"https://t.co/3AI0d4Vkbo?amp=1\" target=\"_blank\"\u003ehttps://t.co/3AI0d4Vkbo?amp=1\u003c/a\u003e\u003cbr\u003e• Twitter: \u003ca href=\"https://twitter.com/ayunda_risu\" target=\"_blank\"\u003ehttps://twitter.com/ayunda_risu\u003c/a\u003e\u003cbr\u003e【Moona Hoshinova】\u003cbr\u003e• Channel: \u003ca href=\"https://t.co/W68ItCZBTg?amp=1\" target=\"_blank\"\u003ehttps://t.co/W68ItCZBTg?amp=1\u003c/a\u003e\u003cbr\u003e• Twitter: \u003ca href=\"https://twitter.com/moonahoshinova\" target=\"_blank\"\u003ehttps://twitter.com/moonahoshinova\u003c/a\u003e\u003cbr\u003e【Airani Iofifteen】\u003cbr\u003e• Channel: \u003ca href=\"https://t.co/ATHpGQeH2b?amp=1\" target=\"_blank\"\u003ehttps://t.co/ATHpGQeH2b?amp=1\u003c/a\u003e\u003cbr\u003e• Twitter: \u003ca href=\"https://twitter.com/airaniiofifteen\" target=\"_blank\"\u003ehttps://twitter.com/airaniiofifteen\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e【Official cover website】\u003cbr\u003e\u003ca href=\"http://cover-corp.com/\" target=\"_blank\"\u003ehttp://cover-corp.com/\u003c/a\u003e\u003cbr\u003e【Official YouTube Channel hololive Indonesia】\u003cbr\u003e\u003ca href=\"https://www.youtube.com/c/hololiveIndonesia\" target=\"_blank\"\u003ehttps://www.youtube.com/c/hololiveIndonesia\u003c/a\u003e\u003cbr\u003e【Official Twitter hololive Indonesia】\u003cbr\u003e\u003ca href=\"https://twitter.com/hololive_Id\" target=\"_blank\"\u003ehttps://twitter.com/hololive_Id\u003c/a\u003e\u003cbr\u003e【Official Facebook hololive Indonesia】\u003cbr\u003e\u003ca href=\"https://www.facebook.com/Hololive-Indonesia-108806367277672/\" target=\"_blank\"\u003ehttps://www.facebook.com/Hololive-Indonesia-108806367277672/\u003c/a\u003e",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/nWP8Wmho188/maxresdefault.jpg",
      "publishedAt": "2022-07-22T12:00:10Z"
    },
    {
      "youtubeId": "ShXmOdYGuG8",
      "originalName": {
        "ja": "キャットラビング / 常闇トワ×猫又おかゆ(cover)",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "キャットラビング",
        "en": "",
        "kr": ""
      },
      "artist": "香椎モイミ",
      "viewCount": 4638601,
      "likeCount": 76663,
      "singers": [
        "tokoyamitowa",
        "nekomataokayu"
      ],
      "lyrics": null,
      "composition": null,
      "arrangement": null,
      "isAvailableMV": true,
      "release": null,
      "releaseAt": "",
      "order": 0,
      "type": "cover",
      "descriptionHtml": {
        "ja": "にゃんって良い子にするから　愛して\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e■素敵な本家様\u003cbr\u003e『キャットラビング』/ 香椎モイミ feat. 可不様\u003cbr\u003e\u003ca href=\"https://www.youtube.com/watch?v=7gwvBrlUiww\" target=\"_blank\"\u003ehttps://www.youtube.com/watch?v=7gwvBrlUiww\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■MIX\u003cbr\u003e淳洋一様（@jun40am）\u003cbr\u003e\u003ca href=\"https://twitter.com/jun40am\" target=\"_blank\"\u003ehttps://twitter.com/jun40am\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Illust\u003cbr\u003eましろしき様（@si10ra）\u003cbr\u003e\u003ca href=\"https://twitter.com/si10ra\" target=\"_blank\"\u003ehttps://twitter.com/si10ra\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Movie\u003cbr\u003eSaiA/再映 様（@Shomijokun）\u003cbr\u003e\u003ca href=\"https://twitter.com/Shomijokun\" target=\"_blank\"\u003ehttps://twitter.com/Shomijokun\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e常闇トワ（@tokoyamitowa）\u003ca href=\"https://www.youtube.com/@TokoyamiTowa\" target=\"_blank\"\u003e@TokoyamiTowa\u003c/a\u003e \u003cbr\u003e\u003ca href=\"https://twitter.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://twitter.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e猫又おかゆ(@nekomataokayu) \u003ca href=\"https://www.youtube.com/@NekomataOkayu\" target=\"_blank\"\u003e@NekomataOkayu\u003c/a\u003e \u003cbr\u003e\u003ca href=\"https://twitter.com/nekomataokayu\" target=\"_blank\"\u003ehttps://twitter.com/nekomataokayu\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*\u003cbr\u003e\u003cbr\u003e◆ホロライブプロダクション\u003cbr\u003e👾公式サイト👾\u003cbr\u003e\u003ca href=\"https://www.hololive.tv/\" target=\"_blank\"\u003ehttps://www.hololive.tv/\u003c/a\u003e\u003cbr\u003e👾公式Twitter👾\u003cbr\u003e\u003ca href=\"https://twitter.com/hololivetv\" target=\"_blank\"\u003ehttps://twitter.com/hololivetv\u003c/a\u003e\u003cbr\u003e👾公式チャンネル👾\u003cbr\u003e\u003ca href=\"https://www.youtube.com/channel/UCJFZ...\" target=\"_blank\"\u003ehttps://www.youtube.com/channel/UCJFZ...\u003c/a\u003e",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/ShXmOdYGuG8/maxresdefault.jpg",
      "publishedAt": "2022-07-01T11:00:15Z"
    },
    {
      "youtubeId": "7AQi222UFrA",
      "originalName": {
        "ja": "ダイアモンド クレバス / 常闇トワ×AZKi(cover)",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "ダイアモンド クレバス",
        "en": "",
        "kr": ""
      },
      "artist": "May'n",
      "viewCount": 3966728,
      "likeCount": 68938,
      "singers": [
        "tokoyamitowa",
        "azki"
      ],
      "lyrics": null,
      "composition": null,
      "arrangement": null,
      "isAvailableMV": true,
      "release": null,
      "releaseAt": "",
      "order": 0,
      "type": "cover",
      "descriptionHtml": {
        "ja": "ｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e■素敵な本家様\u003cbr\u003e『ダイアモンド クレバス』/May'n様\u003cbr\u003e\u003cbr\u003e■MIX\u003cbr\u003e淳洋一様（＠jun40am）\u003cbr\u003e\u003ca href=\"https://twitter.com/jun40am\" target=\"_blank\"\u003ehttps://twitter.com/jun40am\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Illust\u003cbr\u003e魔王マオ様（@maoh_v）\u003cbr\u003e\u003ca href=\"https://twitter.com/maoh_v\" target=\"_blank\"\u003ehttps://twitter.com/maoh_v\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Movie\u003cbr\u003eまるいち様（@yasai0827）\u003cbr\u003e\u003ca href=\"https://twitter.com/yasai0827\" target=\"_blank\"\u003ehttps://twitter.com/yasai0827\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e常闇トワ（@tokoyamitowa）\u003cbr\u003e\u003ca href=\"https://twitter.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://twitter.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003ca href=\"https://www.youtube.com/@TokoyamiTowa\" target=\"_blank\"\u003e@TokoyamiTowa\u003c/a\u003e \u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003eAZKi(@AZKi_VDiVA)\u003cbr\u003e\u003ca href=\"https://twitter.com/AZKi_VDiVA\" target=\"_blank\"\u003ehttps://twitter.com/AZKi_VDiVA\u003c/a\u003e\u003cbr\u003e@AZKi",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/7AQi222UFrA/maxresdefault.jpg",
      "publishedAt": "2022-05-25T11:00:13Z"
    },
    {
      "youtubeId": "5ArDbvfds9k",
      "originalName": {
        "ja": "【MV】Over Time / ORIO【天音かなた・常闇トワ】",
        "en": "[MV] ORIO - Over Time [Amane Kanata, Tokoyami Towa]",
        "kr": ""
      },
      "displayName": {
        "ja": "Over Time",
        "en": "",
        "kr": ""
      },
      "artist": "ORIO (天音かなた・常闇トワ)",
      "viewCount": 932677,
      "likeCount": 36683,
      "singers": [
        "amanekanata",
        "tokoyamitowa"
      ],
      "lyrics": [
        "やぎぬまかな"
      ],
      "composition": [
        "佐藤カズキ"
      ],
      "arrangement": [
        "佐藤カズキ"
      ],
      "isAvailableMV": true,
      "release": [
        "Over Time"
      ],
      "releaseAt": "2022/05/02",
      "order": 1,
      "type": "original",
      "descriptionHtml": {
        "ja": "ORIO1st Single『Over Time』配信中🎶\u003cbr\u003e\u003ca href=\"https://cover.lnk.to/OverTime\" target=\"_blank\"\u003ehttps://cover.lnk.to/OverTime\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e天音かなた・常闇トワによるhololive IDOL PROJECTの新ユニット、ORIO(オーリオ)が遂に始動❢\u003cbr\u003e\u003cbr\u003e「Over Time」\u003cbr\u003eVocal: ORIO（天音かなた、常闇トワ）\u003cbr\u003eMusic: 佐藤カズキ\u003cbr\u003eLyrics: やぎぬまかな\u003cbr\u003eguitar: 佐藤カズキ\u003cbr\u003eBass: 永井正道\u003cbr\u003eMIX: Masahiro Kawata\u003cbr\u003eMV制作: ノノル \u003ca href=\"https://twitter.com/nonolu41?s=21\u0026t=dVcOQtzkkTNt_99cuPOEUQ\" target=\"_blank\"\u003ehttps://twitter.com/nonolu41?s=21\u0026t=dVcOQtzkkTNt_99cuPOEUQ\u003c/a\u003e\u003cbr\u003e文字制作: を \u003ca href=\"https://twitter.com/wo___dw\" target=\"_blank\"\u003ehttps://twitter.com/wo___dw\u003c/a\u003e",
        "en": "ORIO's 1st Single \"Over Time\" now available on streaming services!🎶\u003cbr\u003e\u003ca href=\"https://cover.lnk.to/OverTime\" target=\"_blank\"\u003ehttps://cover.lnk.to/OverTime\u003c/a\u003e\u003cbr\u003e\u003cbr\u003eAt last, hololive IDOL PROJECT's new unit, ORIO, featuring Amane Kanata and Tokoyami Towa, has arisen‼️\u003cbr\u003e\u003cbr\u003eOver Time\u003cbr\u003eVocal: ORIO (Amane Kanata, Tokoyami Towa)\u003cbr\u003eMusic: Kazuki Sato\u003cbr\u003eLyrics: Kana Yaginuma\u003cbr\u003eGuitar: Kazuki Sato\u003cbr\u003eBass: Masamichi Nagai\u003cbr\u003eMIX: Masahiro Kawata\u003cbr\u003eMV: nonolu \u003ca href=\"https://twitter.com/nonolu41\" target=\"_blank\"\u003ehttps://twitter.com/nonolu41\u003c/a\u003e\u003cbr\u003eLettering: wo \u003ca href=\"https://twitter.com/wo___dw\" target=\"_blank\"\u003ehttps://twitter.com/wo___dw\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e▶Vocalists▷\u003cbr\u003eBe sure to follow and subscribe to your favorite!\u003cbr\u003e[Amane Kanata] \u003ca href=\"https://www.youtube.com/c/AmaneKanataCh\" target=\"_blank\"\u003ehttps://www.youtube.com/c/AmaneKanataCh\u003c/a\u003e\u003cbr\u003e[Tokoyami Towa] \u003ca href=\"https://www.youtube.com/channel/UC1uv2Oq6kNxgATlCiez59hw\" target=\"_blank\"\u003ehttps://www.youtube.com/channel/UC1uv2Oq6kNxgATlCiez59hw\u003c/a\u003e\u003cbr\u003e\u003cbr\u003eTranslation: fts\u003cbr\u003eSubtitling, Quality Check: T-chan",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/5ArDbvfds9k/maxresdefault.jpg",
      "publishedAt": "2022-05-10T09:00:04Z"
    },
    {
      "youtubeId": "XpgSrULHibg",
      "originalName": {
        "ja": "アスノヨゾラ哨戒班 ／ Startend cover",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "アスノヨゾラ哨戒班",
        "en": "",
        "kr": ""
      },
      "artist": "Orangestar",
      "viewCount": 25963336,
      "likeCount": 266322,
      "singers": [
        "tokoyamitowa",
        "hoshimachisuisei",
        "minatoaqua"
      ],
      "lyrics": null,
      "composition": null,
      "arrangement": null,
      "isAvailableMV": true,
      "release": null,
      "releaseAt": "",
      "order": 0,
      "type": "cover",
      "descriptionHtml": {
        "ja": "今日の日をいつか思い出せ\u003cbr\u003e未来の僕ら \u003cbr\u003e\u003cbr\u003e■本家様：\u003ca href=\"https://youtu.be/XogSflwXgpw\" target=\"_blank\"\u003ehttps://youtu.be/XogSflwXgpw\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■vocal：Startend\u003cbr\u003e湊あくあ　\u003ca href=\"https://twitter.com/minatoaqua\" target=\"_blank\"\u003ehttps://twitter.com/minatoaqua\u003c/a\u003e \u003ca href=\"https://www.youtube.com/@MinatoAqua\" target=\"_blank\"\u003e@MinatoAqua\u003c/a\u003e \u003cbr\u003e常闇トワ　\u003ca href=\"https://twitter.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://twitter.com/tokoyamitowa\u003c/a\u003e \u003ca href=\"https://www.youtube.com/@TokoyamiTowa\" target=\"_blank\"\u003e@TokoyamiTowa\u003c/a\u003e \u003cbr\u003e星街すいせい　\u003ca href=\"https://twitter.com/suisei_hosimati\" target=\"_blank\"\u003ehttps://twitter.com/suisei_hosimati\u003c/a\u003e \u003ca href=\"https://www.youtube.com/@HoshimachiSuisei\" target=\"_blank\"\u003e@HoshimachiSuisei\u003c/a\u003e \u003cbr\u003e\u003cbr\u003e■mix：NNZN様　\u003ca href=\"https://twitter.com/nnznsss\" target=\"_blank\"\u003ehttps://twitter.com/nnznsss\u003c/a\u003e\u003cbr\u003e■illust：brat様　\u003ca href=\"https://twitter.com/brabrabrat00\" target=\"_blank\"\u003ehttps://twitter.com/brabrabrat00\u003c/a\u003e\u003cbr\u003e■movie：紺色。様　\u003ca href=\"https://twitter.com/kon7iro\" target=\"_blank\"\u003ehttps://twitter.com/kon7iro\u003c/a\u003e",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/XpgSrULHibg/maxresdefault.jpg",
      "publishedAt": "2022-04-16T10:00:50Z"
    },
    {
      "youtubeId": "XXuMwJIAHsY",
      "originalName": {
        "ja": "ギラギラ / 常闇トワ(cover)",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "ギラギラ",
        "en": "",
        "kr": ""
      },
      "artist": "Ado",
      "viewCount": 3771328,
      "likeCount": 81641,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": null,
      "composition": null,
      "arrangement": null,
      "isAvailableMV": true,
      "release": null,
      "releaseAt": "",
      "order": 0,
      "type": "cover",
      "descriptionHtml": {
        "ja": "今に見てろ\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e■素敵な本家様\u003cbr\u003e『ギラギラ』/Ado様\u003cbr\u003e・\u003ca href=\"https://www.youtube.com/watch?v=sOiMD45QGLs\" target=\"_blank\"\u003ehttps://www.youtube.com/watch?v=sOiMD45QGLs\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■MIX\u003cbr\u003e淳洋一様（＠jun40am）\u003cbr\u003e\u003ca href=\"https://twitter.com/jun40am\" target=\"_blank\"\u003ehttps://twitter.com/jun40am\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Illust\u003cbr\u003eかかげ様（@kakage0904）\u003cbr\u003e\u003ca href=\"https://twitter.com/kakage0904\" target=\"_blank\"\u003ehttps://twitter.com/kakage0904\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Movie\u003cbr\u003eRoly様（@yosinO_mo）\u003cbr\u003e\u003ca href=\"https://twitter.com/yosinO_mo\" target=\"_blank\"\u003ehttps://twitter.com/yosinO_mo\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e常闇トワ（@tokoyamitowa）\u003cbr\u003e\u003ca href=\"https://twitter.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://twitter.com/tokoyamitowa\u003c/a\u003e",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/XXuMwJIAHsY/maxresdefault.jpg",
      "publishedAt": "2022-04-10T10:30:14Z"
    },
    {
      "youtubeId": "D8pdSRs_C4o",
      "originalName": {
        "ja": "桜ノ雨 / 常闇トワ×さくらみこ×アキ・ローゼンタール×尾丸ポルカ×風真いろは(cover)",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "桜ノ雨",
        "en": "",
        "kr": ""
      },
      "artist": "halyosy",
      "viewCount": 2748053,
      "likeCount": 65571,
      "singers": [
        "tokoyamitowa",
        "sakuramiko",
        "akirose",
        "omarupolka",
        "kazamairoha"
      ],
      "lyrics": null,
      "composition": null,
      "arrangement": null,
      "isAvailableMV": true,
      "release": null,
      "releaseAt": "",
      "order": 0,
      "type": "cover",
      "descriptionHtml": {
        "ja": "僕らが巡り逢えた奇跡\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e■素敵な本家様\u003cbr\u003e『桜ノ雨』/halyosy様\u003cbr\u003e\u003ca href=\"https://www.youtube.com/watch?v=1UAkQP8tytM\" target=\"_blank\"\u003ehttps://www.youtube.com/watch?v=1UAkQP8tytM\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■MIX\u003cbr\u003e淳 洋一様（@jun40am）\u003cbr\u003e\u003ca href=\"https://twitter.com/jun40am\" target=\"_blank\"\u003ehttps://twitter.com/jun40am\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Illust\u003cbr\u003e壱十九様（@ittokyu）\u003cbr\u003e\u003ca href=\"https://twitter.com/ittokyu\" target=\"_blank\"\u003ehttps://twitter.com/ittokyu\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Movie\u003cbr\u003eたいすけ様（@taisuke_001）\u003cbr\u003e\u003ca href=\"https://twitter.com/taisuke_001\" target=\"_blank\"\u003ehttps://twitter.com/taisuke_001\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e常闇トワ \u003ca href=\"https://www.youtube.com/@TokoyamiTowa\" target=\"_blank\"\u003e@TokoyamiTowa\u003c/a\u003e \u003cbr\u003e\u003ca href=\"https://twitter.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://twitter.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003eさくらみこ \u003ca href=\"https://www.youtube.com/@SakuraMiko\" target=\"_blank\"\u003e@SakuraMiko\u003c/a\u003e \u003cbr\u003e\u003ca href=\"https://twitter.com/sakuramiko35\" target=\"_blank\"\u003ehttps://twitter.com/sakuramiko35\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003eアキ・ローゼンタール　\u003ca href=\"https://www.youtube.com/@AkiRosenthal\" target=\"_blank\"\u003e@AkiRosenthal\u003c/a\u003e \u003cbr\u003e\u003ca href=\"https://twitter.com/akirosenthal\" target=\"_blank\"\u003ehttps://twitter.com/akirosenthal\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e尾丸ポルカ　\u003ca href=\"https://www.youtube.com/@OmaruPolka\" target=\"_blank\"\u003e@OmaruPolka\u003c/a\u003e \u003cbr\u003e\u003ca href=\"https://twitter.com/omarupolka\" target=\"_blank\"\u003ehttps://twitter.com/omarupolka\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e風真いろは　\u003ca href=\"https://www.youtube.com/@kazamairoha\" target=\"_blank\"\u003e@kazamairoha\u003c/a\u003e \u003cbr\u003e\u003ca href=\"https://twitter.com/kazamairohach\" target=\"_blank\"\u003ehttps://twitter.com/kazamairohach\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*\u003cbr\u003e\u003cbr\u003e◆ホロライブプロダクション\u003cbr\u003e👾公式サイト👾\u003cbr\u003e\u003ca href=\"https://www.hololive.tv/\" target=\"_blank\"\u003ehttps://www.hololive.tv/\u003c/a\u003e\u003cbr\u003e👾公式Twitter👾\u003cbr\u003e\u003ca href=\"https://twitter.com/hololivetv\" target=\"_blank\"\u003ehttps://twitter.com/hololivetv\u003c/a\u003e\u003cbr\u003e👾公式チャンネル👾\u003cbr\u003e\u003ca href=\"https://www.youtube.com/channel/UCJFZ...\" target=\"_blank\"\u003ehttps://www.youtube.com/channel/UCJFZ...\u003c/a\u003e",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/D8pdSRs_C4o/maxresdefault.jpg",
      "publishedAt": "2022-03-23T12:00:12Z"
    },
    {
      "youtubeId": "F1_OQXNF8b8",
      "originalName": {
        "ja": "AKUMA",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "AKUMA",
        "en": "",
        "kr": ""
      },
      "artist": "常闇トワ",
      "viewCount": 5128852,
      "likeCount": 34632,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": [
        "すりぃ"
      ],
      "composition": [
        "すりぃ"
      ],
      "arrangement": [
        "すりぃ"
      ],
      "isAvailableMV": false,
      "release": [
        "Scream"
      ],
      "releaseAt": "2022/01/04",
      "order": 1,
      "type": "original",
      "descriptionHtml": {
        "ja": "Provided to YouTube by cover corp.\u003cbr\u003e\u003cbr\u003eAKUMA · 常闇トワ · すりぃ · すりぃ · すりぃ\u003cbr\u003e\u003cbr\u003eAKUMA\u003cbr\u003e\u003cbr\u003eReleased on: 2022-01-18\u003cbr\u003e\u003cbr\u003eAuto-generated by YouTube.",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/F1_OQXNF8b8/maxresdefault.jpg",
      "publishedAt": "2022-01-17T10:04:14Z"
    },
    {
      "youtubeId": "jFcbWQufTIw",
      "originalName": {
        "ja": "ミッドナイト・ランナウェイ",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "ミッドナイト・ランナウェイ",
        "en": "",
        "kr": ""
      },
      "artist": "常闇トワ",
      "viewCount": 91983,
      "likeCount": 1372,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": [
        "R Sound Design"
      ],
      "composition": [
        "R Sound Design"
      ],
      "arrangement": [
        "R Sound Design"
      ],
      "isAvailableMV": false,
      "release": [
        "Scream"
      ],
      "releaseAt": "2022/01/04",
      "order": 2,
      "type": "original",
      "descriptionHtml": {
        "ja": "Provided to YouTube by cover corp.\u003cbr\u003e\u003cbr\u003eミッドナイト・ランナウェイ · Tokoyami Towa · R Sound Design · R Sound Design · R Sound Design\u003cbr\u003e\u003cbr\u003eMidnight runaway\u003cbr\u003e\u003cbr\u003eReleased on: 2022-06-18\u003cbr\u003e\u003cbr\u003eAuto-generated by YouTube.",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/jFcbWQufTIw/maxresdefault.jpg",
      "publishedAt": "2022-06-17T10:05:35Z"
    },
    {
      "youtubeId": "Zc05le75CfI",
      "originalName": {
        "ja": "【オリジナル曲】　FACT/常闇トワ　【フルMV】",
        "en": "",
        "kr": "[오리지널 곡] FACT/토코야미 토와 [풀 MV]"
      },
      "displayName": {
        "ja": "FACT",
        "en": "",
        "kr": ""
      },
      "artist": "常闇トワ",
      "viewCount": 13667282,
      "likeCount": 167617,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": [
        "niki"
      ],
      "composition": [
        "niki"
      ],
      "arrangement": [
        "niki"
      ],
      "isAvailableMV": true,
      "release": [
        "Scream"
      ],
      "releaseAt": "2022/01/04",
      "order": 5,
      "type": "original",
      "descriptionHtml": {
        "ja": "くだらないルールじゃ奪えない\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e配信中\u003cbr\u003e\u003ca href=\"https://cover.lnk.to/FACT\" target=\"_blank\"\u003ehttps://cover.lnk.to/FACT\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e常闇トワ（@tokoyamitowa）\u003cbr\u003e\u003ca href=\"https://twitter.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://twitter.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e■作曲・編曲・作詞・mix・マスタリング\u003cbr\u003eniki様（@niki_reverse）\u003cbr\u003e\u003ca href=\"https://twitter.com/niki_reverse\" target=\"_blank\"\u003ehttps://twitter.com/niki_reverse\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e■Illust\u003cbr\u003e蒼うさぎ様（@AoUSA0328）\u003cbr\u003e\u003ca href=\"https://twitter.com/AoUSA0328\" target=\"_blank\"\u003ehttps://twitter.com/AoUSA0328\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e■映像・コンポジット・3DCG\u003cbr\u003eRoly様（@yosinO_mo）\u003cbr\u003e\u003ca href=\"https://twitter.com/yosinO_mo\" target=\"_blank\"\u003ehttps://twitter.com/yosinO_mo\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e■ボーカルディレクション\u003cbr\u003eNeko Hacker (OFUTONE)様\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e■ボーカルレコーディング\u003cbr\u003eNNZN(OFUTONE)様\u003cbr\u003e\u003cbr\u003e字幕制作：fts, Lamine, T-chan\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e◆ホロライブプロダクション\u003cbr\u003e👾公式サイト👾\u003cbr\u003e\u003ca href=\"https://www.hololive.tv/\" target=\"_blank\"\u003ehttps://www.hololive.tv/\u003c/a\u003e\u003cbr\u003e👾公式Twitter👾\u003cbr\u003e\u003ca href=\"https://twitter.com/hololivetv\" target=\"_blank\"\u003ehttps://twitter.com/hololivetv\u003c/a\u003e\u003cbr\u003e👾公式チャンネル👾\u003cbr\u003e\u003ca href=\"https://www.youtube.com/channel/UCJFZiqLMntJufDCHc6bQixg\" target=\"_blank\"\u003ehttps://www.youtube.com/channel/UCJFZiqLMntJufDCHc6bQixg\u003c/a\u003e",
        "en": "",
        "kr": "하찮은 규칙 따위론 빼앗지 못해\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e공개 중\u003cbr\u003e\u003ca href=\"https://cover.lnk.to/FACT\" target=\"_blank\"\u003ehttps://cover.lnk.to/FACT\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■보컬\u003cbr\u003e常闇トワ（@tokoyamitowa）\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e/ tokoyamitowa\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e■작곡, 작사, 편곡, 믹싱, 미스터링\u003cbr\u003eniki様（@niki_reverse）\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e/ niki_reverse\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e■일러스트\u003cbr\u003e蒼うさぎ様（@AoUSA0328）\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e/ aousa0328\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e■영상, 컴포지션, 3DCG\u003cbr\u003eRoly様（@yosinO_mo）\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e/ yosino_mo\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e■보컬 디렉션\u003cbr\u003eNeko Hacker (OFUTONE)様\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e■보컬 레코딩\u003cbr\u003eNNZN(OFUTONE)様\u003cbr\u003e\u003cbr\u003e자막 제작: Lamine, Hiro"
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/Zc05le75CfI/maxresdefault.jpg",
      "publishedAt": "2022-01-03T12:00:13Z"
    },
    {
      "youtubeId": "D6AmCNdwT7E",
      "originalName": {
        "ja": "born to be real",
        "en": "born to be real",
        "kr": ""
      },
      "displayName": {
        "ja": "born to be real",
        "en": "",
        "kr": ""
      },
      "artist": "常闇トワ",
      "viewCount": 1605584,
      "likeCount": 12731,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": [
        "ANCHOR"
      ],
      "composition": [
        "ANCHOR"
      ],
      "arrangement": [
        "ANCHOR"
      ],
      "isAvailableMV": false,
      "release": [
        "Scream"
      ],
      "releaseAt": "2022/01/04",
      "order": 4,
      "type": "original",
      "descriptionHtml": {
        "ja": "Provided to YouTube by cover corp.\u003cbr\u003e\u003cbr\u003eborn to be real · 常闇トワ · ANCHOR · ANCHOR · ANCHOR\u003cbr\u003e\u003cbr\u003eborn to be real\u003cbr\u003e\u003cbr\u003eReleased on: 2022-03-12\u003cbr\u003e\u003cbr\u003eAuto-generated by YouTube.",
        "en": "Provided to YouTube by cover corp.\u003cbr\u003e\u003cbr\u003eborn to be real · 常闇トワ · ANCHOR · ANCHOR · ANCHOR\u003cbr\u003e\u003cbr\u003eborn to be real\u003cbr\u003e\u003cbr\u003eReleased on: 2022-03-12\u003cbr\u003e\u003cbr\u003eAuto-generated by YouTube.",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/D6AmCNdwT7E/maxresdefault.jpg",
      "publishedAt": "2022-03-11T10:04:19Z"
    },
    {
      "youtubeId": "uNQIltgLlgo",
      "originalName": {
        "ja": "マイロア",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "マイロア",
        "en": "",
        "kr": ""
      },
      "artist": "常闇トワ",
      "viewCount": 2350638,
      "likeCount": 25243,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": [
        "鬱P"
      ],
      "composition": [
        "鬱P"
      ],
      "arrangement": [
        "鬱P"
      ],
      "isAvailableMV": false,
      "release": [
        "Scream"
      ],
      "releaseAt": "2022/01/04",
      "order": 6,
      "type": "original",
      "descriptionHtml": {
        "ja": "Provided to YouTube by cover corp.\u003cbr\u003e\u003cbr\u003eマイロア · 常闇トワ · 鬱P · 鬱P · 鬱P\u003cbr\u003e\u003cbr\u003eマイロア\u003cbr\u003e\u003cbr\u003eReleased on: 2022-01-11\u003cbr\u003e\u003cbr\u003eAuto-generated by YouTube.",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/uNQIltgLlgo/maxresdefault.jpg",
      "publishedAt": "2022-01-10T10:09:17Z"
    },
    {
      "youtubeId": "0firv69LkgI",
      "originalName": {
        "ja": "灰色と青/常闇トワ×星街すいせい(cover)",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "灰色と青",
        "en": "",
        "kr": ""
      },
      "artist": "米津玄師",
      "viewCount": 18034904,
      "likeCount": 205759,
      "singers": [
        "tokoyamitowa",
        "hoshimachisuisei"
      ],
      "lyrics": null,
      "composition": null,
      "arrangement": null,
      "isAvailableMV": true,
      "release": null,
      "releaseAt": "",
      "order": 0,
      "type": "cover",
      "descriptionHtml": {
        "ja": "何があろうと僕らはきっと上手くいく\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e■素敵な本家様\u003cbr\u003e『灰色と青（ ＋菅田将暉 ）』/米津玄師様\u003cbr\u003e\u003ca href=\"https://www.youtube.com/watch?v=gJX2iy6nhHc\" target=\"_blank\"\u003ehttps://www.youtube.com/watch?v=gJX2iy6nhHc\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■MIX\u0026inst\u003cbr\u003e淳様（@jun40am）\u003cbr\u003e\u003ca href=\"https://twitter.com/jun40am\" target=\"_blank\"\u003ehttps://twitter.com/jun40am\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Illust\u003cbr\u003e月野様（@tsuki_nonono）\u003cbr\u003e\u003ca href=\"https://twitter.com/tsuki_nonono\" target=\"_blank\"\u003ehttps://twitter.com/tsuki_nonono\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Movie\u003cbr\u003eぴろぱる様（@PIROPARU）\u003cbr\u003e\u003ca href=\"https://twitter.com/PIROPARU\" target=\"_blank\"\u003ehttps://twitter.com/PIROPARU\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e常闇トワ（@tokoyamitowa）\u003cbr\u003e\u003ca href=\"https://twitter.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://twitter.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e星街すいせい(@suisei_hosimati)\u003cbr\u003e\u003ca href=\"https://twitter.com/suisei_hosimati\" target=\"_blank\"\u003ehttps://twitter.com/suisei_hosimati\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*\u003cbr\u003e\u003cbr\u003e◆ホロライブプロダクション\u003cbr\u003e👾公式サイト👾\u003cbr\u003e\u003ca href=\"https://www.hololive.tv/\" target=\"_blank\"\u003ehttps://www.hololive.tv/\u003c/a\u003e\u003cbr\u003e👾公式Twitter👾\u003cbr\u003e\u003ca href=\"https://twitter.com/hololivetv\" target=\"_blank\"\u003ehttps://twitter.com/hololivetv\u003c/a\u003e\u003cbr\u003e👾公式チャンネル👾\u003cbr\u003e\u003ca href=\"https://www.youtube.com/channel/UCJFZ...\" target=\"_blank\"\u003ehttps://www.youtube.com/channel/UCJFZ...\u003c/a\u003e",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/0firv69LkgI/maxresdefault.jpg",
      "publishedAt": "2021-12-23T10:00:12Z"
    },
    {
      "youtubeId": "6uN99OAINAY",
      "originalName": {
        "ja": "EYE/常闇トワ(cover)",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "EYE",
        "en": "",
        "kr": ""
      },
      "artist": "Kanaria",
      "viewCount": 3790939,
      "likeCount": 75458,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": null,
      "composition": null,
      "arrangement": null,
      "isAvailableMV": true,
      "release": null,
      "releaseAt": "",
      "order": 0,
      "type": "cover",
      "descriptionHtml": {
        "ja": "耳障り\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e■素敵な本家様\u003cbr\u003e『EYE』/Kanaria様\u003cbr\u003e\u003ca href=\"https://www.youtube.com/watch?v=sSHkXxADtaE\" target=\"_blank\"\u003ehttps://www.youtube.com/watch?v=sSHkXxADtaE\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■MIX\u003cbr\u003e淳様（@jun40am）\u003cbr\u003e\u003ca href=\"https://twitter.com/jun40am\" target=\"_blank\"\u003ehttps://twitter.com/jun40am\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Illust\u003cbr\u003emins様（@minsgraph）\u003cbr\u003e\u003ca href=\"https://twitter.com/minsgraph\" target=\"_blank\"\u003ehttps://twitter.com/minsgraph\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Movie\u003cbr\u003eSaiA/再映様（@Shomijokun）\u003cbr\u003e\u003ca href=\"https://twitter.com/Shomijokun\" target=\"_blank\"\u003ehttps://twitter.com/Shomijokun\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e常闇トワ（@tokoyamitowa）\u003cbr\u003e\u003ca href=\"https://twitter.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://twitter.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*\u003cbr\u003e\u003cbr\u003e◆ホロライブプロダクション\u003cbr\u003e👾公式サイト👾\u003cbr\u003e\u003ca href=\"https://www.hololive.tv/\" target=\"_blank\"\u003ehttps://www.hololive.tv/\u003c/a\u003e\u003cbr\u003e👾公式Twitter👾\u003cbr\u003e\u003ca href=\"https://twitter.com/hololivetv\" target=\"_blank\"\u003ehttps://twitter.com/hololivetv\u003c/a\u003e\u003cbr\u003e👾公式チャンネル👾\u003cbr\u003e\u003ca href=\"https://www.youtube.com/channel/UCJFZ...\" target=\"_blank\"\u003ehttps://www.youtube.com/channel/UCJFZ...\u003c/a\u003e",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/6uN99OAINAY/maxresdefault.jpg",
      "publishedAt": "2021-11-24T11:00:11Z"
    },
    {
      "youtubeId": "23nEnPOXLEk",
      "originalName": {
        "ja": "【MV】マドロミ / 天音かなた・常闇トワ【ディープインサニティ アサイラム ゲーム主題歌】",
        "en": "[MV] Amane Kanata, Tokoyami Towa - madoromi [Deep Insanity ASYLUM theme song]",
        "kr": ""
      },
      "displayName": {
        "ja": "マドロミ",
        "en": "",
        "kr": ""
      },
      "artist": "天音かなた・常闇トワ",
      "viewCount": 2323603,
      "likeCount": 71220,
      "singers": [
        "amanekanata",
        "tokoyamitowa"
      ],
      "lyrics": [
        "砂守岳央（未来古代楽団）"
      ],
      "composition": [
        "砂守岳央（未来古代楽団）"
      ],
      "arrangement": [
        "砂守岳央（未来古代楽団）"
      ],
      "isAvailableMV": true,
      "release": [
        "マドロミ"
      ],
      "releaseAt": "2021/10/14",
      "order": 1,
      "type": "original",
      "descriptionHtml": {
        "ja": "天音かなた、常闇トワの2人がゲーム主題歌を歌う『ディープインサニティ アサイラム』\u003cbr\u003e2021年10月14日 正式サービス開始予定！\u003cbr\u003e\u003cbr\u003eスクウェア・エニックスの新作RPG『ディープインサニティ アサイラム』。\u003cbr\u003e求めるのはシンソウか、それともキョウキか。\u003cbr\u003e記憶を失った青年が巨大地下世界でくり広げる最\"狂\"にディープなミステリーアドベンチャーが、遂にはじまる！\u003cbr\u003e\u003cbr\u003eタイトル名：ディープインサニティ アサイラム\u003cbr\u003e配信日：2021年10月14日(木)正式サービス開始\u003cbr\u003eプラットフォーム：iOS/Android/PC(STEAM)\u003cbr\u003e\u003cbr\u003e▼ダウンロードはこちら▼\u003cbr\u003eiOS / Android → \u003ca href=\"https://sqex.to/dcUJW\" target=\"_blank\"\u003ehttps://sqex.to/dcUJW\u003c/a\u003e\u003cbr\u003ePC(Steam) → \u003ca href=\"https://store.steampowered.com/app/1629890/\" target=\"_blank\"\u003ehttps://store.steampowered.com/app/1629890/\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e▼公式サイト：\u003ca href=\"https://www.jp.square-enix.com/deepinsanity/game/\" target=\"_blank\"\u003ehttps://www.jp.square-enix.com/deepinsanity/game/\u003c/a\u003e\u003cbr\u003e▼公式Twitter：\u003ca href=\"https://twitter.com/deepinsanity_pj\" target=\"_blank\"\u003ehttps://twitter.com/deepinsanity_pj\u003c/a\u003e \u003cbr\u003e\u003cbr\u003e▶出演タレント▷\u003cbr\u003e気になるタレントは是非チャンネル登録とフォローをお願いします！\u003cbr\u003e【天音かなた】\u003ca href=\"https://youtu.be/Tc3jcBAncUQ\" target=\"_blank\"\u003ehttps://youtu.be/Tc3jcBAncUQ\u003c/a\u003e\u003cbr\u003e【常闇トワ】\u003ca href=\"https://youtu.be/btYOWro5CAA\" target=\"_blank\"\u003ehttps://youtu.be/btYOWro5CAA\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e歌唱：天音かなた・常闇トワ\u003cbr\u003e作詞・作曲：砂守岳央（未来古代楽団） \u003cbr\u003e鍵盤・弦編曲：松岡美弥子（未来古代楽団） \u003cbr\u003eドラム：HAZE \u003cbr\u003eヴァイオリン：吉田篤貴（EMO strings） \u003cbr\u003eヴァイオリン：須原杏 \u003cbr\u003eヴィオラ：河村泉 \u003cbr\u003eチェロ：内田麒麟 \u003cbr\u003eベース：加賀原匠 \u003cbr\u003eレコーディングスタジオ：studio MSR\u003cbr\u003e\u003cbr\u003eRecording \u0026 Mixing Engineer：NNZN(OFUTONE)\u003cbr\u003eVocal Direction：かっさん (Neko Hacker)\u003cbr\u003eMovie：こんぶ\u003cbr\u003eIllust：よもさか・おるだん\u003cbr\u003e\u003cbr\u003e字幕制作：fts, T-chan",
        "en": "\"Deep Insanity ASYLUM\" theme song, with vocals by Amane Kanata and Tokoyami Towa.\u003cbr\u003eService is scheduled to officially commence on October 14, 2021!\u003cbr\u003e\u003cbr\u003eSquare Enix's brand-new RPG \"Deep Insanity ASYLUM\".\u003cbr\u003eIs it truth or madness that you seek?\u003cbr\u003eFollow a young man with amnesia's journey and explore the depths of insanity found deep underground in this mystery!\u003cbr\u003e\u003cbr\u003eTitle: Deep Insanity ASYLUM\u003cbr\u003eLaunch Date: Thursday, October 14, 2021 (service officially commences)\u003cbr\u003ePlatform: iOS/Android/PC(STEAM)\u003cbr\u003e\u003cbr\u003e▼Download Links▼\u003cbr\u003eiOS / Android → \u003ca href=\"https://sqex.to/dcUJW\" target=\"_blank\"\u003ehttps://sqex.to/dcUJW\u003c/a\u003e\u003cbr\u003ePC(Steam) → \u003ca href=\"https://store.steampowered.com/app/1629890/\" target=\"_blank\"\u003ehttps://store.steampowered.com/app/1629890/\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e▼Official HP: \u003ca href=\"https://www.jp.square-enix.com/deepinsanity/game/\" target=\"_blank\"\u003ehttps://www.jp.square-enix.com/deepinsanity/game/\u003c/a\u003e\u003cbr\u003e▼Official Twitter：\u003ca href=\"https://twitter.com/deepinsanity_pj\" target=\"_blank\"\u003ehttps://twitter.com/deepinsanity_pj\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e▶︎Appearances▷\u003cbr\u003eBe sure to follow and subscribe to your favorite!\u003cbr\u003e[Amane Kanata] \u003ca href=\"https://youtu.be/Tc3jcBAncUQ\" target=\"_blank\"\u003ehttps://youtu.be/Tc3jcBAncUQ\u003c/a\u003e\u003cbr\u003e[Tokoyami Towa] \u003ca href=\"https://youtu.be/btYOWro5CAA\" target=\"_blank\"\u003ehttps://youtu.be/btYOWro5CAA\u003c/a\u003e\u003cbr\u003e\u003cbr\u003eVocals: Amane Kanata, Tokoyami Towa\u003cbr\u003eLyrics, Composition: Taketeru Sunamori (Mirai Kodai Orchestra)\u003cbr\u003eKeyboard, Strings Arrangement: Miyako Matsuoka (Mirai Kodai Orchestra)\u003cbr\u003eDrums: HAZE\u003cbr\u003eViolin: Atsuki Yoshida (EMO strings)\u003cbr\u003eViolin: Anzu Suhara\u003cbr\u003eViola: Izumi Kawamura\u003cbr\u003eCello: Kirin Uchida\u003cbr\u003eBass: Takumi Kagahara\u003cbr\u003eRecording Studio: studio MSR\u003cbr\u003e\u003cbr\u003eRecording \u0026 Mixing Engineer: NNZN (OFUTONE)\u003cbr\u003eVocal Direction: Kassan (Neko Hacker)\u003cbr\u003eMovie: Konbu\u003cbr\u003eIllust: Yomosaka, Ordan\u003cbr\u003e\u003cbr\u003eTranslation: fts\u003cbr\u003eSubtitling: T-chan",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/23nEnPOXLEk/maxresdefault.jpg",
      "publishedAt": "2021-10-13T11:00:13Z"
    },
    {
      "youtubeId": "wVfp1NPf928",
      "originalName": {
        "ja": "Hearts/常闇トワ(cover)",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "Hearts",
        "en": "",
        "kr": ""
      },
      "artist": "niki",
      "viewCount": 2165920,
      "likeCount": 58061,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": null,
      "composition": null,
      "arrangement": null,
      "isAvailableMV": true,
      "release": null,
      "releaseAt": "",
      "order": 0,
      "type": "cover",
      "descriptionHtml": {
        "ja": "心砕かれぬように\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e■素敵な本家様\u003cbr\u003e『Hearts』/niki様\u003cbr\u003e・\u003ca href=\"https://www.youtube.com/watch?v=Dj8xglbOKhc\" target=\"_blank\"\u003ehttps://www.youtube.com/watch?v=Dj8xglbOKhc\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■MIX\u003cbr\u003e淳様（＠jun40am）\u003cbr\u003e\u003ca href=\"https://twitter.com/jun40am\" target=\"_blank\"\u003ehttps://twitter.com/jun40am\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Illust\u003cbr\u003eじゃが山たらヲ様(@jagatara00)\u003cbr\u003e\u003ca href=\"https://twitter.com/jagatara00\" target=\"_blank\"\u003ehttps://twitter.com/jagatara00\u003c/a\u003e\u003cbr\u003e\u003cbr\u003eかかげ様（@kakage0904）\u003cbr\u003e\u003ca href=\"https://twitter.com/kakage0904\" target=\"_blank\"\u003ehttps://twitter.com/kakage0904\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Movie\u003cbr\u003eRoly様（@yosinO_mo）\u003cbr\u003e\u003ca href=\"https://twitter.com/yosinO_mo\" target=\"_blank\"\u003ehttps://twitter.com/yosinO_mo\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e常闇トワ（@tokoyamitowa）\u003cbr\u003e\u003ca href=\"https://twitter.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://twitter.com/tokoyamitowa\u003c/a\u003e",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/wVfp1NPf928/maxresdefault.jpg",
      "publishedAt": "2021-09-28T12:00:13Z"
    },
    {
      "youtubeId": "S-VngJTUdmE",
      "originalName": {
        "ja": "うっせぇわ／天音かなた＆常闇トワ(Cover)",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "うっせぇわ",
        "en": "",
        "kr": ""
      },
      "artist": "Ado",
      "viewCount": 3162668,
      "likeCount": 108709,
      "singers": [
        "amanekanata",
        "tokoyamitowa"
      ],
      "lyrics": null,
      "composition": null,
      "arrangement": null,
      "isAvailableMV": true,
      "release": null,
      "releaseAt": "",
      "order": 0,
      "type": "cover",
      "descriptionHtml": {
        "ja": "原曲：\u003cbr\u003e\u003ca href=\"https://www.youtube.com/watch?v=Qp3b-RXtz4w\" target=\"_blank\"\u003ehttps://www.youtube.com/watch?v=Qp3b-RXtz4w\u003c/a\u003e\u003cbr\u003e\u003cbr\u003emusic: syudou\u003cbr\u003eoriginal: Ado\u003cbr\u003e\u003cbr\u003eMIX: ハム\u003cbr\u003e\u003ca href=\"https://twitter.com/hamu_lr\" target=\"_blank\"\u003ehttps://twitter.com/hamu_lr\u003c/a\u003e\u003cbr\u003eillust: 朱昆布\u003cbr\u003e\u003ca href=\"https://twitter.com/konbusennin2\" target=\"_blank\"\u003ehttps://twitter.com/konbusennin2\u003c/a\u003e\u003cbr\u003emovie: ぴろぱる\u003cbr\u003e\u003ca href=\"https://twitter.com/PIROPARU\" target=\"_blank\"\u003ehttps://twitter.com/PIROPARU\u003c/a\u003e\u003cbr\u003e\u003cbr\u003evocal: 常闇トワ\u003cbr\u003e\u003ca href=\"https://www.youtube.com/channel/UC1uv2Oq6kNxgATlCiez59hw\" target=\"_blank\"\u003ehttps://www.youtube.com/channel/UC1uv2Oq6kNxgATlCiez59hw\u003c/a\u003e\u003cbr\u003e\u003ca href=\"https://twitter.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://twitter.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003evocal: 天音かなた\u003cbr\u003e\u003ca href=\"https://www.youtube.com/channel/UCZlDXzGoo7d44bwdNObFacg\" target=\"_blank\"\u003ehttps://www.youtube.com/channel/UCZlDXzGoo7d44bwdNObFacg\u003c/a\u003e\u003cbr\u003e\u003ca href=\"https://twitter.com/amanekanatach\" target=\"_blank\"\u003ehttps://twitter.com/amanekanatach\u003c/a\u003e",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/S-VngJTUdmE/maxresdefault.jpg",
      "publishedAt": "2021-04-15T11:00:16Z"
    },
    {
      "youtubeId": "Ud73fm4Uoq0",
      "originalName": {
        "ja": "【オリジナル曲】　Palette/常闇トワ　【フルMV】",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "Palette",
        "en": "",
        "kr": ""
      },
      "artist": "常闇トワ",
      "viewCount": 11910579,
      "likeCount": 219977,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": [
        "常闇トワ"
      ],
      "composition": [
        "niki"
      ],
      "arrangement": [
        "niki"
      ],
      "isAvailableMV": true,
      "release": [
        "Scream",
        "Palette"
      ],
      "releaseAt": "2021/02/24",
      "order": 3,
      "type": "original",
      "descriptionHtml": {
        "ja": "強くなくてもいい\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e常闇トワ　オリジナル曲「Palette」配信中\u003cbr\u003e▼詳細▼\u003cbr\u003e\u003ca href=\"https://towa.streamlink.to/palette\" target=\"_blank\"\u003ehttps://towa.streamlink.to/palette\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e■Vocal・作詞\u003cbr\u003e常闇トワ（@tokoyamitowa）\u003cbr\u003e\u003ca href=\"https://twitter.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://twitter.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e■作曲・編曲・mix・マスタリング\u003cbr\u003eniki様（@niki_reverse）\u003cbr\u003e\u003ca href=\"https://twitter.com/niki_reverse\" target=\"_blank\"\u003ehttps://twitter.com/niki_reverse\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e■Illust・絵コンテ・アニメーション\u003cbr\u003eかかげ様（@kakage0904）\u003cbr\u003e\u003ca href=\"https://twitter.com/kakage0904\" target=\"_blank\"\u003ehttps://twitter.com/kakage0904\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e■映像・コンポジット・3DCG\u003cbr\u003eRoly様（@yosinO_mo）\u003cbr\u003e\u003ca href=\"https://twitter.com/yosinO_mo\" target=\"_blank\"\u003ehttps://twitter.com/yosinO_mo\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e■ロゴデザイン\u003cbr\u003eをとは(OFUTONE)様\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e■ボーカルディレクション\u003cbr\u003eNeko Hacker (OFUTONE)様\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e■ボーカルレコーディング\u003cbr\u003eNNZN(OFUTONE)様\u003cbr\u003e\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e◆ホロライブプロダクション\u003cbr\u003e👾公式サイト👾\u003cbr\u003e\u003ca href=\"https://www.hololive.tv/\" target=\"_blank\"\u003ehttps://www.hololive.tv/\u003c/a\u003e\u003cbr\u003e👾公式Twitter👾\u003cbr\u003e\u003ca href=\"https://twitter.com/hololivetv\" target=\"_blank\"\u003ehttps://twitter.com/hololivetv\u003c/a\u003e\u003cbr\u003e👾公式チャンネル👾\u003cbr\u003e\u003ca href=\"https://www.youtube.com/channel/UCJFZ...\" target=\"_blank\"\u003ehttps://www.youtube.com/channel/UCJFZ...\u003c/a\u003e",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/Ud73fm4Uoq0/maxresdefault.jpg",
      "publishedAt": "2021-03-18T11:00:16Z"
    },
    {
      "youtubeId": "9RBY7u5qas8",
      "originalName": {
        "ja": "KING/常闇トワ(cover)",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "KING",
        "en": "",
        "kr": ""
      },
      "artist": "Kanaria",
      "viewCount": 5245977,
      "likeCount": 126717,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": null,
      "composition": null,
      "arrangement": null,
      "isAvailableMV": true,
      "release": null,
      "releaseAt": "",
      "order": 0,
      "type": "cover",
      "descriptionHtml": {
        "ja": "■素敵な本家様\u003cbr\u003e『KING』/Kanaria様\u003cbr\u003e・\u003ca href=\"https://www.youtube.com/watch?v=cm-l2h6GB8Q\" target=\"_blank\"\u003ehttps://www.youtube.com/watch?v=cm-l2h6GB8Q\u003c/a\u003e\u003cbr\u003e・\u003ca href=\"https://www.nicovideo.jp/watch/sm37287661\" target=\"_blank\"\u003ehttps://www.nicovideo.jp/watch/sm37287661\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■MIX\u003cbr\u003e淳様（@jun40am）\u003cbr\u003e\u003ca href=\"https://twitter.com/jun40am\" target=\"_blank\"\u003ehttps://twitter.com/jun40am\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Illust\u003cbr\u003e丈ゆきみ様（@take_yukimi）\u003cbr\u003e\u003ca href=\"https://twitter.com/take_yukimi\" target=\"_blank\"\u003ehttps://twitter.com/take_yukimi\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Movie\u003cbr\u003eぴろぱる様（@PIROPARU）\u003cbr\u003e\u003ca href=\"https://twitter.com/PIROPARU\" target=\"_blank\"\u003ehttps://twitter.com/PIROPARU\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e常闇トワ（@tokoyamitowa）\u003cbr\u003e\u003ca href=\"https://twitter.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://twitter.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*\u003cbr\u003e\u003cbr\u003e◆ホロライブプロダクション\u003cbr\u003e👾公式サイト👾\u003cbr\u003e\u003ca href=\"https://www.hololive.tv/\" target=\"_blank\"\u003ehttps://www.hololive.tv/\u003c/a\u003e\u003cbr\u003e👾公式Twitter👾\u003cbr\u003e\u003ca href=\"https://twitter.com/hololivetv\" target=\"_blank\"\u003ehttps://twitter.com/hololivetv\u003c/a\u003e\u003cbr\u003e👾公式チャンネル👾\u003cbr\u003e\u003ca href=\"https://www.youtube.com/channel/UCJFZ...\" target=\"_blank\"\u003ehttps://www.youtube.com/channel/UCJFZ...\u003c/a\u003e",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/9RBY7u5qas8/maxresdefault.jpg",
      "publishedAt": "2021-02-03T11:30:11Z"
    },
    {
      "youtubeId": "64kI2BWRd2g",
      "originalName": {
        "ja": "ボッカデラベリタ/常闇トワ(cover)",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "ボッカデラベリタ",
        "en": "",
        "kr": ""
      },
      "artist": "柊キライ",
      "viewCount": 7381851,
      "likeCount": 112548,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": null,
      "composition": null,
      "arrangement": null,
      "isAvailableMV": true,
      "release": null,
      "releaseAt": "",
      "order": 0,
      "type": "cover",
      "descriptionHtml": {
        "ja": "いい子じゃいられない\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e■素敵な本家様\u003cbr\u003e『ボッカデラベリタ』/柊キライ様\u003cbr\u003e・\u003ca href=\"https://www.youtube.com/watch?v=wp9Z2wZ-2bs\" target=\"_blank\"\u003ehttps://www.youtube.com/watch?v=wp9Z2wZ-2bs\u003c/a\u003e\u003cbr\u003e・\u003ca href=\"https://www.nicovideo.jp/watch/sm36731216\" target=\"_blank\"\u003ehttps://www.nicovideo.jp/watch/sm36731216\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■MIX\u003cbr\u003emidrino様（@mid_rino）\u003cbr\u003e\u003ca href=\"https://twitter.com/mid_rino\" target=\"_blank\"\u003ehttps://twitter.com/mid_rino\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Illust\u003cbr\u003eせらみっく様（@ceramic06）\u003cbr\u003e\u003ca href=\"https://twitter.com/ceramic06\" target=\"_blank\"\u003ehttps://twitter.com/ceramic06\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Movie\u003cbr\u003eらら様（@2525_lala）\u003cbr\u003e\u003ca href=\"https://twitter.com/2525_lala\" target=\"_blank\"\u003ehttps://twitter.com/2525_lala\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e常闇トワ（@tokoyamitowa）\u003cbr\u003e\u003ca href=\"https://twitter.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://twitter.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*\u003cbr\u003e\u003cbr\u003e◆ホロライブプロダクション\u003cbr\u003e👾公式サイト👾\u003cbr\u003e\u003ca href=\"https://www.hololive.tv/\" target=\"_blank\"\u003ehttps://www.hololive.tv/\u003c/a\u003e\u003cbr\u003e👾公式Twitter👾\u003cbr\u003e\u003ca href=\"https://twitter.com/hololivetv\" target=\"_blank\"\u003ehttps://twitter.com/hololivetv\u003c/a\u003e\u003cbr\u003e👾公式チャンネル👾\u003cbr\u003e\u003ca href=\"https://www.youtube.com/channel/UCJFZ...\" target=\"_blank\"\u003ehttps://www.youtube.com/channel/UCJFZ...\u003c/a\u003e",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/64kI2BWRd2g/maxresdefault.jpg",
      "publishedAt": "2020-12-23T11:30:11Z"
    },
    {
      "youtubeId": "2o_H09MdT94",
      "originalName": {
        "ja": "百鬼祭 / 常闇トワ(cover)",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "百鬼祭",
        "en": "",
        "kr": ""
      },
      "artist": "Kanaria",
      "viewCount": 4651567,
      "likeCount": 89679,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": null,
      "composition": null,
      "arrangement": null,
      "isAvailableMV": true,
      "release": null,
      "releaseAt": "",
      "order": 0,
      "type": "cover",
      "descriptionHtml": {
        "ja": "だから私はただ　ずっと鳴いて\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e■素敵な本家様\u003cbr\u003e『百鬼祭』/Kanaria様\u003cbr\u003e・\u003ca href=\"https://www.youtube.com/watch?v=Fk4FLklyPWk\" target=\"_blank\"\u003ehttps://www.youtube.com/watch?v=Fk4FLklyPWk\u003c/a\u003e\u003cbr\u003e・\u003ca href=\"https://www.nicovideo.jp/watch/sm36838810\" target=\"_blank\"\u003ehttps://www.nicovideo.jp/watch/sm36838810\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■MIX\u003cbr\u003emidrino様（@mid_rino）\u003cbr\u003e\u003ca href=\"https://twitter.com/mid_rino\" target=\"_blank\"\u003ehttps://twitter.com/mid_rino\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Illust\u003cbr\u003e夜よいち様（@yoruyoru108）\u003cbr\u003e\u003ca href=\"https://twitter.com/yoruyoru108\" target=\"_blank\"\u003ehttps://twitter.com/yoruyoru108\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Movie\u003cbr\u003eぴろぱる様（@PIROPARU）\u003cbr\u003e\u003ca href=\"https://twitter.com/PIROPARU\" target=\"_blank\"\u003ehttps://twitter.com/PIROPARU\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e常闇トワ（@tokoyamitowa）\u003cbr\u003e\u003ca href=\"https://twitter.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://twitter.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*\u003cbr\u003e\u003cbr\u003e◆ホロライブプロダクション\u003cbr\u003e👾公式サイト👾\u003cbr\u003e\u003ca href=\"https://www.hololive.tv/\" target=\"_blank\"\u003ehttps://www.hololive.tv/\u003c/a\u003e\u003cbr\u003e👾公式Twitter👾\u003cbr\u003e\u003ca href=\"https://twitter.com/hololivetv\" target=\"_blank\"\u003ehttps://twitter.com/hololivetv\u003c/a\u003e\u003cbr\u003e👾公式チャンネル👾\u003cbr\u003e\u003ca href=\"https://www.youtube.com/channel/UCJFZ...\" target=\"_blank\"\u003ehttps://www.youtube.com/channel/UCJFZ...\u003c/a\u003e",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/2o_H09MdT94/maxresdefault.jpg",
      "publishedAt": "2020-11-07T09:00:13Z"
    },
    {
      "youtubeId": "3UV8OZj2olg",
      "originalName": {
        "ja": "-ERROR/常闇トワ(cover)",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "-ERROR",
        "en": "",
        "kr": ""
      },
      "artist": "niki",
      "viewCount": 19083839,
      "likeCount": 271892,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": null,
      "composition": null,
      "arrangement": null,
      "isAvailableMV": true,
      "release": null,
      "releaseAt": "",
      "order": 0,
      "type": "cover",
      "descriptionHtml": {
        "ja": "どのくらい異常？\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e■素敵な本家様\u003cbr\u003e『ERROR』/niki様\u003cbr\u003e・\u003ca href=\"https://www.youtube.com/watch?v=jvoW9lJdirk\" target=\"_blank\"\u003ehttps://www.youtube.com/watch?v=jvoW9lJdirk\u003c/a\u003e\u003cbr\u003e・\u003ca href=\"https://www.nicovideo.jp/watch/sm12099561\" target=\"_blank\"\u003ehttps://www.nicovideo.jp/watch/sm12099561\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■MIX\u003cbr\u003e淳様（＠jun40am）\u003cbr\u003e\u003ca href=\"https://twitter.com/jun40am\" target=\"_blank\"\u003ehttps://twitter.com/jun40am\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Illust\u003cbr\u003eかかげ様（@kakage0904）\u003cbr\u003e\u003ca href=\"https://twitter.com/kakage0904\" target=\"_blank\"\u003ehttps://twitter.com/kakage0904\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Movie\u003cbr\u003eRoly様（@yosinO_mo）\u003cbr\u003e\u003ca href=\"https://twitter.com/yosinO_mo\" target=\"_blank\"\u003ehttps://twitter.com/yosinO_mo\u003c/a\u003e\u003cbr\u003eとーわ様（@touwaoftn）\u003cbr\u003e\u003ca href=\"https://twitter.com/touwaoftn\" target=\"_blank\"\u003ehttps://twitter.com/touwaoftn\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e常闇トワ（@tokoyamitowa）\u003cbr\u003e\u003ca href=\"https://twitter.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://twitter.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*\u003cbr\u003e\u003cbr\u003e◆ホロライブプロダクション\u003cbr\u003e👾公式サイト👾\u003cbr\u003e\u003ca href=\"https://www.hololive.tv/\" target=\"_blank\"\u003ehttps://www.hololive.tv/\u003c/a\u003e\u003cbr\u003e👾公式Twitter👾\u003cbr\u003e\u003ca href=\"https://twitter.com/hololivetv\" target=\"_blank\"\u003ehttps://twitter.com/hololivetv\u003c/a\u003e\u003cbr\u003e👾公式チャンネル👾\u003cbr\u003e\u003ca href=\"https://www.youtube.com/channel/UCJFZ...\" target=\"_blank\"\u003ehttps://www.youtube.com/channel/UCJFZ...\u003c/a\u003e",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/3UV8OZj2olg/maxresdefault.jpg",
      "publishedAt": "2020-07-26T12:30:12Z"
    },
    {
      "youtubeId": "ZQ3gmQzpvBM",
      "originalName": {
        "ja": "黒い羊/常闇トワ(cover)",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "黒い羊",
        "en": "",
        "kr": ""
      },
      "artist": "欅坂46",
      "viewCount": 2344846,
      "likeCount": 51754,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": null,
      "composition": null,
      "arrangement": null,
      "isAvailableMV": true,
      "release": null,
      "releaseAt": "",
      "order": 0,
      "type": "cover",
      "descriptionHtml": {
        "ja": "同じ色に染まりたくないんだ\u003cbr\u003e\u003cbr\u003eｰｰｰｰｰｰｰｰｰｰ\u003cbr\u003e\u003cbr\u003e■素敵な本家様\u003cbr\u003e『黒い羊』/欅坂46様\u003cbr\u003e・\u003ca href=\"https://www.youtube.com/watch?v=MAkIYZiyJq4\" target=\"_blank\"\u003ehttps://www.youtube.com/watch?v=MAkIYZiyJq4\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■オケアレンジ\u003cbr\u003eだいご様\u003cbr\u003e・\u003ca href=\"https://www.youtube.com/watch?v=wPfGcvFCm5g\" target=\"_blank\"\u003ehttps://www.youtube.com/watch?v=wPfGcvFCm5g\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■MIX\u003cbr\u003e淳様（＠jun40am）\u003cbr\u003e\u003ca href=\"https://twitter.com/jun40am\" target=\"_blank\"\u003ehttps://twitter.com/jun40am\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Illust\u003cbr\u003e野乃ノ　之様（@nonono_noisy）\u003cbr\u003e\u003ca href=\"https://twitter.com/nonono_noisy\" target=\"_blank\"\u003ehttps://twitter.com/nonono_noisy\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Movie\u003cbr\u003eREO様（@reo_tryall）\u003cbr\u003e\u003ca href=\"https://twitter.com/reo_tryall\" target=\"_blank\"\u003ehttps://twitter.com/reo_tryall\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e常闇トワ（@tokoyamitowa）\u003cbr\u003e\u003ca href=\"https://twitter.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://twitter.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*\u003cbr\u003e\u003cbr\u003e◆ホロライブプロダクション\u003cbr\u003e👾公式サイト👾\u003cbr\u003e\u003ca href=\"https://www.hololive.tv/\" target=\"_blank\"\u003ehttps://www.hololive.tv/\u003c/a\u003e\u003cbr\u003e👾公式Twitter👾\u003cbr\u003e\u003ca href=\"https://twitter.com/hololivetv\" target=\"_blank\"\u003ehttps://twitter.com/hololivetv\u003c/a\u003e\u003cbr\u003e👾公式チャンネル👾\u003cbr\u003e\u003ca href=\"https://www.youtube.com/channel/UCJFZ...\" target=\"_blank\"\u003ehttps://www.youtube.com/channel/UCJFZ...\u003c/a\u003e",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/ZQ3gmQzpvBM/maxresdefault.jpg",
      "publishedAt": "2020-06-28T09:00:13Z"
    },
    {
      "youtubeId": "2D0B3wTjE20",
      "originalName": {
        "ja": "brilliant/常闇トワ(cover)",
        "en": "",
        "kr": ""
      },
      "displayName": {
        "ja": "brilliant",
        "en": "",
        "kr": ""
      },
      "artist": "niki",
      "viewCount": 3553486,
      "likeCount": 69901,
      "singers": [
        "tokoyamitowa"
      ],
      "lyrics": null,
      "composition": null,
      "arrangement": null,
      "isAvailableMV": true,
      "release": null,
      "releaseAt": "",
      "order": 0,
      "type": "cover",
      "descriptionHtml": {
        "ja": "はじめましての方ははじめまして👾\u003cbr\u003eホロライブ4期生の小悪魔、常闇トワ様です！✨\u003cbr\u003e\u003cbr\u003e『一人では生きては行けないから』\u003cbr\u003eトワ様はいつも君たちに支えてもらってる😊\u003cbr\u003eこれからもどんな時もお互い尊重して、助け合えたらいいな。\u003cbr\u003e\u003cbr\u003e○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*\u003cbr\u003e\u003cbr\u003e■素敵な本家様\u003cbr\u003e『brilliant』/niki様\u003cbr\u003e・\u003ca href=\"https://www.youtube.com/watch?v=RboUC86iVWw\" target=\"_blank\"\u003ehttps://www.youtube.com/watch?v=RboUC86iVWw\u003c/a\u003e\u003cbr\u003e・\u003ca href=\"https://www.nicovideo.jp/watch/sm30024921\" target=\"_blank\"\u003ehttps://www.nicovideo.jp/watch/sm30024921\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■MIX\u003cbr\u003e淳様（＠jun40am）\u003cbr\u003e\u003ca href=\"https://twitter.com/jun40am\" target=\"_blank\"\u003ehttps://twitter.com/jun40am\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Illust\u003cbr\u003eミュシャ様（@misa_chainchroA）\u003cbr\u003e\u003ca href=\"https://twitter.com/misa_chainchroA\" target=\"_blank\"\u003ehttps://twitter.com/misa_chainchroA\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Movie\u003cbr\u003eREO様（@reo_tryall）\u003cbr\u003e\u003ca href=\"https://twitter.com/reo_tryall\" target=\"_blank\"\u003ehttps://twitter.com/reo_tryall\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e■Vocal\u003cbr\u003e常闇トワ（@tokoyamitowa）\u003cbr\u003e\u003ca href=\"https://twitter.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://twitter.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*\u003cbr\u003e\u003cbr\u003eホロライブ4期生の常闇トワ(Tokoyami Towa)様です💛👾\u003cbr\u003eTwitter：\u003ca href=\"https://twitter.com/tokoyamitowa\" target=\"_blank\"\u003ehttps://twitter.com/tokoyamitowa\u003c/a\u003e\u003cbr\u003e毎日大体9時配信＆21時or22時配信の予定です✨ ✨ \u003cbr\u003eFPSやいろいろなゲームが大好き🎮\u003cbr\u003e\u003cbr\u003e○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*\u003cbr\u003e\u003cbr\u003e【ファンアート】#TOWART\u003cbr\u003e【生放送関連】：#トワイライヴ\u003cbr\u003e【ファンネーム】：#常闇眷属\u003cbr\u003e【推し絵文字】：👾\u003cbr\u003e※ファンアートは使用させていただくことがあります！\u003cbr\u003e\u003cbr\u003e○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*\u003cbr\u003e\u003cbr\u003e✡お手紙・プレゼントの宛先✡\u003cbr\u003e〒173-0003\u003cbr\u003e東京都板橋区加賀1丁目6番1号ネットデポ新板橋\u003cbr\u003eカバー株式会社 ホロライブ プレゼント係分\u003cbr\u003e常闇トワ宛\u003cbr\u003e\u003cbr\u003e【注意事項】\u003ca href=\"https://www.hololive.tv/contact\" target=\"_blank\"\u003ehttps://www.hololive.tv/contact\u003c/a\u003e\u003cbr\u003e\u003cbr\u003e○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*○o｡+..:*\u003cbr\u003e\u003cbr\u003e◆ホロライブプロダクション\u003cbr\u003e👾公式サイト👾\u003cbr\u003e\u003ca href=\"https://www.hololive.tv/\" target=\"_blank\"\u003ehttps://www.hololive.tv/\u003c/a\u003e\u003cbr\u003e👾公式Twitter👾\u003cbr\u003e\u003ca href=\"https://twitter.com/hololivetv\" target=\"_blank\"\u003ehttps://twitter.com/hololivetv\u003c/a\u003e\u003cbr\u003e👾公式チャンネル👾\u003cbr\u003e\u003ca href=\"https://www.youtube.com/channel/UCJFZ...\" target=\"_blank\"\u003ehttps://www.youtube.com/channel/UCJFZ...\u003c/a\u003e",
        "en": "",
        "kr": ""
      },
      "thumbnailUrl": "https://i.ytimg.com/vi/2D0B3wTjE20/maxresdefault.jpg",
      "publishedAt": "2020-04-03T12:30:16Z"
    }
  ]
}
